(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("throttle-debounce"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "throttle-debounce"], factory);
	else if(typeof exports === 'object')
		exports["EmojiPicker"] = factory(require("react"), require("throttle-debounce"));
	else
		root["EmojiPicker"] = factory(root["react"], root["throttle-debounce"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_58__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 60);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.skinTones = exports.keywords = exports.modifiers = exports.categories = exports.emojis = undefined;

var _data = __webpack_require__(110);

exports.emojis = _data.emojis;
exports.categories = _data.categories;
exports.modifiers = _data.modifiers;
exports.keywords = _data.keywords;
exports.skinTones = _data.skinTones;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(113);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(105)(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(108)();
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var core = __webpack_require__(0);
var ctx = __webpack_require__(45);
var hide = __webpack_require__(11);
var has = __webpack_require__(10);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(18);
var IE8_DOM_DEFINE = __webpack_require__(46);
var toPrimitive = __webpack_require__(30);
var dP = Object.defineProperty;

exports.f = __webpack_require__(9) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(13)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 10 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(8);
var createDesc = __webpack_require__(25);
module.exports = __webpack_require__(9) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(49);
var defined = __webpack_require__(31);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(70), __esModule: true };

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(34)('wks');
var uid = __webpack_require__(27);
var Symbol = __webpack_require__(7).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KEYWORDS_SINGLE = exports.ALL_KEYWORDS = exports.DEFAULT_IMAGE_RESOLUTION = exports.DEFAULT_CDN_PATH = exports.FILTER_UPDATE_DEBOUNCE = exports.HIDE_SCROLL_DEBOUNCE = exports.OPEN_DIVERSITIES_TIMEOUT = exports.MIN_SCROLLBAR_HEIGHT_PADDED = undefined;

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

var _emojiData = __webpack_require__(1);

var _init_keywords_single = __webpack_require__(120);

var _init_keywords_single2 = _interopRequireDefault(_init_keywords_single);

var _base = __webpack_require__(121);

var scss = _interopRequireWildcard(_base);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars

// view
var MIN_SCROLLBAR_HEIGHT_PADDED = exports.MIN_SCROLLBAR_HEIGHT_PADDED = 15;

// timers
var OPEN_DIVERSITIES_TIMEOUT = exports.OPEN_DIVERSITIES_TIMEOUT = 1000;
var HIDE_SCROLL_DEBOUNCE = exports.HIDE_SCROLL_DEBOUNCE = 550;
var FILTER_UPDATE_DEBOUNCE = exports.FILTER_UPDATE_DEBOUNCE = 200;

// images
var DEFAULT_CDN_PATH = exports.DEFAULT_CDN_PATH = 'https://cdn.jsdelivr.net/emojione/assets/3.0/png';
var DEFAULT_IMAGE_RESOLUTION = exports.DEFAULT_IMAGE_RESOLUTION = '32';

// keywords
var ALL_KEYWORDS = exports.ALL_KEYWORDS = (0, _keys2.default)(_emojiData.keywords);
var KEYWORDS_SINGLE = exports.KEYWORDS_SINGLE = _init_keywords_single2.default;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(48);
var enumBugKeys = __webpack_require__(35);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(72), __esModule: true };

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(74);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(53);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(98);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(102);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(53);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 27 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(31);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(12);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(34)('keys');
var uid = __webpack_require__(27);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(0);
var global = __webpack_require__(7);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(26) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 35 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 36 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(18);
var dPs = __webpack_require__(82);
var enumBugKeys = __webpack_require__(35);
var IE_PROTO = __webpack_require__(33)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(47)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(83).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(8).f;
var has = __webpack_require__(10);
var TAG = __webpack_require__(16)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(16);


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var core = __webpack_require__(0);
var LIBRARY = __webpack_require__(26);
var wksExt = __webpack_require__(40);
var defineProperty = __webpack_require__(8).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (emoji) {

    if (!emoji) {
        return;
    }

    var emojiObject = {
        name: emoji.n,
        unified: emoji.u,
        order: emoji.o,
        category: _.categories[emoji.c].name
    };

    if (emoji.d) {
        emojiObject.diversities = emoji.d;
    }

    return emojiObject;
};

var _ = __webpack_require__(1);

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(63), __esModule: true };

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(65);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(9) && !__webpack_require__(13)(function () {
  return Object.defineProperty(__webpack_require__(47)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
var document = __webpack_require__(7).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(10);
var toIObject = __webpack_require__(14);
var arrayIndexOf = __webpack_require__(67)(false);
var IE_PROTO = __webpack_require__(33)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(50);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 50 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(6);
var core = __webpack_require__(0);
var fails = __webpack_require__(13);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(10);
var toObject = __webpack_require__(29);
var IE_PROTO = __webpack_require__(33)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(77);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(88);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(26);
var $export = __webpack_require__(6);
var redefine = __webpack_require__(55);
var hide = __webpack_require__(11);
var Iterators = __webpack_require__(37);
var $iterCreate = __webpack_require__(81);
var setToStringTag = __webpack_require__(39);
var getPrototypeOf = __webpack_require__(52);
var ITERATOR = __webpack_require__(16)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(11);


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(48);
var hiddenKeys = __webpack_require__(35).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(28);
var createDesc = __webpack_require__(25);
var toIObject = __webpack_require__(14);
var toPrimitive = __webpack_require__(30);
var has = __webpack_require__(10);
var IE8_DOM_DEFINE = __webpack_require__(46);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(9) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_58__;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.unifiedWithModifier = exports.bgImage = undefined;

var _bg_image = __webpack_require__(119);

var _bg_image2 = _interopRequireDefault(_bg_image);

var _unified_with_modifier = __webpack_require__(123);

var _unified_with_modifier2 = _interopRequireDefault(_unified_with_modifier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.bgImage = _bg_image2.default;
exports.unifiedWithModifier = _unified_with_modifier2.default;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EmojiPicker = __webpack_require__(61);

var _EmojiPicker2 = _interopRequireDefault(_EmojiPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _EmojiPicker2.default;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(62);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(44);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(20);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(23);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(24);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SkinTones = __webpack_require__(109);

var _SkinTones2 = _interopRequireDefault(_SkinTones);

var _emojiData = __webpack_require__(1);

var _CategoriesNav = __webpack_require__(114);

var _CategoriesNav2 = _interopRequireDefault(_CategoriesNav);

var _WrapperSection = __webpack_require__(117);

var _WrapperSection2 = _interopRequireDefault(_WrapperSection);

var _SearchBar = __webpack_require__(150);

var _SearchBar2 = _interopRequireDefault(_SearchBar);

__webpack_require__(158);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASSNAME_CATEGORY_INDEX = 1;
var CLASSNAME_MODIFIER_INDEX = 2;

var EmojiPicker = function (_Component) {
    (0, _inherits3.default)(EmojiPicker, _Component);

    function EmojiPicker(props) {
        (0, _classCallCheck3.default)(this, EmojiPicker);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EmojiPicker.__proto__ || (0, _getPrototypeOf2.default)(EmojiPicker)).call(this, props));

        _this.state = {
            filter: null,
            modifier: null,
            activeModifier: null,
            seenCategories: {
                0: true
            },
            seenInSearch: {},
            modifiersSpread: false
        };

        _this.transformed = [];
        _this.pickerClassNames = ['emoji-picker', '', ''];
        _this.onCategoryClick = _this.onCategoryClick.bind(_this);
        _this.onEmojiClick = _this.onEmojiClick.bind(_this);
        _this.onSearch = _this.onSearch.bind(_this);
        _this.onModifierClick = _this.onModifierClick.bind(_this);
        _this.suppressModifiers = _this.suppressModifiers.bind(_this);
        _this.setSeenCategory = _this.setSeenCategory.bind(_this);
        _this.openDiversitiesMenu = _this.openDiversitiesMenu.bind(_this);
        _this.closeDiversitiesMenu = _this.closeDiversitiesMenu.bind(_this);
        _this.setActiveCategory = _this.setActiveCategory.bind(_this);
        _this.setSeenInSearch = _this.setSeenInSearch.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(EmojiPicker, [{
        key: 'getChildContext',
        value: function getChildContext() {
            var _props = this.props,
                assetPath = _props.assetPath,
                emojiResolution = _props.emojiResolution,
                disableDiversityPicker = _props.disableDiversityPicker,
                customCategoryNames = _props.customCategoryNames;
            var activeModifier = this.state.activeModifier;
            var openDiversitiesMenu = this.openDiversitiesMenu;

            return { onEmojiClick: this.onEmojiClick, parent: this, assetPath: assetPath, activeModifier: activeModifier, emojiResolution: emojiResolution, openDiversitiesMenu: openDiversitiesMenu, disableDiversityPicker: disableDiversityPicker, customCategoryNames: customCategoryNames };
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setActiveCategory({ index: 0 });
        }
    }, {
        key: 'setPickerClassname',
        value: function setPickerClassname(index) {
            var nextValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            this.pickerClassNames[index] = nextValue;
            this._picker.setAttribute('class', this.pickerClassNames.join(' '));
        }
    }, {
        key: 'setActiveCategory',
        value: function setActiveCategory(_ref) {
            var index = _ref.index;


            if (!_emojiData.categories[index]) {
                return;
            }

            if (this.state.filter) {
                return;
            }

            var indexPresent = typeof index === 'number',
                prevActive = this.state.activeCategory;

            if (index === prevActive) {
                return;
            }

            if (!indexPresent) {
                index = 0;
            }

            this.setPickerClassname(CLASSNAME_CATEGORY_INDEX, _emojiData.categories[index].name);
            this.setState({ activeCategory: index });
        }
    }, {
        key: 'unsetActiveCategory',
        value: function unsetActiveCategory() {
            this.setPickerClassname(CLASSNAME_CATEGORY_INDEX);
        }
    }, {
        key: 'setSeenCategory',
        value: function setSeenCategory(index, categories) {

            var seenCategories = (0, _assign2.default)({}, this.state.seenCategories, categories);
            seenCategories[index] = true;

            if ((0, _keys2.default)(this.state.seenCategories).length === (0, _keys2.default)(seenCategories).length) {
                return;
            }

            this.setState({ seenCategories: seenCategories });
        }
    }, {
        key: 'setSeenInSearch',
        value: function setSeenInSearch(categories) {
            var seenInSearch = (0, _extends3.default)({}, this.state.seenInSearch);
            var counter = 0;

            for (var catIndex in categories) {

                if (this.state.seenCategories[catIndex] || this.state.seenInSearch[catIndex]) {
                    continue;
                }

                if (categories.hasOwnProperty(catIndex)) {
                    counter++;
                    seenInSearch[catIndex] = true;
                }
            }

            counter && this.setState({ seenInSearch: seenInSearch });
        }
    }, {
        key: 'onCategoryClick',
        value: function onCategoryClick(e, index) {
            e && e.preventDefault();
            this.setState({ delayedCategory: index });
            this.setSeenCategory(index);
            this._wrapperSection.scrollToCategoryByIndex(index);
        }
    }, {
        key: 'onSearch',
        value: function onSearch(filter) {
            var _this2 = this;

            this.setState({ filter: filter }, function () {
                _this2._wrapperSection.scrollTop();
                if (!filter) {
                    return _this2.setActiveCategory(0);
                }
                _this2._wrapperSection.onScroll();
                _this2.unsetActiveCategory();
            });
        }
    }, {
        key: 'onModifierClick',
        value: function onModifierClick(e, modifier) {
            e.preventDefault();

            if (!this.state.modifiersSpread) {
                this._picker.addEventListener('mousedown', this.suppressModifiers);
                return this.setState({ modifiersSpread: true });
            }

            if (modifier === this.state.activeModifier) {
                modifier = null;
            }

            this.setPickerClassname(CLASSNAME_MODIFIER_INDEX, modifier);
            this.setState({ activeModifier: modifier, modifiersSpread: false });
        }
    }, {
        key: 'suppressModifiers',
        value: function suppressModifiers(e) {
            if (!this.state.modifiersSpread) {
                return;
            }
            this._picker.removeEventListener('mousedown', this.suppressModifiers);

            if (e && e.target.classList.contains('st')) {
                return;
            }

            this.setState({ modifiersSpread: false });
        }
    }, {
        key: 'openDiversitiesMenu',
        value: function openDiversitiesMenu(name) {

            this._picker.addEventListener('mousedown', this.closeDiversitiesMenu);
            this.setState({
                diversityPicker: name
            });
        }
    }, {
        key: 'closeDiversitiesMenu',
        value: function closeDiversitiesMenu(e) {
            if (!this.state.diversityPicker) {
                return;
            }
            var pickerClass = 'diversity-picker';

            if (e && (e.target.classList.contains(pickerClass) || e.target.parentElement.classList.contains(pickerClass))) {
                return;
            }

            this._picker.removeEventListener('mousedown', this.closeDiversitiesMenu);

            this.setState({
                diversityPicker: null
            });
        }
    }, {
        key: 'onEmojiClick',
        value: function onEmojiClick(unified, emoji, e) {
            var _this3 = this;

            e.preventDefault();

            var usedModifiers = _emojiData.modifiers.filter(function (modifier) {
                return unified.indexOf(modifier) > -1;
            });

            if (usedModifiers.length) {
                var name = emoji.name + '::' + _emojiData.skinTones[usedModifiers[0]];
                return this.props.onEmojiClick(unified, (0, _assign2.default)({}, emoji, {
                    name: name || emoji.name
                }), e);
            } else if (this.state.activeModifier && emoji.hasOwnProperty('diversities')) {
                var modifier = emoji.diversities.filter(function (diversity) {
                    return diversity.indexOf(_this3.state.activeModifier) > -1;
                });

                if (modifier.length) {
                    var _name = emoji.name + '::' + _emojiData.skinTones[this.state.activeModifier];
                    return this.props.onEmojiClick(modifier[0], (0, _assign2.default)({}, emoji, {
                        name: _name || emoji.name
                    }), e);
                }
            }

            return this.props.onEmojiClick(unified, emoji, e);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var preload = this.props.preload;

            var visibleCategories = (0, _assign2.default)({}, this.state.seenCategories, this.state.seenInSearch);

            return _react2.default.createElement(
                'aside',
                { className: this.pickerClassNames.join(' '),
                    ref: function ref(picker) {
                        return _this4._picker = picker;
                    } },
                _react2.default.createElement(_CategoriesNav2.default, { onClick: this.onCategoryClick }),
                _react2.default.createElement(
                    'div',
                    { className: 'bar-wrapper' },
                    _react2.default.createElement(_SkinTones2.default, { onModifierClick: this.onModifierClick,
                        activeModifier: this.state.activeModifier,
                        spread: this.state.modifiersSpread }),
                    _react2.default.createElement(_SearchBar2.default, { onChange: this.onSearch })
                ),
                _react2.default.createElement(_WrapperSection2.default, { filter: this.state.filter,
                    diversityPicker: this.state.diversityPicker,
                    closeDiversitiesMenu: this.closeDiversitiesMenu,
                    visibleCategories: visibleCategories,
                    modifiersSpread: this.state.modifiersSpread,
                    ref: function ref(_ref2) {
                        return _this4._wrapperSection = _ref2;
                    },
                    setSeenCategory: this.setSeenCategory,
                    suppressModifiers: this.suppressModifiers,
                    setActiveCategory: this.setActiveCategory,
                    setSeenInSearch: this.setSeenInSearch,
                    activeCategory: this.state.activeCategory,
                    delayedCategory: this.state.delayedCategory,
                    preload: preload })
            );
        }
    }]);
    return EmojiPicker;
}(_react.Component);

EmojiPicker.propTypes = {
    onEmojiClick: _propTypes2.default.func.isRequired,
    assetPath: _propTypes2.default.string,
    emojiResolution: _propTypes2.default.number,
    preload: _propTypes2.default.bool,
    customCategoryNames: _propTypes2.default.object,
    disableDiversityPicker: _propTypes2.default.bool
};

EmojiPicker.childContextTypes = {
    customCategoryNames: _propTypes2.default.object,
    onEmojiClick: _propTypes2.default.func,
    parent: _propTypes2.default.instanceOf(EmojiPicker),
    assetPath: _propTypes2.default.string,
    activeModifier: _propTypes2.default.string,
    emojiResolution: _propTypes2.default.number,
    openDiversitiesMenu: _propTypes2.default.func,
    disableDiversityPicker: _propTypes2.default.bool
};

exports.default = EmojiPicker;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(44);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(64);
module.exports = __webpack_require__(0).Object.assign;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(6);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(66) });


/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(19);
var gOPS = __webpack_require__(36);
var pIE = __webpack_require__(28);
var toObject = __webpack_require__(29);
var IObject = __webpack_require__(49);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(13)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(14);
var toLength = __webpack_require__(68);
var toAbsoluteIndex = __webpack_require__(69);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(32);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(32);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(71);
module.exports = __webpack_require__(0).Object.keys;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(29);
var $keys = __webpack_require__(19);

__webpack_require__(51)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(73);
module.exports = __webpack_require__(0).Object.getPrototypeOf;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(29);
var $getPrototypeOf = __webpack_require__(52);

__webpack_require__(51)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(75), __esModule: true };

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(76);
var $Object = __webpack_require__(0).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(9), 'Object', { defineProperty: __webpack_require__(8).f });


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(78), __esModule: true };

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(79);
__webpack_require__(84);
module.exports = __webpack_require__(40).f('iterator');


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(80)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(54)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(32);
var defined = __webpack_require__(31);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(38);
var descriptor = __webpack_require__(25);
var setToStringTag = __webpack_require__(39);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(11)(IteratorPrototype, __webpack_require__(16)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(8);
var anObject = __webpack_require__(18);
var getKeys = __webpack_require__(19);

module.exports = __webpack_require__(9) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(7).document;
module.exports = document && document.documentElement;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(85);
var global = __webpack_require__(7);
var hide = __webpack_require__(11);
var Iterators = __webpack_require__(37);
var TO_STRING_TAG = __webpack_require__(16)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(86);
var step = __webpack_require__(87);
var Iterators = __webpack_require__(37);
var toIObject = __webpack_require__(14);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(54)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(89), __esModule: true };

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(90);
__webpack_require__(95);
__webpack_require__(96);
__webpack_require__(97);
module.exports = __webpack_require__(0).Symbol;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(7);
var has = __webpack_require__(10);
var DESCRIPTORS = __webpack_require__(9);
var $export = __webpack_require__(6);
var redefine = __webpack_require__(55);
var META = __webpack_require__(91).KEY;
var $fails = __webpack_require__(13);
var shared = __webpack_require__(34);
var setToStringTag = __webpack_require__(39);
var uid = __webpack_require__(27);
var wks = __webpack_require__(16);
var wksExt = __webpack_require__(40);
var wksDefine = __webpack_require__(41);
var enumKeys = __webpack_require__(92);
var isArray = __webpack_require__(93);
var anObject = __webpack_require__(18);
var isObject = __webpack_require__(12);
var toIObject = __webpack_require__(14);
var toPrimitive = __webpack_require__(30);
var createDesc = __webpack_require__(25);
var _create = __webpack_require__(38);
var gOPNExt = __webpack_require__(94);
var $GOPD = __webpack_require__(57);
var $DP = __webpack_require__(8);
var $keys = __webpack_require__(19);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(56).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(28).f = $propertyIsEnumerable;
  __webpack_require__(36).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(26)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(11)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(27)('meta');
var isObject = __webpack_require__(12);
var has = __webpack_require__(10);
var setDesc = __webpack_require__(8).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(13)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(19);
var gOPS = __webpack_require__(36);
var pIE = __webpack_require__(28);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(50);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(14);
var gOPN = __webpack_require__(56).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 95 */
/***/ (function(module, exports) {



/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(41)('asyncIterator');


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(41)('observable');


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(99), __esModule: true };

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100);
module.exports = __webpack_require__(0).Object.setPrototypeOf;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(6);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(101).set });


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(12);
var anObject = __webpack_require__(18);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(45)(Function.call, __webpack_require__(57).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(103), __esModule: true };

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(104);
var $Object = __webpack_require__(0).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(38) });


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var assign = __webpack_require__(106);

var ReactPropTypesSecret = __webpack_require__(42);
var checkPropTypes = __webpack_require__(107);

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = __webpack_require__(42);
  var loggedTypeFailures = {};

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          )

        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(42);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _emojiData = __webpack_require__(1);

__webpack_require__(111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NEUT = 'neutral';

function SkinTones(_ref) {
    var onModifierClick = _ref.onModifierClick,
        activeModifier = _ref.activeModifier,
        spread = _ref.spread;


    var spreadClass = spread ? ' spread' : '';

    return _react2.default.createElement(
        'ul',
        { className: 'skin-tones' + spreadClass },
        _emojiData.modifiers.map(function (modifier, index) {

            var isNeutral = modifier === NEUT,
                isSelected = activeModifier === modifier || !activeModifier && isNeutral,
                selectedClass = isSelected ? ' selected' : '',
                modifierClass = '' + (isNeutral ? '' : 'm') + modifier + selectedClass;

            var style = {};

            if (spread) {
                if (isSelected) {
                    style.transform = 'translateX(' + -index * 20 + 'px) scale(1.5)';
                } else {
                    style.transform = 'translateX(' + -index * 20 + 'px)';
                }
            }

            return _react2.default.createElement(
                'li',
                { className: modifierClass, style: style, key: modifier },
                _react2.default.createElement('a', { className: 'st', onClick: function onClick(e) {
                        return onModifierClick(e, modifier);
                    } })
            );
        })
    );
}

SkinTones.propTypes = {
    onModifierClick: _propTypes2.default.func.isRequired,
    activeModifier: _propTypes2.default.string,
    spread: _propTypes2.default.bool
};

exports.default = SkinTones;

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = {"emojis":{"0":{"n":"copyright","u":"00a9","o":197,"c":7},"1":{"n":"registered","u":"00ae","o":198,"c":7},"2":{"n":"bangbang","u":"203c","o":89,"c":7},"3":{"n":"interrobang","u":"2049","o":90,"c":7},"4":{"n":"tm","u":"2122","o":196,"c":7},"5":{"n":"information_source","u":"2139","o":130,"c":7},"6":{"n":"left_right_arrow","u":"2194","o":178,"c":7},"7":{"n":"arrow_up_down","u":"2195","o":177,"c":7},"8":{"n":"arrow_upper_left","u":"2196","o":176,"c":7},"9":{"n":"arrow_upper_right","u":"2197","o":173,"c":7},"10":{"n":"arrow_lower_right","u":"2198","o":174,"c":7},"11":{"n":"arrow_lower_left","u":"2199","o":175,"c":7},"12":{"n":"leftwards_arrow_with_hook","u":"21a9","o":180,"c":7},"13":{"n":"arrow_right_hook","u":"21aa","o":179,"c":7},"14":{"n":"watch","u":"231a","o":1,"c":4},"15":{"n":"hourglass","u":"231b","o":36,"c":4},"16":{"n":"keyboard","u":"2328","o":5,"c":4},"17":{"n":"eject","u":"23cf","o":158,"c":7},"18":{"n":"fast_forward","u":"23e9","o":162,"c":7},"19":{"n":"rewind","u":"23ea","o":163,"c":7},"20":{"n":"arrow_double_up","u":"23eb","o":164,"c":7},"21":{"n":"arrow_double_down","u":"23ec","o":165,"c":7},"22":{"n":"black_right_pointing_double_triangle_with_vertical_bar","u":"23ed","o":160,"c":7},"23":{"n":"black_left_pointing_double_triangle_with_vertical_bar","u":"23ee","o":161,"c":7},"24":{"n":"black_right_pointing_triangle_with_double_vertical_bar","u":"23ef","o":156,"c":7},"25":{"n":"alarm_clock","u":"23f0","o":34,"c":4},"26":{"n":"stopwatch","u":"23f1","o":32,"c":4},"27":{"n":"timer_clock","u":"23f2","o":33,"c":4},"28":{"n":"hourglass_flowing_sand","u":"23f3","o":37,"c":4},"29":{"n":"double_vertical_bar","u":"23f8","o":155,"c":7},"30":{"n":"black_square_for_stop","u":"23f9","o":157,"c":7},"31":{"n":"black_circle_for_record","u":"23fa","o":159,"c":7},"32":{"n":"m","u":"24c2","o":108,"c":7},"33":{"n":"black_small_square","u":"25aa","o":222,"c":7},"34":{"n":"white_small_square","u":"25ab","o":223,"c":7},"35":{"n":"arrow_forward","u":"25b6","o":154,"c":7},"36":{"n":"arrow_backward","u":"25c0","o":166,"c":7},"37":{"n":"white_medium_square","u":"25fb","o":227,"c":7},"38":{"n":"black_medium_square","u":"25fc","o":226,"c":7},"39":{"n":"white_medium_small_square","u":"25fd","o":225,"c":7},"40":{"n":"black_medium_small_square","u":"25fe","o":224,"c":7},"41":{"n":"sunny","u":"2600","o":138,"c":2},"42":{"n":"cloud","u":"2601","o":144,"c":2},"43":{"n":"umbrella","u":"2602","o":293,"c":0},"44":{"n":"snowman","u":"2603","o":149,"c":2},"45":{"n":"comet","u":"2604","o":137,"c":2},"46":{"n":"phone","u":"260e","o":24,"c":4},"47":{"n":"ballot_box_with_check","u":"2611","o":208,"c":7},"48":{"n":"umbrella_with_rain_drops","u":"2614","o":159,"c":2},"49":{"n":"coffee","u":"2615","o":73,"c":1},"50":{"n":"shamrock","u":"2618","o":96,"c":2},"51":{"n":"point_up","u":"261d","o":116,"c":0,"d":["261d-1f3fb","261d-1f3fc","261d-1f3fd","261d-1f3fe","261d-1f3ff"]},"52":{"n":"skull_and_crossbones","u":"2620","o":83,"c":0},"53":{"n":"radioactive_sign","u":"2622","o":44,"c":7},"54":{"n":"biohazard_sign","u":"2623","o":45,"c":7},"55":{"n":"orthodox_cross","u":"2626","o":26,"c":7},"56":{"n":"star_and_crescent","u":"262a","o":19,"c":7},"57":{"n":"peace_symbol","u":"262e","o":17,"c":7},"58":{"n":"yin_yang","u":"262f","o":25,"c":7},"59":{"n":"wheel_of_dharma","u":"2638","o":21,"c":7},"60":{"n":"white_frowning_face","u":"2639","o":38,"c":0},"61":{"n":"relaxed","u":"263a","o":9,"c":0},"64":{"n":"aries","u":"2648","o":29,"c":7},"65":{"n":"taurus","u":"2649","o":30,"c":7},"66":{"n":"gemini","u":"264a","o":31,"c":7},"67":{"n":"cancer","u":"264b","o":32,"c":7},"68":{"n":"leo","u":"264c","o":33,"c":7},"69":{"n":"virgo","u":"264d","o":34,"c":7},"70":{"n":"libra","u":"264e","o":35,"c":7},"71":{"n":"scorpius","u":"264f","o":36,"c":7},"72":{"n":"sagittarius","u":"2650","o":37,"c":7},"73":{"n":"capricorn","u":"2651","o":38,"c":7},"74":{"n":"aquarius","u":"2652","o":39,"c":7},"75":{"n":"pisces","u":"2653","o":40,"c":7},"76":{"n":"spades","u":"2660","o":243,"c":7},"77":{"n":"clubs","u":"2663","o":244,"c":7},"78":{"n":"hearts","u":"2665","o":245,"c":7},"79":{"n":"diamonds","u":"2666","o":246,"c":7},"80":{"n":"hotsprings","u":"2668","o":77,"c":7},"81":{"n":"recycle","u":"267b","o":99,"c":7},"82":{"n":"wheelchair","u":"267f","o":113,"c":7},"83":{"n":"hammer_and_pick","u":"2692","o":57,"c":4},"84":{"n":"anchor","u":"2693","o":53,"c":5},"85":{"n":"crossed_swords","u":"2694","o":67,"c":4},"87":{"n":"scales","u":"2696","o":54,"c":4},"88":{"n":"alembic","u":"2697","o":76,"c":4},"89":{"n":"gear","u":"2699","o":61,"c":4},"90":{"n":"atom_symbol","u":"269b","o":42,"c":7},"91":{"n":"fleur_de_lis","u":"269c","o":97,"c":7},"92":{"n":"warning","u":"26a0","o":94,"c":7},"93":{"n":"zap","u":"26a1","o":134,"c":2},"94":{"n":"white_circle","u":"26aa","o":210,"c":7},"95":{"n":"black_circle","u":"26ab","o":211,"c":7},"96":{"n":"coffin","u":"26b0","o":70,"c":4},"97":{"n":"funeral_urn","u":"26b1","o":71,"c":4},"98":{"n":"soccer","u":"26bd","o":1,"c":3},"99":{"n":"baseball","u":"26be","o":4,"c":3},"100":{"n":"snowman_without_snow","u":"26c4","o":150,"c":2},"101":{"n":"partly_sunny","u":"26c5","o":140,"c":2},"102":{"n":"thunder_cloud_and_rain","u":"26c8","o":146,"c":2},"103":{"n":"ophiuchus","u":"26ce","o":28,"c":7},"104":{"n":"pick","u":"26cf","o":59,"c":4},"105":{"n":"helmet_with_white_cross","u":"26d1","o":284,"c":0},"106":{"n":"chains","u":"26d3","o":62,"c":4},"107":{"n":"no_entry","u":"26d4","o":72,"c":7},"108":{"n":"shinto_shrine","u":"26e9","o":104,"c":5},"109":{"n":"church","u":"26ea","o":100,"c":5},"110":{"n":"mountain","u":"26f0","o":73,"c":5},"111":{"n":"umbrella_on_ground","u":"26f1","o":70,"c":5},"112":{"n":"fountain","u":"26f2","o":62,"c":5},"113":{"n":"golf","u":"26f3","o":15,"c":3},"114":{"n":"ferry","u":"26f4","o":51,"c":5},"115":{"n":"boat","u":"26f5","o":47,"c":5},"116":{"n":"skier","u":"26f7","o":22,"c":3},"117":{"n":"ice_skate","u":"26f8","o":20,"c":3},"118":{"n":"person_with_ball","u":"26f9","o":34,"c":3,"d":["26f9-1f3fb","26f9-1f3fc","26f9-1f3fd","26f9-1f3fe","26f9-1f3ff"]},"119":{"n":"tent","u":"26fa","o":79,"c":5},"120":{"n":"fuelpump","u":"26fd","o":55,"c":5},"121":{"n":"scissors","u":"2702","o":160,"c":4},"122":{"n":"white_check_mark","u":"2705","o":100,"c":7},"123":{"n":"airplane","u":"2708","o":40,"c":5},"124":{"n":"email","u":"2709","o":107,"c":4},"125":{"n":"fist","u":"270a","o":105,"c":0,"d":["270a-1f3fb","270a-1f3fc","270a-1f3fd","270a-1f3fe","270a-1f3ff"]},"126":{"n":"hand","u":"270b","o":117,"c":0,"d":["270b-1f3fb","270b-1f3fc","270b-1f3fd","270b-1f3fe","270b-1f3ff"]},"127":{"n":"v","u":"270c","o":109,"c":0,"d":["270c-1f3fb","270c-1f3fc","270c-1f3fd","270c-1f3fe","270c-1f3ff"]},"128":{"n":"writing_hand","u":"270d","o":125,"c":0,"d":["270d-1f3fb","270d-1f3fc","270d-1f3fd","270d-1f3fe","270d-1f3ff"]},"129":{"n":"pencil2","u":"270f","o":167,"c":4},"130":{"n":"black_nib","u":"2712","o":163,"c":4},"131":{"n":"heavy_check_mark","u":"2714","o":207,"c":7},"132":{"n":"heavy_multiplication_x","u":"2716","o":193,"c":7},"133":{"n":"latin_cross","u":"271d","o":18,"c":7},"134":{"n":"star_of_david","u":"2721","o":22,"c":7},"135":{"n":"sparkles","u":"2728","o":133,"c":2},"136":{"n":"eight_spoked_asterisk","u":"2733","o":104,"c":7},"137":{"n":"eight_pointed_black_star","u":"2734","o":53,"c":7},"138":{"n":"snowflake","u":"2744","o":151,"c":2},"139":{"n":"sparkle","u":"2747","o":103,"c":7},"140":{"n":"x","u":"274c","o":69,"c":7},"141":{"n":"negative_squared_cross_mark","u":"274e","o":105,"c":7},"142":{"n":"question","u":"2753","o":87,"c":7},"143":{"n":"grey_question","u":"2754","o":88,"c":7},"144":{"n":"grey_exclamation","u":"2755","o":86,"c":7},"145":{"n":"exclamation","u":"2757","o":85,"c":7},"146":{"n":"heavy_heart_exclamation_mark_ornament","u":"2763","o":8,"c":7},"147":{"n":"heart","u":"2764","o":1,"c":7},"148":{"n":"heavy_plus_sign","u":"2795","o":190,"c":7},"149":{"n":"heavy_minus_sign","u":"2796","o":191,"c":7},"150":{"n":"heavy_division_sign","u":"2797","o":192,"c":7},"151":{"n":"arrow_right","u":"27a1","o":169,"c":7},"152":{"n":"curly_loop","u":"27b0","o":200,"c":7},"153":{"n":"loop","u":"27bf","o":201,"c":7},"154":{"n":"arrow_heading_up","u":"2934","o":181,"c":7},"155":{"n":"arrow_heading_down","u":"2935","o":182,"c":7},"156":{"n":"arrow_left","u":"2b05","o":170,"c":7},"157":{"n":"arrow_up","u":"2b06","o":171,"c":7},"158":{"n":"arrow_down","u":"2b07","o":172,"c":7},"159":{"n":"black_large_square","u":"2b1b","o":228,"c":7},"160":{"n":"white_large_square","u":"2b1c","o":229,"c":7},"161":{"n":"star","u":"2b50","o":131,"c":2},"162":{"n":"o","u":"2b55","o":70,"c":7},"163":{"n":"wavy_dash","u":"3030","o":199,"c":7},"164":{"n":"part_alternation_mark","u":"303d","o":93,"c":7},"165":{"n":"congratulations","u":"3297","o":58,"c":7},"166":{"n":"secret","u":"3299","o":57,"c":7},"167":{"n":"mahjong","u":"1f004","o":249,"c":7},"168":{"n":"black_joker","u":"1f0cf","o":247,"c":7},"169":{"n":"a","u":"1f170","o":63,"c":7},"170":{"n":"b","u":"1f171","o":64,"c":7},"171":{"n":"o2","u":"1f17e","o":67,"c":7},"172":{"n":"parking","u":"1f17f","o":114,"c":7},"173":{"n":"ab","u":"1f18e","o":65,"c":7},"174":{"n":"cl","u":"1f191","o":66,"c":7},"175":{"n":"cool","u":"1f192","o":137,"c":7},"176":{"n":"free","u":"1f193","o":139,"c":7},"177":{"n":"id","u":"1f194","o":41,"c":7},"178":{"n":"new","u":"1f195","o":138,"c":7},"179":{"n":"ng","u":"1f196","o":134,"c":7},"180":{"n":"ok","u":"1f197","o":135,"c":7},"181":{"n":"sos","u":"1f198","o":68,"c":7},"182":{"n":"up","u":"1f199","o":136,"c":7},"183":{"n":"vs","u":"1f19a","o":54,"c":7},"184":{"n":"koko","u":"1f201","o":128,"c":7},"185":{"n":"sa","u":"1f202","o":116,"c":7},"186":{"n":"u7121","u":"1f21a","o":49,"c":7},"187":{"n":"u6307","u":"1f22f","o":101,"c":7},"188":{"n":"u7981","u":"1f232","o":62,"c":7},"189":{"n":"u7a7a","u":"1f233","o":115,"c":7},"190":{"n":"u5408","u":"1f234","o":59,"c":7},"191":{"n":"u6e80","u":"1f235","o":60,"c":7},"192":{"n":"u6709","u":"1f236","o":48,"c":7},"193":{"n":"u6708","u":"1f237","o":52,"c":7},"194":{"n":"u7533","u":"1f238","o":50,"c":7},"195":{"n":"u5272","u":"1f239","o":61,"c":7},"196":{"n":"u55b6","u":"1f23a","o":51,"c":7},"197":{"n":"ideograph_advantage","u":"1f250","o":56,"c":7},"198":{"n":"accept","u":"1f251","o":43,"c":7},"199":{"n":"cyclone","u":"1f300","o":109,"c":7},"200":{"n":"foggy","u":"1f301","o":119,"c":5},"201":{"n":"closed_umbrella","u":"1f302","o":292,"c":0},"202":{"n":"night_with_stars","u":"1f303","o":116,"c":5},"203":{"n":"sunrise_over_mountains","u":"1f304","o":109,"c":5},"204":{"n":"sunrise","u":"1f305","o":108,"c":5},"205":{"n":"city_sunset","u":"1f306","o":114,"c":5},"206":{"n":"city_sunrise","u":"1f307","o":113,"c":5},"207":{"n":"rainbow","u":"1f308","o":143,"c":2},"208":{"n":"bridge_at_night","u":"1f309","o":118,"c":5},"209":{"n":"ocean","u":"1f30a","o":156,"c":2},"210":{"n":"volcano","u":"1f30b","o":76,"c":5},"211":{"n":"milky_way","u":"1f30c","o":117,"c":5},"212":{"n":"earth_africa","u":"1f30d","o":114,"c":2},"213":{"n":"earth_americas","u":"1f30e","o":113,"c":2},"214":{"n":"earth_asia","u":"1f30f","o":115,"c":2},"215":{"n":"globe_with_meridians","u":"1f310","o":106,"c":7},"216":{"n":"new_moon","u":"1f311","o":120,"c":2},"217":{"n":"waxing_crescent_moon","u":"1f312","o":121,"c":2},"218":{"n":"first_quarter_moon","u":"1f313","o":122,"c":2},"219":{"n":"moon","u":"1f314","o":123,"c":2},"220":{"n":"full_moon","u":"1f315","o":116,"c":2},"221":{"n":"waning_gibbous_moon","u":"1f316","o":117,"c":2},"222":{"n":"last_quarter_moon","u":"1f317","o":118,"c":2},"223":{"n":"waning_crescent_moon","u":"1f318","o":119,"c":2},"224":{"n":"crescent_moon","u":"1f319","o":129,"c":2},"225":{"n":"new_moon_with_face","u":"1f31a","o":124,"c":2},"226":{"n":"first_quarter_moon_with_face","u":"1f31b","o":127,"c":2},"227":{"n":"last_quarter_moon_with_face","u":"1f31c","o":128,"c":2},"228":{"n":"full_moon_with_face","u":"1f31d","o":125,"c":2},"229":{"n":"sun_with_face","u":"1f31e","o":126,"c":2},"230":{"n":"star2","u":"1f31f","o":132,"c":2},"231":{"n":"stars","u":"1f320","o":110,"c":5},"232":{"n":"thermometer","u":"1f321","o":82,"c":4},"233":{"n":"mostly_sunny","u":"1f324","o":139,"c":2},"234":{"n":"barely_sunny","u":"1f325","o":141,"c":2},"235":{"n":"partly_sunny_rain","u":"1f326","o":142,"c":2},"236":{"n":"rain_cloud","u":"1f327","o":145,"c":2},"237":{"n":"snow_cloud","u":"1f328","o":148,"c":2},"238":{"n":"lightning","u":"1f329","o":147,"c":2},"239":{"n":"tornado","u":"1f32a","o":154,"c":2},"240":{"n":"fog","u":"1f32b","o":155,"c":2},"241":{"n":"wind_blowing_face","u":"1f32c","o":152,"c":2},"242":{"n":"hotdog","u":"1f32d","o":39,"c":1},"243":{"n":"taco","u":"1f32e","o":43,"c":1},"244":{"n":"burrito","u":"1f32f","o":44,"c":1},"245":{"n":"chestnut","u":"1f330","o":24,"c":1},"246":{"n":"seedling","u":"1f331","o":94,"c":2},"247":{"n":"evergreen_tree","u":"1f332","o":91,"c":2},"248":{"n":"deciduous_tree","u":"1f333","o":92,"c":2},"249":{"n":"palm_tree","u":"1f334","o":93,"c":2},"250":{"n":"cactus","u":"1f335","o":89,"c":2},"251":{"n":"hot_pepper","u":"1f336","o":21,"c":1},"252":{"n":"tulip","u":"1f337","o":106,"c":2},"253":{"n":"cherry_blossom","u":"1f338","o":111,"c":2},"254":{"n":"rose","u":"1f339","o":107,"c":2},"255":{"n":"hibiscus","u":"1f33a","o":112,"c":2},"256":{"n":"sunflower","u":"1f33b","o":109,"c":2},"257":{"n":"blossom","u":"1f33c","o":110,"c":2},"258":{"n":"corn","u":"1f33d","o":20,"c":1},"259":{"n":"ear_of_rice","u":"1f33e","o":104,"c":2},"260":{"n":"herb","u":"1f33f","o":95,"c":2},"261":{"n":"four_leaf_clover","u":"1f340","o":97,"c":2},"262":{"n":"maple_leaf","u":"1f341","o":102,"c":2},"263":{"n":"fallen_leaf","u":"1f342","o":101,"c":2},"264":{"n":"leaves","u":"1f343","o":100,"c":2},"265":{"n":"mushroom","u":"1f344","o":103,"c":2},"266":{"n":"tomato","u":"1f345","o":16,"c":1},"267":{"n":"eggplant","u":"1f346","o":17,"c":1},"268":{"n":"grapes","u":"1f347","o":8,"c":1},"269":{"n":"melon","u":"1f348","o":10,"c":1},"270":{"n":"watermelon","u":"1f349","o":7,"c":1},"271":{"n":"tangerine","u":"1f34a","o":4,"c":1},"272":{"n":"lemon","u":"1f34b","o":5,"c":1},"273":{"n":"banana","u":"1f34c","o":6,"c":1},"274":{"n":"pineapple","u":"1f34d","o":13,"c":1},"275":{"n":"apple","u":"1f34e","o":2,"c":1},"276":{"n":"green_apple","u":"1f34f","o":1,"c":1},"277":{"n":"pear","u":"1f350","o":3,"c":1},"278":{"n":"peach","u":"1f351","o":12,"c":1},"279":{"n":"cherries","u":"1f352","o":11,"c":1},"280":{"n":"strawberry","u":"1f353","o":9,"c":1},"281":{"n":"hamburger","u":"1f354","o":40,"c":1},"282":{"n":"pizza","u":"1f355","o":38,"c":1},"283":{"n":"meat_on_bone","u":"1f356","o":37,"c":1},"284":{"n":"poultry_leg","u":"1f357","o":36,"c":1},"285":{"n":"rice_cracker","u":"1f358","o":56,"c":1},"286":{"n":"rice_ball","u":"1f359","o":55,"c":1},"287":{"n":"rice","u":"1f35a","o":54,"c":1},"288":{"n":"curry","u":"1f35b","o":53,"c":1},"289":{"n":"ramen","u":"1f35c","o":48,"c":1},"290":{"n":"spaghetti","u":"1f35d","o":47,"c":1},"291":{"n":"bread","u":"1f35e","o":28,"c":1},"292":{"n":"fries","u":"1f35f","o":41,"c":1},"293":{"n":"sweet_potato","u":"1f360","o":23,"c":1},"294":{"n":"dango","u":"1f361","o":58,"c":1},"295":{"n":"oden","u":"1f362","o":57,"c":1},"296":{"n":"sushi","u":"1f363","o":51,"c":1},"297":{"n":"fried_shrimp","u":"1f364","o":35,"c":1},"298":{"n":"fish_cake","u":"1f365","o":50,"c":1},"299":{"n":"icecream","u":"1f366","o":61,"c":1},"300":{"n":"shaved_ice","u":"1f367","o":59,"c":1},"301":{"n":"ice_cream","u":"1f368","o":60,"c":1},"302":{"n":"doughnut","u":"1f369","o":69,"c":1},"303":{"n":"cookie","u":"1f36a","o":70,"c":1},"304":{"n":"chocolate_bar","u":"1f36b","o":67,"c":1},"305":{"n":"candy","u":"1f36c","o":66,"c":1},"306":{"n":"lollipop","u":"1f36d","o":65,"c":1},"307":{"n":"custard","u":"1f36e","o":64,"c":1},"308":{"n":"honey_pot","u":"1f36f","o":26,"c":1},"309":{"n":"cake","u":"1f370","o":62,"c":1},"310":{"n":"bento","u":"1f371","o":52,"c":1},"311":{"n":"stew","u":"1f372","o":49,"c":1},"312":{"n":"fried_egg","u":"1f373","o":32,"c":1},"313":{"n":"fork_and_knife","u":"1f374","o":85,"c":1},"314":{"n":"tea","u":"1f375","o":74,"c":1},"315":{"n":"sake","u":"1f376","o":75,"c":1},"316":{"n":"wine_glass","u":"1f377","o":79,"c":1},"317":{"n":"cocktail","u":"1f378","o":81,"c":1},"318":{"n":"tropical_drink","u":"1f379","o":82,"c":1},"319":{"n":"beer","u":"1f37a","o":76,"c":1},"320":{"n":"beers","u":"1f37b","o":77,"c":1},"321":{"n":"baby_bottle","u":"1f37c","o":72,"c":1},"322":{"n":"knife_fork_plate","u":"1f37d","o":86,"c":1},"323":{"n":"champagne","u":"1f37e","o":83,"c":1},"324":{"n":"popcorn","u":"1f37f","o":68,"c":1},"325":{"n":"ribbon","u":"1f380","o":101,"c":4},"326":{"n":"gift","u":"1f381","o":98,"c":4},"327":{"n":"birthday","u":"1f382","o":63,"c":1},"328":{"n":"jack_o_lantern","u":"1f383","o":87,"c":0},"329":{"n":"christmas_tree","u":"1f384","o":90,"c":2},"330":{"n":"santa","u":"1f385","o":194,"c":0,"d":["1f385-1f3fb","1f385-1f3fc","1f385-1f3fd","1f385-1f3fe","1f385-1f3ff"]},"331":{"n":"fireworks","u":"1f386","o":112,"c":5},"332":{"n":"sparkler","u":"1f387","o":111,"c":5},"333":{"n":"balloon","u":"1f388","o":99,"c":4},"334":{"n":"tada","u":"1f389","o":103,"c":4},"335":{"n":"confetti_ball","u":"1f38a","o":102,"c":4},"336":{"n":"tanabata_tree","u":"1f38b","o":99,"c":2},"337":{"n":"crossed_flags","u":"1f38c","o":118,"c":6},"338":{"n":"bamboo","u":"1f38d","o":98,"c":2},"339":{"n":"dolls","u":"1f38e","o":104,"c":4},"340":{"n":"flags","u":"1f38f","o":100,"c":4},"341":{"n":"wind_chime","u":"1f390","o":106,"c":4},"342":{"n":"rice_scene","u":"1f391","o":106,"c":5},"343":{"n":"school_satchel","u":"1f392","o":285,"c":0},"344":{"n":"mortar_board","u":"1f393","o":282,"c":0},"345":{"n":"medal","u":"1f396","o":56,"c":3},"346":{"n":"reminder_ribbon","u":"1f397","o":62,"c":3},"347":{"n":"studio_microphone","u":"1f399","o":29,"c":4},"348":{"n":"level_slider","u":"1f39a","o":30,"c":4},"349":{"n":"control_knobs","u":"1f39b","o":31,"c":4},"350":{"n":"film_frames","u":"1f39e","o":22,"c":4},"351":{"n":"admission_tickets","u":"1f39f","o":64,"c":3},"352":{"n":"carousel_horse","u":"1f3a0","o":69,"c":5},"353":{"n":"ferris_wheel","u":"1f3a1","o":67,"c":5},"354":{"n":"roller_coaster","u":"1f3a2","o":68,"c":5},"355":{"n":"fishing_pole_and_fish","u":"1f3a3","o":17,"c":3},"356":{"n":"microphone","u":"1f3a4","o":72,"c":3},"357":{"n":"movie_camera","u":"1f3a5","o":20,"c":4},"358":{"n":"cinema","u":"1f3a6","o":126,"c":7},"359":{"n":"headphones","u":"1f3a7","o":73,"c":3},"360":{"n":"art","u":"1f3a8","o":70,"c":3},"361":{"n":"tophat","u":"1f3a9","o":281,"c":0},"362":{"n":"circus_tent","u":"1f3aa","o":65,"c":3},"363":{"n":"ticket","u":"1f3ab","o":63,"c":3},"364":{"n":"clapper","u":"1f3ac","o":71,"c":3},"365":{"n":"performing_arts","u":"1f3ad","o":69,"c":3},"366":{"n":"video_game","u":"1f3ae","o":84,"c":3},"367":{"n":"dart","u":"1f3af","o":82,"c":3},"368":{"n":"slot_machine","u":"1f3b0","o":85,"c":3},"369":{"n":"8ball","u":"1f3b1","o":8,"c":3},"370":{"n":"game_die","u":"1f3b2","o":81,"c":3},"371":{"n":"bowling","u":"1f3b3","o":83,"c":3},"372":{"n":"flower_playing_cards","u":"1f3b4","o":248,"c":7},"373":{"n":"musical_note","u":"1f3b5","o":188,"c":7},"374":{"n":"notes","u":"1f3b6","o":189,"c":7},"375":{"n":"saxophone","u":"1f3b7","o":77,"c":3},"376":{"n":"guitar","u":"1f3b8","o":79,"c":3},"377":{"n":"musical_keyboard","u":"1f3b9","o":75,"c":3},"378":{"n":"trumpet","u":"1f3ba","o":78,"c":3},"379":{"n":"violin","u":"1f3bb","o":80,"c":3},"380":{"n":"musical_score","u":"1f3bc","o":74,"c":3},"381":{"n":"running_shirt_with_sash","u":"1f3bd","o":54,"c":3},"382":{"n":"tennis","u":"1f3be","o":5,"c":3},"383":{"n":"ski","u":"1f3bf","o":21,"c":3},"384":{"n":"basketball","u":"1f3c0","o":2,"c":3},"385":{"n":"checkered_flag","u":"1f3c1","o":3,"c":6},"386":{"n":"snowboarder","u":"1f3c2","o":23,"c":3},"387":{"n":"runner","u":"1f3c3","o":233,"c":0,"d":["1f3c3-1f3fb","1f3c3-1f3fc","1f3c3-1f3fd","1f3c3-1f3fe","1f3c3-1f3ff"]},"388":{"n":"surfer","u":"1f3c4","o":41,"c":3,"d":["1f3c4-1f3fb","1f3c4-1f3fc","1f3c4-1f3fd","1f3c4-1f3fe","1f3c4-1f3ff"]},"389":{"n":"sports_medal","u":"1f3c5","o":55,"c":3},"390":{"n":"trophy","u":"1f3c6","o":60,"c":3},"391":{"n":"horse_racing","u":"1f3c7","o":49,"c":3,"d":["1f3c7-1f3fb","1f3c7-1f3fc","1f3c7-1f3fd","1f3c7-1f3fe","1f3c7-1f3ff"]},"392":{"n":"football","u":"1f3c8","o":3,"c":3},"393":{"n":"rugby_football","u":"1f3c9","o":7,"c":3},"394":{"n":"swimmer","u":"1f3ca","o":43,"c":3,"d":["1f3ca-1f3fb","1f3ca-1f3fc","1f3ca-1f3fd","1f3ca-1f3fe","1f3ca-1f3ff"]},"395":{"n":"weight_lifter","u":"1f3cb","o":25,"c":3,"d":["1f3cb-1f3fb","1f3cb-1f3fc","1f3cb-1f3fd","1f3cb-1f3fe","1f3cb-1f3ff"]},"396":{"n":"golfer","u":"1f3cc","o":39,"c":3},"397":{"n":"racing_motorcycle","u":"1f3cd","o":17,"c":5},"398":{"n":"racing_car","u":"1f3ce","o":6,"c":5},"399":{"n":"cricket_bat_and_ball","u":"1f3cf","o":14,"c":3},"400":{"n":"volleyball","u":"1f3d0","o":6,"c":3},"401":{"n":"field_hockey_stick_and_ball","u":"1f3d1","o":13,"c":3},"402":{"n":"ice_hockey_stick_and_puck","u":"1f3d2","o":12,"c":3},"403":{"n":"table_tennis_paddle_and_ball","u":"1f3d3","o":9,"c":3},"404":{"n":"snow_capped_mountain","u":"1f3d4","o":74,"c":5},"405":{"n":"camping","u":"1f3d5","o":78,"c":5},"406":{"n":"beach_with_umbrella","u":"1f3d6","o":71,"c":5},"407":{"n":"building_construction","u":"1f3d7","o":82,"c":5},"408":{"n":"house_buildings","u":"1f3d8","o":86,"c":5},"409":{"n":"cityscape","u":"1f3d9","o":115,"c":5},"410":{"n":"derelict_house_building","u":"1f3da","o":87,"c":5},"411":{"n":"classical_building","u":"1f3db","o":99,"c":5},"412":{"n":"desert","u":"1f3dc","o":77,"c":5},"413":{"n":"desert_island","u":"1f3dd","o":72,"c":5},"414":{"n":"national_park","u":"1f3de","o":107,"c":5},"415":{"n":"stadium","u":"1f3df","o":66,"c":5},"416":{"n":"house","u":"1f3e0","o":84,"c":5},"417":{"n":"house_with_garden","u":"1f3e1","o":85,"c":5},"418":{"n":"office","u":"1f3e2","o":88,"c":5},"419":{"n":"post_office","u":"1f3e3","o":90,"c":5},"420":{"n":"european_post_office","u":"1f3e4","o":91,"c":5},"421":{"n":"hospital","u":"1f3e5","o":92,"c":5},"422":{"n":"bank","u":"1f3e6","o":93,"c":5},"423":{"n":"atm","u":"1f3e7","o":111,"c":7},"424":{"n":"hotel","u":"1f3e8","o":94,"c":5},"425":{"n":"love_hotel","u":"1f3e9","o":97,"c":5},"426":{"n":"convenience_store","u":"1f3ea","o":95,"c":5},"427":{"n":"school","u":"1f3eb","o":96,"c":5},"428":{"n":"department_store","u":"1f3ec","o":89,"c":5},"429":{"n":"factory","u":"1f3ed","o":83,"c":5},"430":{"n":"izakaya_lantern","u":"1f3ee","o":105,"c":4},"431":{"n":"japanese_castle","u":"1f3ef","o":65,"c":5},"432":{"n":"european_castle","u":"1f3f0","o":64,"c":5},"433":{"n":"waving_white_flag","u":"1f3f3","o":1,"c":6},"434":{"n":"waving_black_flag","u":"1f3f4","o":2,"c":6},"435":{"n":"rosette","u":"1f3f5","o":61,"c":3},"436":{"n":"label","u":"1f3f7","o":115,"c":4},"437":{"n":"badminton_racquet_and_shuttlecock","u":"1f3f8","o":10,"c":3},"438":{"n":"bow_and_arrow","u":"1f3f9","o":16,"c":3},"439":{"n":"amphora","u":"1f3fa","o":72,"c":4},"445":{"n":"rat","u":"1f400","o":84,"c":2},"446":{"n":"mouse2","u":"1f401","o":83,"c":2},"447":{"n":"ox","u":"1f402","o":63,"c":2},"448":{"n":"water_buffalo","u":"1f403","o":62,"c":2},"449":{"n":"cow2","u":"1f404","o":64,"c":2},"450":{"n":"tiger2","u":"1f405","o":61,"c":2},"451":{"n":"leopard","u":"1f406","o":60,"c":2},"452":{"n":"rabbit2","u":"1f407","o":82,"c":2},"453":{"n":"cat2","u":"1f408","o":78,"c":2},"454":{"n":"dragon","u":"1f409","o":87,"c":2},"455":{"n":"crocodile","u":"1f40a","o":59,"c":2},"456":{"n":"whale2","u":"1f40b","o":58,"c":2},"457":{"n":"snail","u":"1f40c","o":38,"c":2},"458":{"n":"snake","u":"1f40d","o":45,"c":2},"459":{"n":"racehorse","u":"1f40e","o":71,"c":2},"460":{"n":"ram","u":"1f40f","o":74,"c":2},"461":{"n":"goat","u":"1f410","o":73,"c":2},"462":{"n":"sheep","u":"1f411","o":75,"c":2},"463":{"n":"monkey","u":"1f412","o":20,"c":2},"464":{"n":"rooster","u":"1f413","o":79,"c":2},"465":{"n":"chicken","u":"1f414","o":21,"c":2},"466":{"n":"dog2","u":"1f415","o":76,"c":2},"467":{"n":"pig2","u":"1f416","o":72,"c":2},"468":{"n":"boar","u":"1f417","o":32,"c":2},"469":{"n":"elephant","u":"1f418","o":68,"c":2},"470":{"n":"octopus","u":"1f419","o":50,"c":2},"471":{"n":"shell","u":"1f41a","o":39,"c":2},"472":{"n":"bug","u":"1f41b","o":36,"c":2},"473":{"n":"ant","u":"1f41c","o":41,"c":2},"474":{"n":"bee","u":"1f41d","o":35,"c":2},"475":{"n":"beetle","u":"1f41e","o":40,"c":2},"476":{"n":"fish","u":"1f41f","o":53,"c":2},"477":{"n":"tropical_fish","u":"1f420","o":52,"c":2},"478":{"n":"blowfish","u":"1f421","o":54,"c":2},"479":{"n":"turtle","u":"1f422","o":44,"c":2},"480":{"n":"hatching_chick","u":"1f423","o":25,"c":2},"481":{"n":"baby_chick","u":"1f424","o":24,"c":2},"482":{"n":"hatched_chick","u":"1f425","o":26,"c":2},"483":{"n":"bird","u":"1f426","o":23,"c":2},"484":{"n":"penguin","u":"1f427","o":22,"c":2},"485":{"n":"koala","u":"1f428","o":9,"c":2},"486":{"n":"poodle","u":"1f429","o":77,"c":2},"487":{"n":"dromedary_camel","u":"1f42a","o":66,"c":2},"488":{"n":"camel","u":"1f42b","o":67,"c":2},"489":{"n":"dolphin","u":"1f42c","o":55,"c":2},"490":{"n":"mouse","u":"1f42d","o":3,"c":2},"491":{"n":"cow","u":"1f42e","o":12,"c":2},"492":{"n":"tiger","u":"1f42f","o":10,"c":2},"493":{"n":"rabbit","u":"1f430","o":5,"c":2},"494":{"n":"cat","u":"1f431","o":2,"c":2},"495":{"n":"dragon_face","u":"1f432","o":88,"c":2},"496":{"n":"whale","u":"1f433","o":57,"c":2},"497":{"n":"horse","u":"1f434","o":33,"c":2},"498":{"n":"monkey_face","u":"1f435","o":16,"c":2},"499":{"n":"dog","u":"1f436","o":1,"c":2},"500":{"n":"pig","u":"1f437","o":13,"c":2},"501":{"n":"frog","u":"1f438","o":15,"c":2},"502":{"n":"hamster","u":"1f439","o":4,"c":2},"503":{"n":"wolf","u":"1f43a","o":31,"c":2},"504":{"n":"bear","u":"1f43b","o":7,"c":2},"505":{"n":"panda_face","u":"1f43c","o":8,"c":2},"506":{"n":"pig_nose","u":"1f43d","o":14,"c":2},"507":{"n":"feet","u":"1f43e","o":86,"c":2},"508":{"n":"chipmunk","u":"1f43f","o":85,"c":2},"509":{"n":"eyes","u":"1f440","o":137,"c":0},"510":{"n":"eye","u":"1f441","o":136,"c":0},"511":{"n":"ear","u":"1f442","o":133,"c":0,"d":["1f442-1f3fb","1f442-1f3fc","1f442-1f3fd","1f442-1f3fe","1f442-1f3ff"]},"512":{"n":"nose","u":"1f443","o":134,"c":0,"d":["1f443-1f3fb","1f443-1f3fc","1f443-1f3fd","1f443-1f3fe","1f443-1f3ff"]},"513":{"n":"lips","u":"1f444","o":131,"c":0},"514":{"n":"tongue","u":"1f445","o":132,"c":0},"515":{"n":"point_up_2","u":"1f446","o":114,"c":0,"d":["1f446-1f3fb","1f446-1f3fc","1f446-1f3fd","1f446-1f3fe","1f446-1f3ff"]},"516":{"n":"point_down","u":"1f447","o":115,"c":0,"d":["1f447-1f3fb","1f447-1f3fc","1f447-1f3fd","1f447-1f3fe","1f447-1f3ff"]},"517":{"n":"point_left","u":"1f448","o":112,"c":0,"d":["1f448-1f3fb","1f448-1f3fc","1f448-1f3fd","1f448-1f3fe","1f448-1f3ff"]},"518":{"n":"point_right","u":"1f449","o":113,"c":0,"d":["1f449-1f3fb","1f449-1f3fc","1f449-1f3fd","1f449-1f3fe","1f449-1f3ff"]},"519":{"n":"facepunch","u":"1f44a","o":104,"c":0,"d":["1f44a-1f3fb","1f44a-1f3fc","1f44a-1f3fd","1f44a-1f3fe","1f44a-1f3ff"]},"520":{"n":"wave","u":"1f44b","o":121,"c":0,"d":["1f44b-1f3fb","1f44b-1f3fc","1f44b-1f3fd","1f44b-1f3fe","1f44b-1f3ff"]},"521":{"n":"ok_hand","u":"1f44c","o":111,"c":0,"d":["1f44c-1f3fb","1f44c-1f3fc","1f44c-1f3fd","1f44c-1f3fe","1f44c-1f3ff"]},"522":{"n":"+1","u":"1f44d","o":102,"c":0,"d":["1f44d-1f3fb","1f44d-1f3fc","1f44d-1f3fd","1f44d-1f3fe","1f44d-1f3ff"]},"523":{"n":"-1","u":"1f44e","o":103,"c":0,"d":["1f44e-1f3fb","1f44e-1f3fc","1f44e-1f3fd","1f44e-1f3fe","1f44e-1f3ff"]},"524":{"n":"clap","u":"1f44f","o":99,"c":0,"d":["1f44f-1f3fb","1f44f-1f3fc","1f44f-1f3fd","1f44f-1f3fe","1f44f-1f3ff"]},"525":{"n":"open_hands","u":"1f450","o":97,"c":0,"d":["1f450-1f3fb","1f450-1f3fc","1f450-1f3fd","1f450-1f3fe","1f450-1f3ff"]},"526":{"n":"crown","u":"1f451","o":283,"c":0},"527":{"n":"womans_hat","u":"1f452","o":280,"c":0},"528":{"n":"eyeglasses","u":"1f453","o":290,"c":0},"529":{"n":"necktie","u":"1f454","o":271,"c":0},"530":{"n":"shirt","u":"1f455","o":269,"c":0},"531":{"n":"jeans","u":"1f456","o":270,"c":0},"532":{"n":"dress","u":"1f457","o":272,"c":0},"533":{"n":"kimono","u":"1f458","o":274,"c":0},"534":{"n":"bikini","u":"1f459","o":273,"c":0},"535":{"n":"womans_clothes","u":"1f45a","o":268,"c":0},"536":{"n":"purse","u":"1f45b","o":287,"c":0},"537":{"n":"handbag","u":"1f45c","o":288,"c":0},"538":{"n":"pouch","u":"1f45d","o":286,"c":0},"539":{"n":"mans_shoe","u":"1f45e","o":278,"c":0},"540":{"n":"athletic_shoe","u":"1f45f","o":279,"c":0},"541":{"n":"high_heel","u":"1f460","o":275,"c":0},"542":{"n":"sandal","u":"1f461","o":276,"c":0},"543":{"n":"boot","u":"1f462","o":277,"c":0},"544":{"n":"footprints","u":"1f463","o":135,"c":0},"545":{"n":"bust_in_silhouette","u":"1f464","o":139,"c":0},"546":{"n":"busts_in_silhouette","u":"1f465","o":140,"c":0},"547":{"n":"boy","u":"1f466","o":142,"c":0,"d":["1f466-1f3fb","1f466-1f3fc","1f466-1f3fd","1f466-1f3fe","1f466-1f3ff"]},"548":{"n":"girl","u":"1f467","o":143,"c":0,"d":["1f467-1f3fb","1f467-1f3fc","1f467-1f3fd","1f467-1f3fe","1f467-1f3ff"]},"549":{"n":"man","u":"1f468","o":144,"c":0,"d":["1f468-1f3fb","1f468-1f3fc","1f468-1f3fd","1f468-1f3fe","1f468-1f3ff"]},"550":{"n":"woman","u":"1f469","o":145,"c":0,"d":["1f469-1f3fb","1f469-1f3fc","1f469-1f3fd","1f469-1f3fe","1f469-1f3ff"]},"551":{"n":"family","u":"1f46a","o":243,"c":0},"552":{"n":"couple","u":"1f46b","o":234,"c":0},"553":{"n":"two_men_holding_hands","u":"1f46c","o":236,"c":0},"554":{"n":"two_women_holding_hands","u":"1f46d","o":235,"c":0},"555":{"n":"cop","u":"1f46e","o":154,"c":0,"d":["1f46e-1f3fb","1f46e-1f3fc","1f46e-1f3fd","1f46e-1f3fe","1f46e-1f3ff"]},"556":{"n":"dancers","u":"1f46f","o":228,"c":0},"557":{"n":"bride_with_veil","u":"1f470","o":197,"c":0,"d":["1f470-1f3fb","1f470-1f3fc","1f470-1f3fd","1f470-1f3fe","1f470-1f3ff"]},"558":{"n":"person_with_blond_hair","u":"1f471","o":147,"c":0,"d":["1f471-1f3fb","1f471-1f3fc","1f471-1f3fd","1f471-1f3fe","1f471-1f3ff"]},"559":{"n":"man_with_gua_pi_mao","u":"1f472","o":150,"c":0,"d":["1f472-1f3fb","1f472-1f3fc","1f472-1f3fd","1f472-1f3fe","1f472-1f3ff"]},"560":{"n":"man_with_turban","u":"1f473","o":152,"c":0,"d":["1f473-1f3fb","1f473-1f3fc","1f473-1f3fd","1f473-1f3fe","1f473-1f3ff"]},"561":{"n":"older_man","u":"1f474","o":148,"c":0,"d":["1f474-1f3fb","1f474-1f3fc","1f474-1f3fd","1f474-1f3fe","1f474-1f3ff"]},"562":{"n":"older_woman","u":"1f475","o":149,"c":0,"d":["1f475-1f3fb","1f475-1f3fc","1f475-1f3fd","1f475-1f3fe","1f475-1f3ff"]},"563":{"n":"baby","u":"1f476","o":141,"c":0,"d":["1f476-1f3fb","1f476-1f3fc","1f476-1f3fd","1f476-1f3fe","1f476-1f3ff"]},"564":{"n":"construction_worker","u":"1f477","o":156,"c":0,"d":["1f477-1f3fb","1f477-1f3fc","1f477-1f3fd","1f477-1f3fe","1f477-1f3ff"]},"565":{"n":"princess","u":"1f478","o":195,"c":0,"d":["1f478-1f3fb","1f478-1f3fc","1f478-1f3fd","1f478-1f3fe","1f478-1f3ff"]},"566":{"n":"japanese_ogre","u":"1f479","o":78,"c":0},"567":{"n":"japanese_goblin","u":"1f47a","o":79,"c":0},"568":{"n":"ghost","u":"1f47b","o":81,"c":0},"569":{"n":"angel","u":"1f47c","o":199,"c":0,"d":["1f47c-1f3fb","1f47c-1f3fc","1f47c-1f3fd","1f47c-1f3fe","1f47c-1f3ff"]},"570":{"n":"alien","u":"1f47d","o":84,"c":0},"571":{"n":"space_invader","u":"1f47e","o":85,"c":0},"572":{"n":"imp","u":"1f47f","o":77,"c":0},"573":{"n":"skull","u":"1f480","o":82,"c":0},"574":{"n":"information_desk_person","u":"1f481","o":203,"c":0,"d":["1f481-1f3fb","1f481-1f3fc","1f481-1f3fd","1f481-1f3fe","1f481-1f3ff"]},"575":{"n":"guardsman","u":"1f482","o":158,"c":0,"d":["1f482-1f3fb","1f482-1f3fc","1f482-1f3fd","1f482-1f3fe","1f482-1f3ff"]},"576":{"n":"dancer","u":"1f483","o":226,"c":0,"d":["1f483-1f3fb","1f483-1f3fc","1f483-1f3fd","1f483-1f3fe","1f483-1f3ff"]},"577":{"n":"lipstick","u":"1f484","o":129,"c":0},"578":{"n":"nail_care","u":"1f485","o":127,"c":0,"d":["1f485-1f3fb","1f485-1f3fc","1f485-1f3fd","1f485-1f3fe","1f485-1f3ff"]},"579":{"n":"massage","u":"1f486","o":223,"c":0,"d":["1f486-1f3fb","1f486-1f3fc","1f486-1f3fd","1f486-1f3fe","1f486-1f3ff"]},"580":{"n":"haircut","u":"1f487","o":221,"c":0,"d":["1f487-1f3fb","1f487-1f3fc","1f487-1f3fd","1f487-1f3fe","1f487-1f3ff"]},"581":{"n":"barber","u":"1f488","o":75,"c":4},"582":{"n":"syringe","u":"1f489","o":81,"c":4},"583":{"n":"pill","u":"1f48a","o":80,"c":4},"584":{"n":"kiss","u":"1f48b","o":130,"c":0},"585":{"n":"love_letter","u":"1f48c","o":111,"c":4},"586":{"n":"ring","u":"1f48d","o":128,"c":0},"587":{"n":"gem","u":"1f48e","o":53,"c":4},"588":{"n":"couplekiss","u":"1f48f","o":240,"c":0},"589":{"n":"bouquet","u":"1f490","o":105,"c":2},"590":{"n":"couple_with_heart","u":"1f491","o":237,"c":0},"591":{"n":"wedding","u":"1f492","o":98,"c":5},"592":{"n":"heartbeat","u":"1f493","o":11,"c":7},"593":{"n":"broken_heart","u":"1f494","o":7,"c":7},"594":{"n":"two_hearts","u":"1f495","o":9,"c":7},"595":{"n":"sparkling_heart","u":"1f496","o":13,"c":7},"596":{"n":"heartpulse","u":"1f497","o":12,"c":7},"597":{"n":"cupid","u":"1f498","o":14,"c":7},"598":{"n":"blue_heart","u":"1f499","o":4,"c":7},"599":{"n":"green_heart","u":"1f49a","o":3,"c":7},"600":{"n":"yellow_heart","u":"1f49b","o":2,"c":7},"601":{"n":"purple_heart","u":"1f49c","o":5,"c":7},"602":{"n":"gift_heart","u":"1f49d","o":15,"c":7},"603":{"n":"revolving_hearts","u":"1f49e","o":10,"c":7},"604":{"n":"heart_decoration","u":"1f49f","o":16,"c":7},"605":{"n":"diamond_shape_with_a_dot_inside","u":"1f4a0","o":107,"c":7},"606":{"n":"bulb","u":"1f4a1","o":41,"c":4},"607":{"n":"anger","u":"1f4a2","o":76,"c":7},"608":{"n":"bomb","u":"1f4a3","o":64,"c":4},"609":{"n":"zzz","u":"1f4a4","o":110,"c":7},"610":{"n":"boom","u":"1f4a5","o":136,"c":2},"611":{"n":"sweat_drops","u":"1f4a6","o":158,"c":2},"612":{"n":"droplet","u":"1f4a7","o":157,"c":2},"613":{"n":"dash","u":"1f4a8","o":153,"c":2},"614":{"n":"hankey","u":"1f4a9","o":80,"c":0},"615":{"n":"muscle","u":"1f4aa","o":123,"c":0,"d":["1f4aa-1f3fb","1f4aa-1f3fc","1f4aa-1f3fd","1f4aa-1f3fe","1f4aa-1f3ff"]},"616":{"n":"dizzy","u":"1f4ab","o":130,"c":2},"617":{"n":"speech_balloon","u":"1f4ac","o":239,"c":7},"618":{"n":"thought_balloon","u":"1f4ad","o":241,"c":7},"619":{"n":"white_flower","u":"1f4ae","o":55,"c":7},"620":{"n":"100","u":"1f4af","o":75,"c":7},"621":{"n":"moneybag","u":"1f4b0","o":51,"c":4},"622":{"n":"currency_exchange","u":"1f4b1","o":195,"c":7},"623":{"n":"heavy_dollar_sign","u":"1f4b2","o":194,"c":7},"624":{"n":"credit_card","u":"1f4b3","o":52,"c":4},"625":{"n":"yen","u":"1f4b4","o":48,"c":4},"626":{"n":"dollar","u":"1f4b5","o":47,"c":4},"627":{"n":"euro","u":"1f4b6","o":49,"c":4},"628":{"n":"pound","u":"1f4b7","o":50,"c":4},"629":{"n":"money_with_wings","u":"1f4b8","o":46,"c":4},"630":{"n":"chart","u":"1f4b9","o":102,"c":7},"631":{"n":"seat","u":"1f4ba","o":45,"c":5},"632":{"n":"computer","u":"1f4bb","o":4,"c":4},"633":{"n":"briefcase","u":"1f4bc","o":289,"c":0},"634":{"n":"minidisc","u":"1f4bd","o":12,"c":4},"635":{"n":"floppy_disk","u":"1f4be","o":13,"c":4},"636":{"n":"cd","u":"1f4bf","o":14,"c":4},"637":{"n":"dvd","u":"1f4c0","o":15,"c":4},"638":{"n":"file_folder","u":"1f4c1","o":138,"c":4},"639":{"n":"open_file_folder","u":"1f4c2","o":139,"c":4},"640":{"n":"page_with_curl","u":"1f4c3","o":123,"c":4},"641":{"n":"page_facing_up","u":"1f4c4","o":124,"c":4},"642":{"n":"date","u":"1f4c5","o":132,"c":4},"643":{"n":"calendar","u":"1f4c6","o":131,"c":4},"644":{"n":"card_index","u":"1f4c7","o":133,"c":4},"645":{"n":"chart_with_upwards_trend","u":"1f4c8","o":127,"c":4},"646":{"n":"chart_with_downwards_trend","u":"1f4c9","o":128,"c":4},"647":{"n":"bar_chart","u":"1f4ca","o":126,"c":4},"648":{"n":"clipboard","u":"1f4cb","o":137,"c":4},"649":{"n":"pushpin","u":"1f4cc","o":158,"c":4},"650":{"n":"round_pushpin","u":"1f4cd","o":159,"c":4},"651":{"n":"paperclip","u":"1f4ce","o":154,"c":4},"652":{"n":"straight_ruler","u":"1f4cf","o":157,"c":4},"653":{"n":"triangular_ruler","u":"1f4d0","o":156,"c":4},"654":{"n":"bookmark_tabs","u":"1f4d1","o":125,"c":4},"655":{"n":"ledger","u":"1f4d2","o":145,"c":4},"656":{"n":"notebook","u":"1f4d3","o":143,"c":4},"657":{"n":"notebook_with_decorative_cover","u":"1f4d4","o":144,"c":4},"658":{"n":"closed_book","u":"1f4d5","o":146,"c":4},"659":{"n":"book","u":"1f4d6","o":151,"c":4},"660":{"n":"green_book","u":"1f4d7","o":147,"c":4},"661":{"n":"blue_book","u":"1f4d8","o":148,"c":4},"662":{"n":"orange_book","u":"1f4d9","o":149,"c":4},"663":{"n":"books","u":"1f4da","o":150,"c":4},"664":{"n":"name_badge","u":"1f4db","o":73,"c":7},"665":{"n":"scroll","u":"1f4dc","o":122,"c":4},"666":{"n":"memo","u":"1f4dd","o":166,"c":4},"667":{"n":"telephone_receiver","u":"1f4de","o":23,"c":4},"668":{"n":"pager","u":"1f4df","o":25,"c":4},"669":{"n":"fax","u":"1f4e0","o":26,"c":4},"670":{"n":"satellite_antenna","u":"1f4e1","o":38,"c":4},"671":{"n":"loudspeaker","u":"1f4e2","o":237,"c":7},"672":{"n":"mega","u":"1f4e3","o":236,"c":7},"673":{"n":"outbox_tray","u":"1f4e4","o":113,"c":4},"674":{"n":"inbox_tray","u":"1f4e5","o":112,"c":4},"675":{"n":"package","u":"1f4e6","o":114,"c":4},"676":{"n":"e-mail","u":"1f4e7","o":110,"c":4},"677":{"n":"incoming_envelope","u":"1f4e8","o":109,"c":4},"678":{"n":"envelope_with_arrow","u":"1f4e9","o":108,"c":4},"679":{"n":"mailbox_closed","u":"1f4ea","o":116,"c":4},"680":{"n":"mailbox","u":"1f4eb","o":117,"c":4},"681":{"n":"mailbox_with_mail","u":"1f4ec","o":118,"c":4},"682":{"n":"mailbox_with_no_mail","u":"1f4ed","o":119,"c":4},"683":{"n":"postbox","u":"1f4ee","o":120,"c":4},"684":{"n":"postal_horn","u":"1f4ef","o":121,"c":4},"685":{"n":"newspaper","u":"1f4f0","o":142,"c":4},"686":{"n":"iphone","u":"1f4f1","o":2,"c":4},"687":{"n":"calling","u":"1f4f2","o":3,"c":4},"688":{"n":"vibration_mode","u":"1f4f3","o":47,"c":7},"689":{"n":"mobile_phone_off","u":"1f4f4","o":46,"c":7},"690":{"n":"no_mobile_phones","u":"1f4f5","o":83,"c":7},"691":{"n":"signal_strength","u":"1f4f6","o":127,"c":7},"692":{"n":"camera","u":"1f4f7","o":17,"c":4},"693":{"n":"camera_with_flash","u":"1f4f8","o":18,"c":4},"694":{"n":"video_camera","u":"1f4f9","o":19,"c":4},"695":{"n":"tv","u":"1f4fa","o":27,"c":4},"696":{"n":"radio","u":"1f4fb","o":28,"c":4},"697":{"n":"vhs","u":"1f4fc","o":16,"c":4},"698":{"n":"film_projector","u":"1f4fd","o":21,"c":4},"699":{"n":"prayer_beads","u":"1f4ff","o":74,"c":4},"700":{"n":"twisted_rightwards_arrows","u":"1f500","o":183,"c":7},"701":{"n":"repeat","u":"1f501","o":184,"c":7},"702":{"n":"repeat_one","u":"1f502","o":185,"c":7},"703":{"n":"arrows_clockwise","u":"1f503","o":187,"c":7},"704":{"n":"arrows_counterclockwise","u":"1f504","o":186,"c":7},"705":{"n":"low_brightness","u":"1f505","o":91,"c":7},"706":{"n":"high_brightness","u":"1f506","o":92,"c":7},"707":{"n":"mute","u":"1f507","o":231,"c":7},"708":{"n":"speaker","u":"1f508","o":230,"c":7},"709":{"n":"sound","u":"1f509","o":232,"c":7},"710":{"n":"loud_sound","u":"1f50a","o":233,"c":7},"711":{"n":"battery","u":"1f50b","o":39,"c":4},"712":{"n":"electric_plug","u":"1f50c","o":40,"c":4},"713":{"n":"mag","u":"1f50d","o":168,"c":4},"714":{"n":"mag_right","u":"1f50e","o":169,"c":4},"715":{"n":"lock_with_ink_pen","u":"1f50f","o":170,"c":4},"716":{"n":"closed_lock_with_key","u":"1f510","o":171,"c":4},"717":{"n":"key","u":"1f511","o":89,"c":4},"718":{"n":"lock","u":"1f512","o":172,"c":4},"719":{"n":"unlock","u":"1f513","o":173,"c":4},"720":{"n":"bell","u":"1f514","o":234,"c":7},"721":{"n":"no_bell","u":"1f515","o":235,"c":7},"722":{"n":"bookmark","u":"1f516","o":152,"c":4},"723":{"n":"link","u":"1f517","o":153,"c":4},"724":{"n":"radio_button","u":"1f518","o":209,"c":7},"725":{"n":"back","u":"1f519","o":203,"c":7},"726":{"n":"end","u":"1f51a","o":202,"c":7},"727":{"n":"on","u":"1f51b","o":204,"c":7},"728":{"n":"soon","u":"1f51c","o":206,"c":7},"729":{"n":"top","u":"1f51d","o":205,"c":7},"730":{"n":"underage","u":"1f51e","o":82,"c":7},"731":{"n":"keycap_ten","u":"1f51f","o":150,"c":7},"732":{"n":"capital_abcd","u":"1f520","o":133,"c":7},"733":{"n":"abcd","u":"1f521","o":132,"c":7},"734":{"n":"1234","u":"1f522","o":151,"c":7},"735":{"n":"symbols","u":"1f523","o":129,"c":7},"736":{"n":"abc","u":"1f524","o":131,"c":7},"737":{"n":"fire","u":"1f525","o":135,"c":2},"738":{"n":"flashlight","u":"1f526","o":42,"c":4},"739":{"n":"wrench","u":"1f527","o":55,"c":4},"740":{"n":"hammer","u":"1f528","o":56,"c":4},"741":{"n":"nut_and_bolt","u":"1f529","o":60,"c":4},"742":{"n":"hocho","u":"1f52a","o":65,"c":4},"743":{"n":"gun","u":"1f52b","o":63,"c":4},"744":{"n":"microscope","u":"1f52c","o":78,"c":4},"745":{"n":"telescope","u":"1f52d","o":77,"c":4},"746":{"n":"crystal_ball","u":"1f52e","o":73,"c":4},"747":{"n":"six_pointed_star","u":"1f52f","o":23,"c":7},"748":{"n":"beginner","u":"1f530","o":98,"c":7},"749":{"n":"trident","u":"1f531","o":96,"c":7},"750":{"n":"black_square_button","u":"1f532","o":221,"c":7},"751":{"n":"white_square_button","u":"1f533","o":220,"c":7},"752":{"n":"red_circle","u":"1f534","o":212,"c":7},"753":{"n":"large_blue_circle","u":"1f535","o":213,"c":7},"754":{"n":"large_orange_diamond","u":"1f536","o":218,"c":7},"755":{"n":"large_blue_diamond","u":"1f537","o":219,"c":7},"756":{"n":"small_orange_diamond","u":"1f538","o":216,"c":7},"757":{"n":"small_blue_diamond","u":"1f539","o":217,"c":7},"758":{"n":"small_red_triangle","u":"1f53a","o":214,"c":7},"759":{"n":"small_red_triangle_down","u":"1f53b","o":215,"c":7},"760":{"n":"arrow_up_small","u":"1f53c","o":167,"c":7},"761":{"n":"arrow_down_small","u":"1f53d","o":168,"c":7},"762":{"n":"om_symbol","u":"1f549","o":20,"c":7},"763":{"n":"dove_of_peace","u":"1f54a","o":81,"c":2},"764":{"n":"kaaba","u":"1f54b","o":103,"c":5},"765":{"n":"mosque","u":"1f54c","o":101,"c":5},"766":{"n":"synagogue","u":"1f54d","o":102,"c":5},"767":{"n":"menorah_with_nine_branches","u":"1f54e","o":24,"c":7},"768":{"n":"clock1","u":"1f550","o":250,"c":7},"769":{"n":"clock2","u":"1f551","o":251,"c":7},"770":{"n":"clock3","u":"1f552","o":252,"c":7},"771":{"n":"clock4","u":"1f553","o":253,"c":7},"772":{"n":"clock5","u":"1f554","o":254,"c":7},"773":{"n":"clock6","u":"1f555","o":255,"c":7},"774":{"n":"clock7","u":"1f556","o":256,"c":7},"775":{"n":"clock8","u":"1f557","o":257,"c":7},"776":{"n":"clock9","u":"1f558","o":258,"c":7},"777":{"n":"clock10","u":"1f559","o":259,"c":7},"778":{"n":"clock11","u":"1f55a","o":260,"c":7},"779":{"n":"clock12","u":"1f55b","o":261,"c":7},"780":{"n":"clock130","u":"1f55c","o":262,"c":7},"781":{"n":"clock230","u":"1f55d","o":263,"c":7},"782":{"n":"clock330","u":"1f55e","o":264,"c":7},"783":{"n":"clock430","u":"1f55f","o":265,"c":7},"784":{"n":"clock530","u":"1f560","o":266,"c":7},"785":{"n":"clock630","u":"1f561","o":267,"c":7},"786":{"n":"clock730","u":"1f562","o":268,"c":7},"787":{"n":"clock830","u":"1f563","o":269,"c":7},"788":{"n":"clock930","u":"1f564","o":270,"c":7},"789":{"n":"clock1030","u":"1f565","o":271,"c":7},"790":{"n":"clock1130","u":"1f566","o":272,"c":7},"791":{"n":"clock1230","u":"1f567","o":273,"c":7},"792":{"n":"candle","u":"1f56f","o":43,"c":4},"793":{"n":"mantelpiece_clock","u":"1f570","o":35,"c":4},"794":{"n":"hole","u":"1f573","o":79,"c":4},"795":{"n":"man_in_business_suit_levitating","u":"1f574","o":225,"c":0},"796":{"n":"sleuth_or_spy","u":"1f575","o":160,"c":0,"d":["1f575-1f3fb","1f575-1f3fc","1f575-1f3fd","1f575-1f3fe","1f575-1f3ff"]},"797":{"n":"dark_sunglasses","u":"1f576","o":291,"c":0},"798":{"n":"spider","u":"1f577","o":42,"c":2},"799":{"n":"spider_web","u":"1f578","o":43,"c":2},"800":{"n":"joystick","u":"1f579","o":10,"c":4},"801":{"n":"man_dancing","u":"1f57a","o":227,"c":0,"d":["1f57a-1f3fb","1f57a-1f3fc","1f57a-1f3fd","1f57a-1f3fe","1f57a-1f3ff"]},"802":{"n":"linked_paperclips","u":"1f587","o":155,"c":4},"803":{"n":"lower_left_ballpoint_pen","u":"1f58a","o":161,"c":4},"804":{"n":"lower_left_fountain_pen","u":"1f58b","o":162,"c":4},"805":{"n":"lower_left_paintbrush","u":"1f58c","o":164,"c":4},"806":{"n":"lower_left_crayon","u":"1f58d","o":165,"c":4},"807":{"n":"raised_hand_with_fingers_splayed","u":"1f590","o":119,"c":0,"d":["1f590-1f3fb","1f590-1f3fc","1f590-1f3fd","1f590-1f3fe","1f590-1f3ff"]},"808":{"n":"middle_finger","u":"1f595","o":124,"c":0,"d":["1f595-1f3fb","1f595-1f3fc","1f595-1f3fd","1f595-1f3fe","1f595-1f3ff"]},"809":{"n":"spock-hand","u":"1f596","o":120,"c":0,"d":["1f596-1f3fb","1f596-1f3fc","1f596-1f3fd","1f596-1f3fe","1f596-1f3ff"]},"810":{"n":"black_heart","u":"1f5a4","o":6,"c":7},"811":{"n":"desktop_computer","u":"1f5a5","o":6,"c":4},"812":{"n":"printer","u":"1f5a8","o":7,"c":4},"813":{"n":"three_button_mouse","u":"1f5b1","o":8,"c":4},"814":{"n":"trackball","u":"1f5b2","o":9,"c":4},"815":{"n":"frame_with_picture","u":"1f5bc","o":95,"c":4},"816":{"n":"card_index_dividers","u":"1f5c2","o":140,"c":4},"817":{"n":"card_file_box","u":"1f5c3","o":134,"c":4},"818":{"n":"file_cabinet","u":"1f5c4","o":136,"c":4},"819":{"n":"wastebasket","u":"1f5d1","o":44,"c":4},"820":{"n":"spiral_note_pad","u":"1f5d2","o":129,"c":4},"821":{"n":"spiral_calendar_pad","u":"1f5d3","o":130,"c":4},"822":{"n":"compression","u":"1f5dc","o":11,"c":4},"823":{"n":"old_key","u":"1f5dd","o":90,"c":4},"824":{"n":"rolled_up_newspaper","u":"1f5de","o":141,"c":4},"825":{"n":"dagger_knife","u":"1f5e1","o":66,"c":4},"826":{"n":"speaking_head_in_silhouette","u":"1f5e3","o":138,"c":0},"827":{"n":"left_speech_bubble","u":"1f5e8","o":240,"c":7},"828":{"n":"right_anger_bubble","u":"1f5ef","o":242,"c":7},"829":{"n":"ballot_box_with_ballot","u":"1f5f3","o":135,"c":4},"830":{"n":"world_map","u":"1f5fa","o":59,"c":5},"831":{"n":"mount_fuji","u":"1f5fb","o":75,"c":5},"832":{"n":"tokyo_tower","u":"1f5fc","o":63,"c":5},"833":{"n":"statue_of_liberty","u":"1f5fd","o":61,"c":5},"834":{"n":"japan","u":"1f5fe","o":105,"c":5},"835":{"n":"moyai","u":"1f5ff","o":60,"c":5},"836":{"n":"grinning","u":"1f600","o":1,"c":0},"837":{"n":"grin","u":"1f601","o":4,"c":0},"838":{"n":"joy","u":"1f602","o":7,"c":0},"839":{"n":"smiley","u":"1f603","o":2,"c":0},"840":{"n":"smile","u":"1f604","o":3,"c":0},"841":{"n":"sweat_smile","u":"1f605","o":6,"c":0},"842":{"n":"laughing","u":"1f606","o":5,"c":0},"843":{"n":"innocent","u":"1f607","o":11,"c":0},"844":{"n":"smiling_imp","u":"1f608","o":76,"c":0},"845":{"n":"wink","u":"1f609","o":14,"c":0},"846":{"n":"blush","u":"1f60a","o":10,"c":0},"847":{"n":"yum","u":"1f60b","o":21,"c":0},"848":{"n":"relieved","u":"1f60c","o":15,"c":0},"849":{"n":"heart_eyes","u":"1f60d","o":16,"c":0},"850":{"n":"sunglasses","u":"1f60e","o":28,"c":0},"851":{"n":"smirk","u":"1f60f","o":31,"c":0},"852":{"n":"neutral_face","u":"1f610","o":47,"c":0},"853":{"n":"expressionless","u":"1f611","o":48,"c":0},"854":{"n":"unamused","u":"1f612","o":32,"c":0},"855":{"n":"sweat","u":"1f613","o":63,"c":0},"856":{"n":"pensive","u":"1f614","o":34,"c":0},"857":{"n":"confused","u":"1f615","o":36,"c":0},"858":{"n":"confounded","u":"1f616","o":40,"c":0},"859":{"n":"kissing","u":"1f617","o":18,"c":0},"860":{"n":"kissing_heart","u":"1f618","o":17,"c":0},"861":{"n":"kissing_smiling_eyes","u":"1f619","o":19,"c":0},"862":{"n":"kissing_closed_eyes","u":"1f61a","o":20,"c":0},"863":{"n":"stuck_out_tongue","u":"1f61b","o":24,"c":0},"864":{"n":"stuck_out_tongue_winking_eye","u":"1f61c","o":22,"c":0},"865":{"n":"stuck_out_tongue_closed_eyes","u":"1f61d","o":23,"c":0},"866":{"n":"disappointed","u":"1f61e","o":33,"c":0},"867":{"n":"worried","u":"1f61f","o":35,"c":0},"868":{"n":"angry","u":"1f620","o":44,"c":0},"869":{"n":"rage","u":"1f621","o":45,"c":0},"870":{"n":"cry","u":"1f622","o":59,"c":0},"871":{"n":"persevere","u":"1f623","o":39,"c":0},"872":{"n":"triumph","u":"1f624","o":43,"c":0},"873":{"n":"disappointed_relieved","u":"1f625","o":60,"c":0},"874":{"n":"frowning","u":"1f626","o":50,"c":0},"875":{"n":"anguished","u":"1f627","o":51,"c":0},"876":{"n":"fearful","u":"1f628","o":57,"c":0},"877":{"n":"weary","u":"1f629","o":42,"c":0},"878":{"n":"sleepy","u":"1f62a","o":64,"c":0},"879":{"n":"tired_face","u":"1f62b","o":41,"c":0},"880":{"n":"grimacing","u":"1f62c","o":69,"c":0},"881":{"n":"sob","u":"1f62d","o":62,"c":0},"882":{"n":"open_mouth","u":"1f62e","o":52,"c":0},"883":{"n":"hushed","u":"1f62f","o":49,"c":0},"884":{"n":"cold_sweat","u":"1f630","o":58,"c":0},"885":{"n":"scream","u":"1f631","o":56,"c":0},"886":{"n":"astonished","u":"1f632","o":53,"c":0},"887":{"n":"flushed","u":"1f633","o":55,"c":0},"888":{"n":"sleeping","u":"1f634","o":65,"c":0},"889":{"n":"dizzy_face","u":"1f635","o":54,"c":0},"890":{"n":"no_mouth","u":"1f636","o":46,"c":0},"891":{"n":"mask","u":"1f637","o":73,"c":0},"892":{"n":"smile_cat","u":"1f638","o":89,"c":0},"893":{"n":"joy_cat","u":"1f639","o":90,"c":0},"894":{"n":"smiley_cat","u":"1f63a","o":88,"c":0},"895":{"n":"heart_eyes_cat","u":"1f63b","o":91,"c":0},"896":{"n":"smirk_cat","u":"1f63c","o":92,"c":0},"897":{"n":"kissing_cat","u":"1f63d","o":93,"c":0},"898":{"n":"pouting_cat","u":"1f63e","o":96,"c":0},"899":{"n":"crying_cat_face","u":"1f63f","o":95,"c":0},"900":{"n":"scream_cat","u":"1f640","o":94,"c":0},"901":{"n":"slightly_frowning_face","u":"1f641","o":37,"c":0},"902":{"n":"slightly_smiling_face","u":"1f642","o":12,"c":0},"903":{"n":"upside_down_face","u":"1f643","o":13,"c":0},"904":{"n":"face_with_rolling_eyes","u":"1f644","o":66,"c":0},"905":{"n":"no_good","u":"1f645","o":205,"c":0,"d":["1f645-1f3fb","1f645-1f3fc","1f645-1f3fd","1f645-1f3fe","1f645-1f3ff"]},"906":{"n":"ok_woman","u":"1f646","o":207,"c":0,"d":["1f646-1f3fb","1f646-1f3fc","1f646-1f3fd","1f646-1f3fe","1f646-1f3ff"]},"907":{"n":"bow","u":"1f647","o":202,"c":0,"d":["1f647-1f3fb","1f647-1f3fc","1f647-1f3fd","1f647-1f3fe","1f647-1f3ff"]},"908":{"n":"see_no_evil","u":"1f648","o":17,"c":2},"909":{"n":"hear_no_evil","u":"1f649","o":18,"c":2},"910":{"n":"speak_no_evil","u":"1f64a","o":19,"c":2},"911":{"n":"raising_hand","u":"1f64b","o":209,"c":0,"d":["1f64b-1f3fb","1f64b-1f3fc","1f64b-1f3fd","1f64b-1f3fe","1f64b-1f3ff"]},"912":{"n":"raised_hands","u":"1f64c","o":98,"c":0,"d":["1f64c-1f3fb","1f64c-1f3fc","1f64c-1f3fd","1f64c-1f3fe","1f64c-1f3ff"]},"913":{"n":"person_frowning","u":"1f64d","o":219,"c":0,"d":["1f64d-1f3fb","1f64d-1f3fc","1f64d-1f3fd","1f64d-1f3fe","1f64d-1f3ff"]},"914":{"n":"person_with_pouting_face","u":"1f64e","o":217,"c":0,"d":["1f64e-1f3fb","1f64e-1f3fc","1f64e-1f3fd","1f64e-1f3fe","1f64e-1f3ff"]},"915":{"n":"pray","u":"1f64f","o":100,"c":0,"d":["1f64f-1f3fb","1f64f-1f3fc","1f64f-1f3fd","1f64f-1f3fe","1f64f-1f3ff"]},"916":{"n":"rocket","u":"1f680","o":43,"c":5},"917":{"n":"helicopter","u":"1f681","o":38,"c":5},"918":{"n":"steam_locomotive","u":"1f682","o":33,"c":5},"919":{"n":"railway_car","u":"1f683","o":26,"c":5},"920":{"n":"bullettrain_side","u":"1f684","o":30,"c":5},"921":{"n":"bullettrain_front","u":"1f685","o":31,"c":5},"922":{"n":"train2","u":"1f686","o":34,"c":5},"923":{"n":"metro","u":"1f687","o":35,"c":5},"924":{"n":"light_rail","u":"1f688","o":32,"c":5},"925":{"n":"station","u":"1f689","o":37,"c":5},"926":{"n":"tram","u":"1f68a","o":36,"c":5},"927":{"n":"train","u":"1f68b","o":27,"c":5},"928":{"n":"bus","u":"1f68c","o":4,"c":5},"929":{"n":"oncoming_bus","u":"1f68d","o":20,"c":5},"930":{"n":"trolleybus","u":"1f68e","o":5,"c":5},"931":{"n":"busstop","u":"1f68f","o":56,"c":5},"932":{"n":"minibus","u":"1f690","o":10,"c":5},"933":{"n":"ambulance","u":"1f691","o":8,"c":5},"934":{"n":"fire_engine","u":"1f692","o":9,"c":5},"935":{"n":"police_car","u":"1f693","o":7,"c":5},"936":{"n":"oncoming_police_car","u":"1f694","o":19,"c":5},"937":{"n":"taxi","u":"1f695","o":2,"c":5},"938":{"n":"oncoming_taxi","u":"1f696","o":22,"c":5},"939":{"n":"car","u":"1f697","o":1,"c":5},"940":{"n":"oncoming_automobile","u":"1f698","o":21,"c":5},"941":{"n":"blue_car","u":"1f699","o":3,"c":5},"942":{"n":"truck","u":"1f69a","o":11,"c":5},"943":{"n":"articulated_lorry","u":"1f69b","o":12,"c":5},"944":{"n":"tractor","u":"1f69c","o":13,"c":5},"945":{"n":"monorail","u":"1f69d","o":29,"c":5},"946":{"n":"mountain_railway","u":"1f69e","o":28,"c":5},"947":{"n":"suspension_railway","u":"1f69f","o":25,"c":5},"948":{"n":"mountain_cableway","u":"1f6a0","o":24,"c":5},"949":{"n":"aerial_tramway","u":"1f6a1","o":23,"c":5},"950":{"n":"ship","u":"1f6a2","o":52,"c":5},"951":{"n":"rowboat","u":"1f6a3","o":48,"c":3,"d":["1f6a3-1f3fb","1f6a3-1f3fc","1f6a3-1f3fd","1f6a3-1f3fe","1f6a3-1f3ff"]},"952":{"n":"speedboat","u":"1f6a4","o":49,"c":5},"953":{"n":"traffic_light","u":"1f6a5","o":58,"c":5},"954":{"n":"vertical_traffic_light","u":"1f6a6","o":57,"c":5},"955":{"n":"construction","u":"1f6a7","o":54,"c":5},"956":{"n":"rotating_light","u":"1f6a8","o":18,"c":5},"957":{"n":"triangular_flag_on_post","u":"1f6a9","o":4,"c":6},"958":{"n":"door","u":"1f6aa","o":91,"c":4},"959":{"n":"no_entry_sign","u":"1f6ab","o":74,"c":7},"960":{"n":"smoking","u":"1f6ac","o":69,"c":4},"961":{"n":"no_smoking","u":"1f6ad","o":84,"c":7},"962":{"n":"put_litter_in_its_place","u":"1f6ae","o":125,"c":7},"963":{"n":"do_not_litter","u":"1f6af","o":79,"c":7},"964":{"n":"potable_water","u":"1f6b0","o":84,"c":4},"965":{"n":"non-potable_water","u":"1f6b1","o":81,"c":7},"966":{"n":"bike","u":"1f6b2","o":15,"c":5},"967":{"n":"no_bicycles","u":"1f6b3","o":80,"c":7},"968":{"n":"bicyclist","u":"1f6b4","o":51,"c":3,"d":["1f6b4-1f3fb","1f6b4-1f3fc","1f6b4-1f3fd","1f6b4-1f3fe","1f6b4-1f3ff"]},"969":{"n":"mountain_bicyclist","u":"1f6b5","o":53,"c":3,"d":["1f6b5-1f3fb","1f6b5-1f3fc","1f6b5-1f3fd","1f6b5-1f3fe","1f6b5-1f3ff"]},"970":{"n":"walking","u":"1f6b6","o":231,"c":0,"d":["1f6b6-1f3fb","1f6b6-1f3fc","1f6b6-1f3fd","1f6b6-1f3fe","1f6b6-1f3ff"]},"971":{"n":"no_pedestrians","u":"1f6b7","o":78,"c":7},"972":{"n":"children_crossing","u":"1f6b8","o":95,"c":7},"973":{"n":"mens","u":"1f6b9","o":121,"c":7},"974":{"n":"womens","u":"1f6ba","o":122,"c":7},"975":{"n":"restroom","u":"1f6bb","o":124,"c":7},"976":{"n":"baby_symbol","u":"1f6bc","o":123,"c":7},"977":{"n":"toilet","u":"1f6bd","o":83,"c":4},"978":{"n":"wc","u":"1f6be","o":112,"c":7},"979":{"n":"shower","u":"1f6bf","o":85,"c":4},"980":{"n":"bath","u":"1f6c0","o":87,"c":4,"d":["1f6c0-1f3fb","1f6c0-1f3fc","1f6c0-1f3fd","1f6c0-1f3fe","1f6c0-1f3ff"]},"981":{"n":"bathtub","u":"1f6c1","o":86,"c":4},"982":{"n":"passport_control","u":"1f6c2","o":117,"c":7},"983":{"n":"customs","u":"1f6c3","o":118,"c":7},"984":{"n":"baggage_claim","u":"1f6c4","o":119,"c":7},"985":{"n":"left_luggage","u":"1f6c5","o":120,"c":7},"986":{"n":"couch_and_lamp","u":"1f6cb","o":92,"c":4},"987":{"n":"sleeping_accommodation","u":"1f6cc","o":94,"c":4},"988":{"n":"shopping_bags","u":"1f6cd","o":96,"c":4},"989":{"n":"bellhop_bell","u":"1f6ce","o":88,"c":4},"990":{"n":"bed","u":"1f6cf","o":93,"c":4},"991":{"n":"place_of_worship","u":"1f6d0","o":27,"c":7},"992":{"n":"octagonal_sign","u":"1f6d1","o":71,"c":7},"993":{"n":"shopping_trolley","u":"1f6d2","o":97,"c":4},"994":{"n":"hammer_and_wrench","u":"1f6e0","o":58,"c":4},"995":{"n":"shield","u":"1f6e1","o":68,"c":4},"996":{"n":"oil_drum","u":"1f6e2","o":45,"c":4},"997":{"n":"motorway","u":"1f6e3","o":81,"c":5},"998":{"n":"railway_track","u":"1f6e4","o":80,"c":5},"999":{"n":"motor_boat","u":"1f6e5","o":48,"c":5},"1000":{"n":"small_airplane","u":"1f6e9","o":39,"c":5},"1001":{"n":"airplane_departure","u":"1f6eb","o":41,"c":5},"1002":{"n":"airplane_arriving","u":"1f6ec","o":42,"c":5},"1003":{"n":"satellite","u":"1f6f0","o":44,"c":5},"1004":{"n":"passenger_ship","u":"1f6f3","o":50,"c":5},"1005":{"n":"scooter","u":"1f6f4","o":14,"c":5},"1006":{"n":"motor_scooter","u":"1f6f5","o":16,"c":5},"1007":{"n":"canoe","u":"1f6f6","o":46,"c":5},"1008":{"n":"zipper_mouth_face","u":"1f910","o":70,"c":0},"1009":{"n":"money_mouth_face","u":"1f911","o":25,"c":0},"1010":{"n":"face_with_thermometer","u":"1f912","o":74,"c":0},"1011":{"n":"nerd_face","u":"1f913","o":27,"c":0},"1012":{"n":"thinking_face","u":"1f914","o":67,"c":0},"1013":{"n":"face_with_head_bandage","u":"1f915","o":75,"c":0},"1014":{"n":"robot_face","u":"1f916","o":86,"c":0},"1015":{"n":"hugging_face","u":"1f917","o":26,"c":0},"1016":{"n":"the_horns","u":"1f918","o":110,"c":0,"d":["1f918-1f3fb","1f918-1f3fc","1f918-1f3fd","1f918-1f3fe","1f918-1f3ff"]},"1017":{"n":"call_me_hand","u":"1f919","o":122,"c":0,"d":["1f919-1f3fb","1f919-1f3fc","1f919-1f3fd","1f919-1f3fe","1f919-1f3ff"]},"1018":{"n":"raised_back_of_hand","u":"1f91a","o":118,"c":0,"d":["1f91a-1f3fb","1f91a-1f3fc","1f91a-1f3fd","1f91a-1f3fe","1f91a-1f3ff"]},"1019":{"n":"left-facing_fist","u":"1f91b","o":106,"c":0,"d":["1f91b-1f3fb","1f91b-1f3fc","1f91b-1f3fd","1f91b-1f3fe","1f91b-1f3ff"]},"1020":{"n":"right-facing_fist","u":"1f91c","o":107,"c":0,"d":["1f91c-1f3fb","1f91c-1f3fc","1f91c-1f3fd","1f91c-1f3fe","1f91c-1f3ff"]},"1021":{"n":"handshake","u":"1f91d","o":101,"c":0},"1022":{"n":"hand_with_index_and_middle_fingers_crossed","u":"1f91e","o":108,"c":0,"d":["1f91e-1f3fb","1f91e-1f3fc","1f91e-1f3fd","1f91e-1f3fe","1f91e-1f3ff"]},"1023":{"n":"face_with_cowboy_hat","u":"1f920","o":30,"c":0},"1024":{"n":"clown_face","u":"1f921","o":29,"c":0},"1025":{"n":"nauseated_face","u":"1f922","o":71,"c":0},"1026":{"n":"rolling_on_the_floor_laughing","u":"1f923","o":8,"c":0},"1027":{"n":"drooling_face","u":"1f924","o":61,"c":0},"1028":{"n":"lying_face","u":"1f925","o":68,"c":0},"1029":{"n":"face_palm","u":"1f926","o":211,"c":0,"d":["1f926-1f3fb","1f926-1f3fc","1f926-1f3fd","1f926-1f3fe","1f926-1f3ff"]},"1030":{"n":"sneezing_face","u":"1f927","o":72,"c":0},"1031":{"n":"pregnant_woman","u":"1f930","o":200,"c":0,"d":["1f930-1f3fb","1f930-1f3fc","1f930-1f3fd","1f930-1f3fe","1f930-1f3ff"]},"1032":{"n":"selfie","u":"1f933","o":126,"c":0,"d":["1f933-1f3fb","1f933-1f3fc","1f933-1f3fd","1f933-1f3fe","1f933-1f3ff"]},"1033":{"n":"prince","u":"1f934","o":196,"c":0,"d":["1f934-1f3fb","1f934-1f3fc","1f934-1f3fd","1f934-1f3fe","1f934-1f3ff"]},"1034":{"n":"man_in_tuxedo","u":"1f935","o":198,"c":0,"d":["1f935-1f3fb","1f935-1f3fc","1f935-1f3fd","1f935-1f3fe","1f935-1f3ff"]},"1035":{"n":"mother_christmas","u":"1f936","o":193,"c":0,"d":["1f936-1f3fb","1f936-1f3fc","1f936-1f3fd","1f936-1f3fe","1f936-1f3ff"]},"1036":{"n":"shrug","u":"1f937","o":214,"c":0,"d":["1f937-1f3fb","1f937-1f3fc","1f937-1f3fd","1f937-1f3fe","1f937-1f3ff"]},"1037":{"n":"person_doing_cartwheel","u":"1f938","o":30,"c":3,"d":["1f938-1f3fb","1f938-1f3fc","1f938-1f3fd","1f938-1f3fe","1f938-1f3ff"]},"1038":{"n":"juggling","u":"1f939","o":66,"c":3,"d":["1f939-1f3fb","1f939-1f3fc","1f939-1f3fd","1f939-1f3fe","1f939-1f3ff"]},"1039":{"n":"fencer","u":"1f93a","o":26,"c":3},"1040":{"n":"wrestlers","u":"1f93c","o":27,"c":3},"1041":{"n":"water_polo","u":"1f93d","o":44,"c":3,"d":["1f93d-1f3fb","1f93d-1f3fc","1f93d-1f3fd","1f93d-1f3fe","1f93d-1f3ff"]},"1042":{"n":"handball","u":"1f93e","o":35,"c":3,"d":["1f93e-1f3fb","1f93e-1f3fc","1f93e-1f3fd","1f93e-1f3fe","1f93e-1f3ff"]},"1043":{"n":"wilted_flower","u":"1f940","o":108,"c":2},"1044":{"n":"drum_with_drumsticks","u":"1f941","o":76,"c":3},"1045":{"n":"clinking_glasses","u":"1f942","o":78,"c":1},"1046":{"n":"tumbler_glass","u":"1f943","o":80,"c":1},"1047":{"n":"spoon","u":"1f944","o":84,"c":1},"1048":{"n":"goal_net","u":"1f945","o":11,"c":3},"1049":{"n":"first_place_medal","u":"1f947","o":57,"c":3},"1050":{"n":"second_place_medal","u":"1f948","o":58,"c":3},"1051":{"n":"third_place_medal","u":"1f949","o":59,"c":3},"1052":{"n":"boxing_glove","u":"1f94a","o":18,"c":3},"1053":{"n":"martial_arts_uniform","u":"1f94b","o":19,"c":3},"1054":{"n":"croissant","u":"1f950","o":27,"c":1},"1055":{"n":"avocado","u":"1f951","o":15,"c":1},"1056":{"n":"cucumber","u":"1f952","o":18,"c":1},"1057":{"n":"bacon","u":"1f953","o":33,"c":1},"1058":{"n":"potato","u":"1f954","o":22,"c":1},"1059":{"n":"carrot","u":"1f955","o":19,"c":1},"1060":{"n":"baguette_bread","u":"1f956","o":29,"c":1},"1061":{"n":"green_salad","u":"1f957","o":45,"c":1},"1062":{"n":"shallow_pan_of_food","u":"1f958","o":46,"c":1},"1063":{"n":"stuffed_flatbread","u":"1f959","o":42,"c":1},"1064":{"n":"egg","u":"1f95a","o":31,"c":1},"1065":{"n":"glass_of_milk","u":"1f95b","o":71,"c":1},"1066":{"n":"peanuts","u":"1f95c","o":25,"c":1},"1067":{"n":"kiwifruit","u":"1f95d","o":14,"c":1},"1068":{"n":"pancakes","u":"1f95e","o":34,"c":1},"1069":{"n":"crab","u":"1f980","o":48,"c":2},"1070":{"n":"lion_face","u":"1f981","o":11,"c":2},"1071":{"n":"scorpion","u":"1f982","o":47,"c":2},"1072":{"n":"turkey","u":"1f983","o":80,"c":2},"1073":{"n":"unicorn_face","u":"1f984","o":34,"c":2},"1074":{"n":"eagle","u":"1f985","o":28,"c":2},"1075":{"n":"duck","u":"1f986","o":27,"c":2},"1076":{"n":"bat","u":"1f987","o":30,"c":2},"1077":{"n":"shark","u":"1f988","o":56,"c":2},"1078":{"n":"owl","u":"1f989","o":29,"c":2},"1079":{"n":"fox_face","u":"1f98a","o":6,"c":2},"1080":{"n":"butterfly","u":"1f98b","o":37,"c":2},"1081":{"n":"deer","u":"1f98c","o":65,"c":2},"1082":{"n":"gorilla","u":"1f98d","o":70,"c":2},"1083":{"n":"lizard","u":"1f98e","o":46,"c":2},"1084":{"n":"rhinoceros","u":"1f98f","o":69,"c":2},"1085":{"n":"shrimp","u":"1f990","o":51,"c":2},"1086":{"n":"squid","u":"1f991","o":49,"c":2},"1087":{"n":"cheese_wedge","u":"1f9c0","o":30,"c":1},"1088":{"n":"hash","u":"0023-20e3","o":152,"c":7},"1090":{"n":"zero","u":"0030-20e3","o":140,"c":7},"1091":{"n":"one","u":"0031-20e3","o":141,"c":7},"1092":{"n":"two","u":"0032-20e3","o":142,"c":7},"1093":{"n":"three","u":"0033-20e3","o":143,"c":7},"1094":{"n":"four","u":"0034-20e3","o":144,"c":7},"1095":{"n":"five","u":"0035-20e3","o":145,"c":7},"1096":{"n":"six","u":"0036-20e3","o":146,"c":7},"1097":{"n":"seven","u":"0037-20e3","o":147,"c":7},"1098":{"n":"eight","u":"0038-20e3","o":148,"c":7},"1099":{"n":"nine","u":"0039-20e3","o":149,"c":7},"1100":{"n":"flag-ac","u":"1f1e6-1f1e8","o":254,"c":6},"1101":{"n":"flag-ad","u":"1f1e6-1f1e9","o":11,"c":6},"1102":{"n":"flag-ae","u":"1f1e6-1f1ea","o":239,"c":6},"1103":{"n":"flag-af","u":"1f1e6-1f1eb","o":6,"c":6},"1104":{"n":"flag-ag","u":"1f1e6-1f1ec","o":15,"c":6},"1105":{"n":"flag-ai","u":"1f1e6-1f1ee","o":13,"c":6},"1106":{"n":"flag-al","u":"1f1e6-1f1f1","o":8,"c":6},"1107":{"n":"flag-am","u":"1f1e6-1f1f2","o":17,"c":6},"1108":{"n":"flag-ao","u":"1f1e6-1f1f4","o":12,"c":6},"1109":{"n":"flag-aq","u":"1f1e6-1f1f6","o":14,"c":6},"1110":{"n":"flag-ar","u":"1f1e6-1f1f7","o":16,"c":6},"1111":{"n":"flag-as","u":"1f1e6-1f1f8","o":10,"c":6},"1112":{"n":"flag-at","u":"1f1e6-1f1f9","o":20,"c":6},"1113":{"n":"flag-au","u":"1f1e6-1f1fa","o":19,"c":6},"1114":{"n":"flag-aw","u":"1f1e6-1f1fc","o":18,"c":6},"1115":{"n":"flag-ax","u":"1f1e6-1f1fd","o":7,"c":6},"1116":{"n":"flag-az","u":"1f1e6-1f1ff","o":21,"c":6},"1117":{"n":"flag-ba","u":"1f1e7-1f1e6","o":34,"c":6},"1118":{"n":"flag-bb","u":"1f1e7-1f1e7","o":25,"c":6},"1119":{"n":"flag-bd","u":"1f1e7-1f1e9","o":24,"c":6},"1120":{"n":"flag-be","u":"1f1e7-1f1ea","o":27,"c":6},"1121":{"n":"flag-bf","u":"1f1e7-1f1eb","o":41,"c":6},"1122":{"n":"flag-bg","u":"1f1e7-1f1ec","o":40,"c":6},"1123":{"n":"flag-bh","u":"1f1e7-1f1ed","o":23,"c":6},"1124":{"n":"flag-bi","u":"1f1e7-1f1ee","o":42,"c":6},"1125":{"n":"flag-bj","u":"1f1e7-1f1ef","o":29,"c":6},"1126":{"n":"flag-bl","u":"1f1e7-1f1f1","o":191,"c":6},"1127":{"n":"flag-bm","u":"1f1e7-1f1f2","o":30,"c":6},"1128":{"n":"flag-bn","u":"1f1e7-1f1f3","o":39,"c":6},"1129":{"n":"flag-bo","u":"1f1e7-1f1f4","o":32,"c":6},"1130":{"n":"flag-bq","u":"1f1e7-1f1f6","o":33,"c":6},"1131":{"n":"flag-br","u":"1f1e7-1f1f7","o":36,"c":6},"1132":{"n":"flag-bs","u":"1f1e7-1f1f8","o":22,"c":6},"1133":{"n":"flag-bt","u":"1f1e7-1f1f9","o":31,"c":6},"1134":{"n":"flag-bv","u":"1f1e7-1f1fb","o":255,"c":6},"1135":{"n":"flag-bw","u":"1f1e7-1f1fc","o":35,"c":6},"1136":{"n":"flag-by","u":"1f1e7-1f1fe","o":26,"c":6},"1137":{"n":"flag-bz","u":"1f1e7-1f1ff","o":28,"c":6},"1138":{"n":"flag-ca","u":"1f1e8-1f1e6","o":46,"c":6},"1139":{"n":"flag-cc","u":"1f1e8-1f1e8","o":54,"c":6},"1140":{"n":"flag-cd","u":"1f1e8-1f1e9","o":58,"c":6},"1141":{"n":"flag-cf","u":"1f1e8-1f1eb","o":49,"c":6},"1142":{"n":"flag-cg","u":"1f1e8-1f1ec","o":57,"c":6},"1143":{"n":"flag-ch","u":"1f1e8-1f1ed","o":221,"c":6},"1144":{"n":"flag-ci","u":"1f1e8-1f1ee","o":61,"c":6},"1145":{"n":"flag-ck","u":"1f1e8-1f1f0","o":59,"c":6},"1146":{"n":"flag-cl","u":"1f1e8-1f1f1","o":51,"c":6},"1147":{"n":"flag-cm","u":"1f1e8-1f1f2","o":45,"c":6},"1148":{"n":"flag-cn","u":"1f1e8-1f1f3","o":52,"c":6},"1149":{"n":"flag-co","u":"1f1e8-1f1f4","o":55,"c":6},"1150":{"n":"flag-cp","u":"1f1e8-1f1f5","o":256,"c":6},"1151":{"n":"flag-cr","u":"1f1e8-1f1f7","o":60,"c":6},"1152":{"n":"flag-cu","u":"1f1e8-1f1fa","o":63,"c":6},"1153":{"n":"flag-cv","u":"1f1e8-1f1fb","o":43,"c":6},"1154":{"n":"flag-cw","u":"1f1e8-1f1fc","o":64,"c":6},"1155":{"n":"flag-cx","u":"1f1e8-1f1fd","o":53,"c":6},"1156":{"n":"flag-cy","u":"1f1e8-1f1fe","o":65,"c":6},"1157":{"n":"flag-cz","u":"1f1e8-1f1ff","o":66,"c":6},"1158":{"n":"flag-de","u":"1f1e9-1f1ea","o":90,"c":6},"1159":{"n":"flag-dg","u":"1f1e9-1f1ec","o":257,"c":6},"1160":{"n":"flag-dj","u":"1f1e9-1f1ef","o":68,"c":6},"1161":{"n":"flag-dk","u":"1f1e9-1f1f0","o":67,"c":6},"1162":{"n":"flag-dm","u":"1f1e9-1f1f2","o":69,"c":6},"1163":{"n":"flag-do","u":"1f1e9-1f1f4","o":70,"c":6},"1164":{"n":"flag-dz","u":"1f1e9-1f1ff","o":9,"c":6},"1165":{"n":"flag-ea","u":"1f1ea-1f1e6","o":258,"c":6},"1166":{"n":"flag-ec","u":"1f1ea-1f1e8","o":71,"c":6},"1167":{"n":"flag-ee","u":"1f1ea-1f1ea","o":76,"c":6},"1168":{"n":"flag-eg","u":"1f1ea-1f1ec","o":72,"c":6},"1169":{"n":"flag-eh","u":"1f1ea-1f1ed","o":250,"c":6},"1170":{"n":"flag-er","u":"1f1ea-1f1f7","o":75,"c":6},"1171":{"n":"flag-es","u":"1f1ea-1f1f8","o":215,"c":6},"1172":{"n":"flag-et","u":"1f1ea-1f1f9","o":77,"c":6},"1173":{"n":"flag-eu","u":"1f1ea-1f1fa","o":78,"c":6},"1174":{"n":"flag-fi","u":"1f1eb-1f1ee","o":82,"c":6},"1175":{"n":"flag-fj","u":"1f1eb-1f1ef","o":81,"c":6},"1176":{"n":"flag-fk","u":"1f1eb-1f1f0","o":79,"c":6},"1177":{"n":"flag-fm","u":"1f1eb-1f1f2","o":150,"c":6},"1178":{"n":"flag-fo","u":"1f1eb-1f1f4","o":80,"c":6},"1179":{"n":"flag-fr","u":"1f1eb-1f1f7","o":83,"c":6},"1180":{"n":"flag-ga","u":"1f1ec-1f1e6","o":87,"c":6},"1181":{"n":"flag-gb","u":"1f1ec-1f1e7","o":240,"c":6},"1182":{"n":"flag-gd","u":"1f1ec-1f1e9","o":95,"c":6},"1183":{"n":"flag-ge","u":"1f1ec-1f1ea","o":89,"c":6},"1184":{"n":"flag-gf","u":"1f1ec-1f1eb","o":84,"c":6},"1185":{"n":"flag-gg","u":"1f1ec-1f1ec","o":99,"c":6},"1186":{"n":"flag-gh","u":"1f1ec-1f1ed","o":91,"c":6},"1187":{"n":"flag-gi","u":"1f1ec-1f1ee","o":92,"c":6},"1188":{"n":"flag-gl","u":"1f1ec-1f1f1","o":94,"c":6},"1189":{"n":"flag-gm","u":"1f1ec-1f1f2","o":88,"c":6},"1190":{"n":"flag-gn","u":"1f1ec-1f1f3","o":100,"c":6},"1191":{"n":"flag-gp","u":"1f1ec-1f1f5","o":96,"c":6},"1192":{"n":"flag-gq","u":"1f1ec-1f1f6","o":74,"c":6},"1193":{"n":"flag-gr","u":"1f1ec-1f1f7","o":93,"c":6},"1194":{"n":"flag-gs","u":"1f1ec-1f1f8","o":212,"c":6},"1195":{"n":"flag-gt","u":"1f1ec-1f1f9","o":98,"c":6},"1196":{"n":"flag-gu","u":"1f1ec-1f1fa","o":97,"c":6},"1197":{"n":"flag-gw","u":"1f1ec-1f1fc","o":101,"c":6},"1198":{"n":"flag-gy","u":"1f1ec-1f1fe","o":102,"c":6},"1199":{"n":"flag-hk","u":"1f1ed-1f1f0","o":105,"c":6},"1200":{"n":"flag-hm","u":"1f1ed-1f1f2","o":259,"c":6},"1201":{"n":"flag-hn","u":"1f1ed-1f1f3","o":104,"c":6},"1202":{"n":"flag-hr","u":"1f1ed-1f1f7","o":62,"c":6},"1203":{"n":"flag-ht","u":"1f1ed-1f1f9","o":103,"c":6},"1204":{"n":"flag-hu","u":"1f1ed-1f1fa","o":106,"c":6},"1205":{"n":"flag-ic","u":"1f1ee-1f1e8","o":47,"c":6},"1206":{"n":"flag-id","u":"1f1ee-1f1e9","o":109,"c":6},"1207":{"n":"flag-ie","u":"1f1ee-1f1ea","o":112,"c":6},"1208":{"n":"flag-il","u":"1f1ee-1f1f1","o":114,"c":6},"1209":{"n":"flag-im","u":"1f1ee-1f1f2","o":113,"c":6},"1210":{"n":"flag-in","u":"1f1ee-1f1f3","o":108,"c":6},"1211":{"n":"flag-io","u":"1f1ee-1f1f4","o":37,"c":6},"1212":{"n":"flag-iq","u":"1f1ee-1f1f6","o":111,"c":6},"1213":{"n":"flag-ir","u":"1f1ee-1f1f7","o":110,"c":6},"1214":{"n":"flag-is","u":"1f1ee-1f1f8","o":107,"c":6},"1215":{"n":"flag-it","u":"1f1ee-1f1f9","o":115,"c":6},"1216":{"n":"flag-je","u":"1f1ef-1f1ea","o":119,"c":6},"1217":{"n":"flag-jm","u":"1f1ef-1f1f2","o":116,"c":6},"1218":{"n":"flag-jo","u":"1f1ef-1f1f4","o":120,"c":6},"1219":{"n":"flag-jp","u":"1f1ef-1f1f5","o":117,"c":6},"1220":{"n":"flag-ke","u":"1f1f0-1f1ea","o":122,"c":6},"1221":{"n":"flag-kg","u":"1f1f0-1f1ec","o":126,"c":6},"1222":{"n":"flag-kh","u":"1f1f0-1f1ed","o":44,"c":6},"1223":{"n":"flag-ki","u":"1f1f0-1f1ee","o":123,"c":6},"1224":{"n":"flag-km","u":"1f1f0-1f1f2","o":56,"c":6},"1225":{"n":"flag-kn","u":"1f1f0-1f1f3","o":193,"c":6},"1226":{"n":"flag-kp","u":"1f1f0-1f1f5","o":171,"c":6},"1227":{"n":"flag-kr","u":"1f1f0-1f1f7","o":213,"c":6},"1228":{"n":"flag-kw","u":"1f1f0-1f1fc","o":125,"c":6},"1229":{"n":"flag-ky","u":"1f1f0-1f1fe","o":48,"c":6},"1230":{"n":"flag-kz","u":"1f1f0-1f1ff","o":121,"c":6},"1231":{"n":"flag-la","u":"1f1f1-1f1e6","o":127,"c":6},"1232":{"n":"flag-lb","u":"1f1f1-1f1e7","o":129,"c":6},"1233":{"n":"flag-lc","u":"1f1f1-1f1e8","o":194,"c":6},"1234":{"n":"flag-li","u":"1f1f1-1f1ee","o":133,"c":6},"1235":{"n":"flag-lk","u":"1f1f1-1f1f0","o":216,"c":6},"1236":{"n":"flag-lr","u":"1f1f1-1f1f7","o":131,"c":6},"1237":{"n":"flag-ls","u":"1f1f1-1f1f8","o":130,"c":6},"1238":{"n":"flag-lt","u":"1f1f1-1f1f9","o":134,"c":6},"1239":{"n":"flag-lu","u":"1f1f1-1f1fa","o":135,"c":6},"1240":{"n":"flag-lv","u":"1f1f1-1f1fb","o":128,"c":6},"1241":{"n":"flag-ly","u":"1f1f1-1f1fe","o":132,"c":6},"1242":{"n":"flag-ma","u":"1f1f2-1f1e6","o":156,"c":6},"1243":{"n":"flag-mc","u":"1f1f2-1f1e8","o":152,"c":6},"1244":{"n":"flag-md","u":"1f1f2-1f1e9","o":151,"c":6},"1245":{"n":"flag-me","u":"1f1f2-1f1ea","o":154,"c":6},"1246":{"n":"flag-mf","u":"1f1f2-1f1eb","o":260,"c":6},"1247":{"n":"flag-mg","u":"1f1f2-1f1ec","o":138,"c":6},"1248":{"n":"flag-mh","u":"1f1f2-1f1ed","o":144,"c":6},"1249":{"n":"flag-mk","u":"1f1f2-1f1f0","o":137,"c":6},"1250":{"n":"flag-ml","u":"1f1f2-1f1f1","o":142,"c":6},"1251":{"n":"flag-mm","u":"1f1f2-1f1f2","o":158,"c":6},"1252":{"n":"flag-mn","u":"1f1f2-1f1f3","o":153,"c":6},"1253":{"n":"flag-mo","u":"1f1f2-1f1f4","o":136,"c":6},"1254":{"n":"flag-mp","u":"1f1f2-1f1f5","o":170,"c":6},"1255":{"n":"flag-mq","u":"1f1f2-1f1f6","o":145,"c":6},"1256":{"n":"flag-mr","u":"1f1f2-1f1f7","o":146,"c":6},"1257":{"n":"flag-ms","u":"1f1f2-1f1f8","o":155,"c":6},"1258":{"n":"flag-mt","u":"1f1f2-1f1f9","o":143,"c":6},"1259":{"n":"flag-mu","u":"1f1f2-1f1fa","o":147,"c":6},"1260":{"n":"flag-mv","u":"1f1f2-1f1fb","o":141,"c":6},"1261":{"n":"flag-mw","u":"1f1f2-1f1fc","o":139,"c":6},"1262":{"n":"flag-mx","u":"1f1f2-1f1fd","o":149,"c":6},"1263":{"n":"flag-my","u":"1f1f2-1f1fe","o":140,"c":6},"1264":{"n":"flag-mz","u":"1f1f2-1f1ff","o":157,"c":6},"1265":{"n":"flag-na","u":"1f1f3-1f1e6","o":159,"c":6},"1266":{"n":"flag-nc","u":"1f1f3-1f1e8","o":163,"c":6},"1267":{"n":"flag-ne","u":"1f1f3-1f1ea","o":166,"c":6},"1268":{"n":"flag-nf","u":"1f1f3-1f1eb","o":169,"c":6},"1269":{"n":"flag-ng","u":"1f1f3-1f1ec","o":167,"c":6},"1270":{"n":"flag-ni","u":"1f1f3-1f1ee","o":165,"c":6},"1271":{"n":"flag-nl","u":"1f1f3-1f1f1","o":162,"c":6},"1272":{"n":"flag-no","u":"1f1f3-1f1f4","o":172,"c":6},"1273":{"n":"flag-np","u":"1f1f3-1f1f5","o":161,"c":6},"1274":{"n":"flag-nr","u":"1f1f3-1f1f7","o":160,"c":6},"1275":{"n":"flag-nu","u":"1f1f3-1f1fa","o":168,"c":6},"1276":{"n":"flag-nz","u":"1f1f3-1f1ff","o":164,"c":6},"1277":{"n":"flag-om","u":"1f1f4-1f1f2","o":173,"c":6},"1278":{"n":"flag-pa","u":"1f1f5-1f1e6","o":177,"c":6},"1279":{"n":"flag-pe","u":"1f1f5-1f1ea","o":180,"c":6},"1280":{"n":"flag-pf","u":"1f1f5-1f1eb","o":85,"c":6},"1281":{"n":"flag-pg","u":"1f1f5-1f1ec","o":178,"c":6},"1282":{"n":"flag-ph","u":"1f1f5-1f1ed","o":181,"c":6},"1283":{"n":"flag-pk","u":"1f1f5-1f1f0","o":174,"c":6},"1284":{"n":"flag-pl","u":"1f1f5-1f1f1","o":183,"c":6},"1285":{"n":"flag-pm","u":"1f1f5-1f1f2","o":195,"c":6},"1286":{"n":"flag-pn","u":"1f1f5-1f1f3","o":182,"c":6},"1287":{"n":"flag-pr","u":"1f1f5-1f1f7","o":185,"c":6},"1288":{"n":"flag-ps","u":"1f1f5-1f1f8","o":176,"c":6},"1289":{"n":"flag-pt","u":"1f1f5-1f1f9","o":184,"c":6},"1290":{"n":"flag-pw","u":"1f1f5-1f1fc","o":175,"c":6},"1291":{"n":"flag-py","u":"1f1f5-1f1fe","o":179,"c":6},"1292":{"n":"flag-qa","u":"1f1f6-1f1e6","o":186,"c":6},"1293":{"n":"flag-re","u":"1f1f7-1f1ea","o":187,"c":6},"1294":{"n":"flag-ro","u":"1f1f7-1f1f4","o":188,"c":6},"1295":{"n":"flag-rs","u":"1f1f7-1f1f8","o":202,"c":6},"1296":{"n":"flag-ru","u":"1f1f7-1f1fa","o":189,"c":6},"1297":{"n":"flag-rw","u":"1f1f7-1f1fc","o":190,"c":6},"1298":{"n":"flag-sa","u":"1f1f8-1f1e6","o":200,"c":6},"1299":{"n":"flag-sb","u":"1f1f8-1f1e7","o":209,"c":6},"1300":{"n":"flag-sc","u":"1f1f8-1f1e8","o":203,"c":6},"1301":{"n":"flag-sd","u":"1f1f8-1f1e9","o":217,"c":6},"1302":{"n":"flag-se","u":"1f1f8-1f1ea","o":220,"c":6},"1303":{"n":"flag-sg","u":"1f1f8-1f1ec","o":205,"c":6},"1304":{"n":"flag-sh","u":"1f1f8-1f1ed","o":192,"c":6},"1305":{"n":"flag-si","u":"1f1f8-1f1ee","o":208,"c":6},"1306":{"n":"flag-sj","u":"1f1f8-1f1ef","o":261,"c":6},"1307":{"n":"flag-sk","u":"1f1f8-1f1f0","o":207,"c":6},"1308":{"n":"flag-sl","u":"1f1f8-1f1f1","o":204,"c":6},"1309":{"n":"flag-sm","u":"1f1f8-1f1f2","o":198,"c":6},"1310":{"n":"flag-sn","u":"1f1f8-1f1f3","o":201,"c":6},"1311":{"n":"flag-so","u":"1f1f8-1f1f4","o":210,"c":6},"1312":{"n":"flag-sr","u":"1f1f8-1f1f7","o":218,"c":6},"1313":{"n":"flag-ss","u":"1f1f8-1f1f8","o":214,"c":6},"1314":{"n":"flag-st","u":"1f1f8-1f1f9","o":199,"c":6},"1315":{"n":"flag-sv","u":"1f1f8-1f1fb","o":73,"c":6},"1316":{"n":"flag-sx","u":"1f1f8-1f1fd","o":206,"c":6},"1317":{"n":"flag-sy","u":"1f1f8-1f1fe","o":222,"c":6},"1318":{"n":"flag-sz","u":"1f1f8-1f1ff","o":219,"c":6},"1319":{"n":"flag-ta","u":"1f1f9-1f1e6","o":262,"c":6},"1320":{"n":"flag-tc","u":"1f1f9-1f1e8","o":235,"c":6},"1321":{"n":"flag-td","u":"1f1f9-1f1e9","o":50,"c":6},"1322":{"n":"flag-tf","u":"1f1f9-1f1eb","o":86,"c":6},"1323":{"n":"flag-tg","u":"1f1f9-1f1ec","o":228,"c":6},"1324":{"n":"flag-th","u":"1f1f9-1f1ed","o":226,"c":6},"1325":{"n":"flag-tj","u":"1f1f9-1f1ef","o":224,"c":6},"1326":{"n":"flag-tk","u":"1f1f9-1f1f0","o":229,"c":6},"1327":{"n":"flag-tl","u":"1f1f9-1f1f1","o":227,"c":6},"1328":{"n":"flag-tm","u":"1f1f9-1f1f2","o":234,"c":6},"1329":{"n":"flag-tn","u":"1f1f9-1f1f3","o":232,"c":6},"1330":{"n":"flag-to","u":"1f1f9-1f1f4","o":230,"c":6},"1331":{"n":"flag-tr","u":"1f1f9-1f1f7","o":233,"c":6},"1332":{"n":"flag-tt","u":"1f1f9-1f1f9","o":231,"c":6},"1333":{"n":"flag-tv","u":"1f1f9-1f1fb","o":236,"c":6},"1334":{"n":"flag-tw","u":"1f1f9-1f1fc","o":223,"c":6},"1335":{"n":"flag-tz","u":"1f1f9-1f1ff","o":225,"c":6},"1336":{"n":"flag-ua","u":"1f1fa-1f1e6","o":238,"c":6},"1337":{"n":"flag-ug","u":"1f1fa-1f1ec","o":237,"c":6},"1338":{"n":"flag-um","u":"1f1fa-1f1f2","o":263,"c":6},"1340":{"n":"flag-us","u":"1f1fa-1f1f8","o":241,"c":6},"1341":{"n":"flag-uy","u":"1f1fa-1f1fe","o":243,"c":6},"1342":{"n":"flag-uz","u":"1f1fa-1f1ff","o":244,"c":6},"1343":{"n":"flag-va","u":"1f1fb-1f1e6","o":246,"c":6},"1344":{"n":"flag-vc","u":"1f1fb-1f1e8","o":196,"c":6},"1345":{"n":"flag-ve","u":"1f1fb-1f1ea","o":247,"c":6},"1346":{"n":"flag-vg","u":"1f1fb-1f1ec","o":38,"c":6},"1347":{"n":"flag-vi","u":"1f1fb-1f1ee","o":242,"c":6},"1348":{"n":"flag-vn","u":"1f1fb-1f1f3","o":248,"c":6},"1349":{"n":"flag-vu","u":"1f1fb-1f1fa","o":245,"c":6},"1350":{"n":"flag-wf","u":"1f1fc-1f1eb","o":249,"c":6},"1351":{"n":"flag-ws","u":"1f1fc-1f1f8","o":197,"c":6},"1352":{"n":"flag-xk","u":"1f1fd-1f1f0","o":124,"c":6},"1353":{"n":"flag-ye","u":"1f1fe-1f1ea","o":251,"c":6},"1354":{"n":"flag-yt","u":"1f1fe-1f1f9","o":148,"c":6},"1355":{"n":"flag-za","u":"1f1ff-1f1e6","o":211,"c":6},"1356":{"n":"flag-zm","u":"1f1ff-1f1f2","o":252,"c":6},"1357":{"n":"flag-zw","u":"1f1ff-1f1fc","o":253,"c":6}},"categories":[{"name":"people","members":[43,51,52,60,61,105,125,126,127,128,201,328,330,343,344,361,387,509,510,511,512,513,514,515,516,517,518,519,520,521,522,523,524,525,526,527,528,529,530,531,532,533,534,535,536,537,538,539,540,541,542,543,544,545,546,547,548,549,550,551,552,553,554,555,556,557,558,559,560,561,562,563,564,565,566,567,568,569,570,571,572,573,574,575,576,577,578,579,580,584,586,588,590,614,615,633,795,796,797,801,807,808,809,826,836,837,838,839,840,841,842,843,844,845,846,847,848,849,850,851,852,853,854,855,856,857,858,859,860,861,862,863,864,865,866,867,868,869,870,871,872,873,874,875,876,877,878,879,880,881,882,883,884,885,886,887,888,889,890,891,892,893,894,895,896,897,898,899,900,901,902,903,904,905,906,907,911,912,913,914,915,970,1008,1009,1010,1011,1012,1013,1014,1015,1016,1017,1018,1019,1020,1021,1022,1023,1024,1025,1026,1027,1028,1029,1030,1031,1032,1033,1034,1035,1036]},{"name":"foods","members":[49,242,243,244,245,251,258,266,267,268,269,270,271,272,273,274,275,276,277,278,279,280,281,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,300,301,302,303,304,305,306,307,308,309,310,311,312,313,314,315,316,317,318,319,320,321,322,323,324,327,1045,1046,1047,1054,1055,1056,1057,1058,1059,1060,1061,1062,1063,1064,1065,1066,1067,1068,1087]},{"name":"nature","members":[41,42,44,45,48,50,93,100,101,102,135,138,161,207,209,212,213,214,216,217,218,219,220,221,222,223,224,225,226,227,228,229,230,233,234,235,236,237,238,239,240,241,246,247,248,249,250,252,253,254,255,256,257,259,260,261,262,263,264,265,329,336,338,445,446,447,448,449,450,451,452,453,454,455,456,457,458,459,460,461,462,463,464,465,466,467,468,469,470,471,472,473,474,475,476,477,478,479,480,481,482,483,484,485,486,487,488,489,490,491,492,493,494,495,496,497,498,499,500,501,502,503,504,505,506,507,508,589,610,611,612,613,616,737,763,798,799,908,909,910,1043,1069,1070,1071,1072,1073,1074,1075,1076,1077,1078,1079,1080,1081,1082,1083,1084,1085,1086]},{"name":"activity","members":[98,99,113,116,117,118,345,346,351,355,356,359,360,362,363,364,365,366,367,368,369,370,371,375,376,377,378,379,380,381,382,383,384,386,388,389,390,391,392,393,394,395,396,399,400,401,402,403,435,437,438,951,968,969,1037,1038,1039,1040,1041,1042,1044,1048,1049,1050,1051,1052,1053]},{"name":"objects","members":[14,15,16,25,26,27,28,46,83,85,87,88,89,96,97,104,106,121,124,129,130,232,325,326,333,334,335,339,340,341,347,348,349,350,357,430,436,439,581,582,583,585,587,606,608,621,624,625,626,627,628,629,632,634,635,636,637,638,639,640,641,642,643,644,645,646,647,648,649,650,651,652,653,654,655,656,657,658,659,660,661,662,663,665,666,667,668,669,670,673,674,675,676,677,678,679,680,681,682,683,684,685,686,687,692,693,694,695,696,697,698,699,711,712,713,714,715,716,717,718,719,722,723,738,739,740,741,742,743,744,745,746,792,793,794,800,802,803,804,805,806,811,812,813,814,815,816,817,818,819,820,821,822,823,824,825,829,958,960,964,977,979,980,981,986,987,988,989,990,993,994,995,996]},{"name":"places","members":[84,108,109,110,111,112,114,115,119,120,123,200,202,203,204,205,206,208,210,211,231,331,332,342,352,353,354,397,398,404,405,406,407,408,409,410,411,412,413,414,415,416,417,418,419,420,421,422,424,425,426,427,428,429,431,432,591,631,764,765,766,830,831,832,833,834,835,916,917,918,919,920,921,922,923,924,925,926,927,928,929,930,931,932,933,934,935,936,937,938,939,940,941,942,943,944,945,946,947,948,949,950,952,953,954,955,956,966,997,998,999,1000,1001,1002,1003,1004,1005,1006,1007]},{"name":"flags","members":[337,385,433,434,957,1100,1101,1102,1103,1104,1105,1106,1107,1108,1109,1110,1111,1112,1113,1114,1115,1116,1117,1118,1119,1120,1121,1122,1123,1124,1125,1126,1127,1128,1129,1130,1131,1132,1133,1134,1135,1136,1137,1138,1139,1140,1141,1142,1143,1144,1145,1146,1147,1148,1149,1150,1151,1152,1153,1154,1155,1156,1157,1158,1159,1160,1161,1162,1163,1164,1165,1166,1167,1168,1169,1170,1171,1172,1173,1174,1175,1176,1177,1178,1179,1180,1181,1182,1183,1184,1185,1186,1187,1188,1189,1190,1191,1192,1193,1194,1195,1196,1197,1198,1199,1200,1201,1202,1203,1204,1205,1206,1207,1208,1209,1210,1211,1212,1213,1214,1215,1216,1217,1218,1219,1220,1221,1222,1223,1224,1225,1226,1227,1228,1229,1230,1231,1232,1233,1234,1235,1236,1237,1238,1239,1240,1241,1242,1243,1244,1245,1246,1247,1248,1249,1250,1251,1252,1253,1254,1255,1256,1257,1258,1259,1260,1261,1262,1263,1264,1265,1266,1267,1268,1269,1270,1271,1272,1273,1274,1275,1276,1277,1278,1279,1280,1281,1282,1283,1284,1285,1286,1287,1288,1289,1290,1291,1292,1293,1294,1295,1296,1297,1298,1299,1300,1301,1302,1303,1304,1305,1306,1307,1308,1309,1310,1311,1312,1313,1314,1315,1316,1317,1318,1319,1320,1321,1322,1323,1324,1325,1326,1327,1328,1329,1330,1331,1332,1333,1334,1335,1336,1337,1338,1340,1341,1342,1343,1344,1345,1346,1347,1348,1349,1350,1351,1352,1353,1354,1355,1356,1357]},{"name":"symbols","members":[0,1,2,3,4,5,6,7,8,9,10,11,12,13,17,18,19,20,21,22,23,24,29,30,31,32,33,34,35,36,37,38,39,40,47,53,54,55,56,57,58,59,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,90,91,92,94,95,103,107,122,131,132,133,134,136,137,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,162,163,164,165,166,167,168,169,170,171,172,173,174,175,176,177,178,179,180,181,182,183,184,185,186,187,188,189,190,191,192,193,194,195,196,197,198,199,215,358,372,373,374,423,592,593,594,595,596,597,598,599,600,601,602,603,604,605,607,609,617,618,619,620,622,623,630,664,671,672,688,689,690,691,700,701,702,703,704,705,706,707,708,709,710,720,721,724,725,726,727,728,729,730,731,732,733,734,735,736,747,748,749,750,751,752,753,754,755,756,757,758,759,760,761,762,767,768,769,770,771,772,773,774,775,776,777,778,779,780,781,782,783,784,785,786,787,788,789,790,791,810,827,828,959,961,962,963,965,967,971,972,973,974,975,976,978,982,983,984,985,991,992,1088,1090,1091,1092,1093,1094,1095,1096,1097,1098,1099]}],"keywords":{"0":[1090],"1":[523,1091],"2":[515,1092],"3":[1093],"4":[1094],"5":[1095],"6":[1096],"7":[1097],"8":[1098],"9":[1099],"100":[620],"1234":[734],"5272":[195],"5408":[190],"6307":[187],"6708":[193],"6709":[192],"7121":[186],"7533":[194],"7981":[188],"copyright":[0],"sign":[0,1,4,53,54,92,93,148,149,150,519,520,521,522,523,524,525,623,625,626,627,628,630,955,959,992,1016],"symbols":[0,1,2,3,4,5,6,7,8,9,10,11,12,13,17,18,19,20,21,22,23,24,29,30,31,32,33,34,35,36,37,38,39,40,47,53,54,55,56,57,58,59,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,90,91,92,94,95,103,107,122,131,132,133,134,136,137,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,162,163,164,165,166,167,168,169,170,171,172,173,174,175,176,177,178,179,180,181,182,183,184,185,186,187,188,189,190,191,192,193,194,195,196,197,198,199,215,358,372,373,374,423,592,593,594,595,596,597,598,599,600,601,602,603,604,605,607,609,617,618,619,620,622,623,630,664,671,672,688,689,690,691,700,701,702,703,704,705,706,707,708,709,710,720,721,724,725,726,727,728,729,730,731,732,733,734,735,736,747,748,749,750,751,752,753,754,755,756,757,758,759,760,761,762,767,768,769,770,771,772,773,774,775,776,777,778,779,780,781,782,783,784,785,786,787,788,789,790,791,810,827,828,959,961,962,963,965,967,971,972,973,974,975,976,978,982,983,984,985,991,992,1088,1090,1091,1092,1093,1094,1095,1096,1097,1098,1099],"registered":[1],"double":[2,18,19,20,21,22,23,24,29,153],"exclamation":[2,3,144,145,146,182,727],"mark":[2,3,4,122,131,140,141,142,143,144,145,146,164,182,584,727],"bangbang":[2],"question":[3,142,143],"interrobang":[3],"trade":[4],"tm":[4,1328],"information":[5,574],"source":[5],"left":[6,8,11,19,23,36,156,517,687,713,727,803,804,805,806,827,985,1019],"right":[6,9,10,13,18,22,24,35,151,518,714,727,828,1020],"arrow":[6,7,8,9,10,11,12,13,20,21,35,36,151,154,155,156,157,158,438,597,678,687,725,726,727,728,729,760,761],"up":[7,20,51,154,157,182,515,522,641,758,760,824],"down":[7,21,155,158,516,523,759,761,903],"north":[8,9],"west":[8,11],"upper":[8,9],"east":[9,10],"south":[10,11],"lower":[10,11,803,804,805,806],"leftwards":[12,156,701,702,725,726],"with":[12,13,22,23,24,28,41,47,48,105,118,182,202,215,225,226,227,228,229,233,235,236,237,238,239,298,322,323,381,406,417,556,557,558,559,560,590,597,602,605,625,626,627,628,629,630,640,645,646,657,678,679,680,681,682,687,691,693,702,707,709,710,715,716,721,725,726,727,728,729,747,767,807,808,809,815,829,837,838,839,840,841,842,843,844,846,849,850,855,861,862,863,864,865,872,874,882,884,891,892,893,894,895,896,897,904,905,906,914,915,921,1010,1013,1022,1023,1044],"hook":[12,13],"rightwards":[13,151,154,155,687,700,701,702,728],"watch":[14],"objects":[14,15,16,25,26,27,28,46,83,85,87,88,89,96,97,104,106,121,124,129,130,232,325,326,333,334,335,339,340,341,347,348,349,350,357,430,436,439,581,582,583,585,587,606,608,621,624,625,626,627,628,629,632,634,635,636,637,638,639,640,641,642,643,644,645,646,647,648,649,650,651,652,653,654,655,656,657,658,659,660,661,662,663,665,666,667,668,669,670,673,674,675,676,677,678,679,680,681,682,683,684,685,686,687,692,693,694,695,696,697,698,699,711,712,713,714,715,716,717,718,719,722,723,738,739,740,741,742,743,744,745,746,792,793,794,800,802,803,804,805,806,811,812,813,814,815,816,817,818,819,820,821,822,823,824,825,829,958,960,964,977,979,980,981,986,987,988,989,990,993,994,995,996],"hourglass":[15,28],"keyboard":[16,377],"eject":[17],"symbol":[17,57,81,82,90,145,216,217,218,219,220,221,222,223,607,609,610,611,613,616,620,676,705,706,723,730,732,733,734,735,736,748,762,960,961,962,963,964,965,973,974,976,1100,1101,1102,1103,1104,1105,1106,1107,1108,1109,1110,1111,1112,1113,1114,1115,1116,1117,1118,1119,1120,1121,1122,1123,1124,1125,1126,1127,1128,1129,1130,1131,1132,1133,1134,1135,1136,1137,1138,1139,1140,1141,1142,1143,1144,1145,1146,1147,1148,1149,1150,1151,1152,1153,1154,1155,1156,1157,1158,1159,1160,1161,1162,1163,1164,1165,1166,1167,1168,1169,1170,1171,1172,1173,1174,1175,1176,1177,1178,1179,1180,1181,1182,1183,1184,1185,1186,1187,1188,1189,1190,1191,1192,1193,1194,1195,1196,1197,1198,1199,1200,1201,1202,1203,1204,1205,1206,1207,1208,1209,1210,1211,1212,1213,1214,1215,1216,1217,1218,1219,1220,1221,1222,1223,1224,1225,1226,1227,1228,1229,1230,1231,1232,1233,1234,1235,1236,1237,1238,1239,1240,1241,1242,1243,1244,1245,1246,1247,1248,1249,1250,1251,1252,1253,1254,1255,1256,1257,1258,1259,1260,1261,1262,1263,1264,1265,1266,1267,1268,1269,1270,1271,1272,1273,1274,1275,1276,1277,1278,1279,1280,1281,1282,1283,1284,1285,1286,1287,1288,1289,1290,1291,1292,1293,1294,1295,1296,1297,1298,1299,1300,1301,1302,1303,1304,1305,1306,1307,1308,1309,1310,1311,1312,1313,1314,1315,1316,1317,1318,1319,1320,1321,1322,1323,1324,1325,1326,1327,1328,1329,1330,1331,1332,1333,1334,1335,1336,1337,1338,1340,1341,1342,1343,1344,1345,1346,1347,1348,1349,1350,1351,1352,1353,1354,1355,1356,1357],"black":[18,19,20,21,22,23,24,30,31,33,35,36,38,40,41,46,76,77,78,79,81,95,121,130,137,142,147,151,156,157,158,159,168,434,750,810],"pointing":[18,19,20,21,22,23,24,35,36,51,154,155,515,516,517,518,713,714,758,759,760,761],"triangle":[18,19,20,21,22,23,24,35,36,758,759,760,761],"fast":[18],"forward":[18,35],"rewind":[19],"vertical":[22,23,24,29,954],"bar":[22,23,24,29,304,647],"alarm":[25],"clock":[25,27,768,769,770,771,772,773,774,775,776,777,778,779,780,781,782,783,784,785,786,787,788,789,790,791,793],"stopwatch":[26],"timer":[27],"flowing":[28],"sand":[28],"square":[30,33,34,37,38,39,40,159,160,750,751],"for":[30,31,732,733,734,735,736,748],"stop":[30,931],"circle":[31,94,95,162,701,702,703,704,752,753],"record":[31],"circled":[32,165,166,197,198,702],"latin":[32,133,169,170,171,172,732,733,736],"capital":[32,169,170,171,172,732],"letter":[32,169,170,171,172,585],"m":[32],"small":[33,34,39,40,233,733,756,757,758,759,760,761,1000],"white":[34,37,39,51,60,61,94,105,122,143,144,160,161,233,234,235,433,515,516,517,518,619,751],"backward":[36],"medium":[37,38,39,40,94,95,161],"sun":[41,101,229,233,234,235],"rays":[41],"nature":[41,42,44,45,48,50,93,100,101,102,135,138,161,207,209,212,213,214,216,217,218,219,220,221,222,223,224,225,226,227,228,229,230,233,234,235,236,237,238,239,240,241,246,247,248,249,250,252,253,254,255,256,257,259,260,261,262,263,264,265,329,336,338,445,446,447,448,449,450,451,452,453,454,455,456,457,458,459,460,461,462,463,464,465,466,467,468,469,470,471,472,473,474,475,476,477,478,479,480,481,482,483,484,485,486,487,488,489,490,491,492,493,494,495,496,497,498,499,500,501,502,503,504,505,506,507,508,589,610,611,612,613,616,737,763,798,799,908,909,910,1043,1069,1070,1071,1072,1073,1074,1075,1076,1077,1078,1079,1080,1081,1082,1083,1084,1085,1086],"sunny":[41,101,233,234,235],"cloud":[42,101,102,233,234,235,236,237,238,239],"umbrella":[43,48,111,201,406],"people":[43,51,52,60,61,105,125,126,127,128,201,328,330,343,344,361,387,509,510,511,512,513,514,515,516,517,518,519,520,521,522,523,524,525,526,527,528,529,530,531,532,533,534,535,536,537,538,539,540,541,542,543,544,545,546,547,548,549,550,551,552,553,554,555,556,557,558,559,560,561,562,563,564,565,566,567,568,569,570,571,572,573,574,575,576,577,578,579,580,584,586,588,590,614,615,633,795,796,797,801,807,808,809,826,836,837,838,839,840,841,842,843,844,845,846,847,848,849,850,851,852,853,854,855,856,857,858,859,860,861,862,863,864,865,866,867,868,869,870,871,872,873,874,875,876,877,878,879,880,881,882,883,884,885,886,887,888,889,890,891,892,893,894,895,896,897,898,899,900,901,902,903,904,905,906,907,911,912,913,914,915,970,1008,1009,1010,1011,1012,1013,1014,1015,1016,1017,1018,1019,1020,1021,1022,1023,1024,1025,1026,1027,1028,1029,1030,1031,1032,1033,1034,1035,1036],"snowman":[44,100],"comet":[45],"telephone":[46,667],"phone":[46,686,687,689],"ballot":[47,829],"box":[47,310,817,829],"check":[47,122,131],"rain":[48,102,235,236],"drops":[48,611],"hot":[49,80,242,251],"beverage":[49],"foods":[49,242,243,244,245,251,258,266,267,268,269,270,271,272,273,274,275,276,277,278,279,280,281,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,300,301,302,303,304,305,306,307,308,309,310,311,312,313,314,315,316,317,318,319,320,321,322,323,324,327,1045,1046,1047,1054,1055,1056,1057,1058,1059,1060,1061,1062,1063,1064,1065,1066,1067,1068,1087],"coffee":[49],"shamrock":[50],"index":[51,515,516,517,518,644,816,1022],"point":[51,515,516,517,518],"skull":[52,573],"and":[52,56,83,102,288,313,315,322,355,382,383,384,399,401,402,403,437,438,552,630,701,702,703,704,741,809,840,841,842,864,865,884,986,994,1022],"crossbones":[52],"radioactive":[53],"biohazard":[54],"orthodox":[55],"cross":[55,105,133,140,141],"star":[56,134,137,161,230,231,747],"crescent":[56,217,223,224],"peace":[57,763],"yin":[58],"yang":[58],"wheel":[59,353],"of":[59,134,258,259,282,311,614,763,833,834,838,872,893,991,1016,1018,1062,1065],"dharma":[59],"frowning":[60,874,901,913],"face":[60,61,225,226,227,228,229,241,490,491,492,493,494,495,497,498,499,500,501,502,503,504,505,579,768,769,770,771,772,773,774,775,776,777,778,779,780,781,782,783,784,785,786,787,788,789,790,791,836,837,838,839,840,841,842,843,844,845,846,847,848,849,850,851,852,853,854,855,856,857,858,859,860,861,862,863,864,865,866,867,868,869,870,871,872,873,874,875,876,877,878,879,880,881,882,883,884,885,886,887,888,889,890,891,892,893,894,895,896,897,898,899,900,901,902,903,904,905,906,914,1008,1009,1010,1011,1012,1013,1014,1015,1023,1024,1025,1027,1028,1029,1030,1070,1073,1079],"smiling":[61,837,839,840,841,842,843,844,846,849,850,861,892,894,895,902],"relaxed":[61],"aries":[64],"taurus":[65],"gemini":[66],"cancer":[67],"leo":[68],"virgo":[69],"libra":[70],"scorpius":[71],"sagittarius":[72],"capricorn":[73],"aquarius":[74],"pisces":[75],"spade":[76],"suit":[76,77,78,79,795],"spades":[76],"club":[77],"clubs":[77],"heart":[78,146,147,590,592,593,595,596,597,598,599,600,601,602,604,810,849,860,895],"hearts":[78,594,603],"diamond":[79,605,754,755,756,757],"diamonds":[79],"springs":[80],"hotsprings":[80],"universal":[81],"recycling":[81],"recycle":[81],"wheelchair":[82],"hammer":[83,740,994],"pick":[83,104],"anchor":[84],"places":[84,108,109,110,111,112,114,115,119,120,123,200,202,203,204,205,206,208,210,211,231,331,332,342,352,353,354,397,398,404,405,406,407,408,409,410,411,412,413,414,415,416,417,418,419,420,421,422,424,425,426,427,428,429,431,432,591,631,764,765,766,830,831,832,833,834,835,916,917,918,919,920,921,922,923,924,925,926,927,928,929,930,931,932,933,934,935,936,937,938,939,940,941,942,943,944,945,946,947,948,949,950,952,953,954,955,956,966,997,998,999,1000,1001,1002,1003,1004,1005,1006,1007],"crossed":[85,337,1022],"swords":[85],"scales":[87],"alembic":[88],"gear":[89],"atom":[90],"fleur":[91],"de":[91,1158],"lis":[91],"warning":[92],"high":[93,541,706,920,921],"voltage":[93],"zap":[93],"coffin":[96],"funeral":[97],"urn":[97],"soccer":[98],"ball":[98,118,286,335,382,399,401,403,746],"activity":[98,99,113,116,117,118,345,346,351,355,356,359,360,362,363,364,365,366,367,368,369,370,371,375,376,377,378,379,380,381,382,383,384,386,388,389,390,391,392,393,394,395,396,399,400,401,402,403,435,437,438,951,968,969,1037,1038,1039,1040,1041,1042,1044,1048,1049,1050,1051,1052,1053],"baseball":[99],"without":[100,314,890],"snow":[100,237,404],"behind":[101,234,235],"partly":[101,235],"thunder":[102],"ophiuchus":[103],"helmet":[105],"chains":[106],"no":[107,682,690,721,730,890,905,908,909,910,959,961,967,971,1272],"entry":[107,959],"shinto":[108],"shrine":[108],"church":[109],"mountain":[110,404,946,948,969],"on":[111,283,727,957,1026],"ground":[111],"fountain":[112,804],"flag":[113,385,433,434,679,680,681,682,957,1100,1101,1102,1103,1104,1105,1106,1107,1108,1109,1110,1111,1112,1113,1114,1115,1116,1117,1118,1119,1120,1121,1122,1123,1124,1125,1126,1127,1128,1129,1130,1131,1132,1133,1134,1135,1136,1137,1138,1139,1140,1141,1142,1143,1144,1145,1146,1147,1148,1149,1150,1151,1152,1153,1154,1155,1156,1157,1158,1159,1160,1161,1162,1163,1164,1165,1166,1167,1168,1169,1170,1171,1172,1173,1174,1175,1176,1177,1178,1179,1180,1181,1182,1183,1184,1185,1186,1187,1188,1189,1190,1191,1192,1193,1194,1195,1196,1197,1198,1199,1200,1201,1202,1203,1204,1205,1206,1207,1208,1209,1210,1211,1212,1213,1214,1215,1216,1217,1218,1219,1220,1221,1222,1223,1224,1225,1226,1227,1228,1229,1230,1231,1232,1233,1234,1235,1236,1237,1238,1239,1240,1241,1242,1243,1244,1245,1246,1247,1248,1249,1250,1251,1252,1253,1254,1255,1256,1257,1258,1259,1260,1261,1262,1263,1264,1265,1266,1267,1268,1269,1270,1271,1272,1273,1274,1275,1276,1277,1278,1279,1280,1281,1282,1283,1284,1285,1286,1287,1288,1289,1290,1291,1292,1293,1294,1295,1296,1297,1298,1299,1300,1301,1302,1303,1304,1305,1306,1307,1308,1309,1310,1311,1312,1313,1314,1315,1316,1317,1318,1319,1320,1321,1322,1323,1324,1325,1326,1327,1328,1329,1330,1331,1332,1333,1334,1335,1336,1337,1338,1340,1341,1342,1343,1344,1345,1346,1347,1348,1349,1350,1351,1352,1353,1354,1355,1356,1357],"in":[113,264,545,546,795,826,885,912,962,1034,1210],"hole":[113,794],"golf":[113],"ferry":[114],"sailboat":[115],"boat":[115,999],"skier":[116],"ice":[117,299,300,301,402],"skate":[117],"person":[118,558,574,907,911,912,913,914,915,1037],"tent":[119,362],"fuel":[120],"pump":[120],"fuelpump":[120],"scissors":[121],"heavy":[122,131,132,145,146,147,148,149,150,162,623],"airplane":[123,1000,1001,1002],"envelope":[124,677,678],"email":[124],"raised":[125,126,680,681,807,809,912,1018],"fist":[125,1019,1020],"hand":[126,127,128,519,520,521,807,808,809,911,1017,1018,1022],"victory":[127],"v":[127],"writing":[128],"pencil":[129,666],"pencil2":[129],"nib":[130],"multiplication":[132],"x":[132,140],"david":[134],"sparkles":[135],"eight":[136,137,775,787,1098],"spoked":[136],"asterisk":[136],"pointed":[137,747],"snowflake":[138],"sparkle":[139],"negative":[141,169,170,171,172,173],"squared":[141,169,170,171,172,173,174,175,176,177,178,179,180,181,182,183,184,185,186,187,188,189,190,191,192,193,194,195,196],"ornament":[142,143,144,146],"grey":[143,144],"plus":[148],"minus":[149],"division":[150],"curly":[152,153],"loop":[152,153],"then":[154,155],"curving":[154,155],"upwards":[154,157,630,645,703,704,729],"heading":[154,155],"downwards":[155,158,646,678,703,704],"large":[159,160,162,752,753,754,755],"o":[162,171,328],"wavy":[163],"dash":[163,613],"part":[164,809],"alternation":[164],"ideograph":[165,166,186,187,188,189,190,191,192,193,194,195,196,197,198],"congratulation":[165],"congratulations":[165],"secret":[166],"mahjong":[167],"tile":[167],"red":[167,275,752,758,759,760,761,939],"dragon":[167,454,495],"playing":[168,372],"card":[168,624,644,816,817],"joker":[168],"a":[169,605,860],"b":[170],"o2":[171],"p":[172],"parking":[172],"ab":[173],"cl":[174,1146],"cool":[175],"free":[176],"id":[177,1206],"new":[178,216,225],"ng":[179,1269],"ok":[180,521,906],"sos":[181],"vs":[183],"katakana":[184,185],"koko":[184],"sa":[185,1298],"cjk":[186,187,188,189,190,191,192,193,194,195,196],"unified":[186,187,188,189,190,191,192,193,194,195,196],"u7121":[186],"u6307":[187],"u7981":[188],"7a7a":[189],"u7a7a":[189],"u5408":[190],"6e80":[191],"u6e80":[191],"u6709":[192],"u6708":[193],"u7533":[194],"u5272":[195],"55b6":[196],"u55b6":[196],"advantage":[197],"accept":[198],"cyclone":[199],"foggy":[200],"closed":[201,658,679,680,716,842,862,865,897],"night":[202,208],"stars":[202,231],"sunrise":[203,204,206],"over":[203,206],"mountains":[203],"cityscape":[205,409],"at":[205,208,687,1112],"dusk":[205],"city":[205,206],"sunset":[205,206],"buildings":[206,408],"rainbow":[207],"bridge":[208],"water":[209,448,964,965,978,1041],"wave":[209,520,709],"ocean":[209],"volcano":[210],"milky":[211],"way":[211],"earth":[212,213,214],"globe":[212,213,214,215],"europe":[212],"africa":[212],"americas":[213],"asia":[214],"australia":[214],"meridians":[215],"moon":[216,217,218,219,220,221,222,223,224,225,226,227,228,342],"waxing":[217,219],"first":[218,226,1049],"quarter":[218,222,226,227],"gibbous":[219,221],"full":[220,228],"waning":[221,223],"last":[222,227],"glowing":[230],"star2":[230],"shooting":[231],"thermometer":[232,1010],"mostly":[233],"barely":[234],"lightning":[238],"tornado":[239],"fog":[240],"wind":[241,264,341],"blowing":[241],"dog":[242,466,499],"hotdog":[242],"taco":[243],"burrito":[244],"chestnut":[245],"seedling":[246],"evergreen":[247],"tree":[247,248,249,329,336],"deciduous":[248],"palm":[249,1029],"cactus":[250],"pepper":[251],"tulip":[252],"cherry":[253],"blossom":[253,257],"rose":[254],"hibiscus":[255],"sunflower":[256],"ear":[258,259,511],"maize":[258],"corn":[258],"rice":[259,285,286,287,288,342],"herb":[260],"four":[261,771,783,1094],"leaf":[261,262,263,264],"clover":[261],"maple":[262],"fallen":[263],"fluttering":[264],"leaves":[264],"mushroom":[265],"tomato":[266],"aubergine":[267],"eggplant":[267],"grapes":[268],"melon":[269],"watermelon":[270],"tangerine":[271],"lemon":[272],"banana":[273],"pineapple":[274],"apple":[275,276],"green":[276,599,660,1061],"pear":[277],"peach":[278],"cherries":[279],"strawberry":[280],"hamburger":[281],"slice":[282],"pizza":[282],"meat":[283],"bone":[283],"poultry":[284],"leg":[284],"cracker":[285],"cooked":[287],"curry":[288],"steaming":[289],"bowl":[289],"ramen":[289],"spaghetti":[290],"bread":[291,1060],"french":[292],"fries":[292],"roasted":[293],"sweet":[293],"potato":[293,1058],"dango":[294],"oden":[295],"sushi":[296],"fried":[297,312],"shrimp":[297,1085],"fish":[298,355,476,477],"cake":[298,309,327],"swirl":[298],"design":[298],"soft":[299],"cream":[299,301],"icecream":[299],"shaved":[300],"doughnut":[302],"cookie":[303],"chocolate":[304],"candy":[305],"lollipop":[306],"custard":[307],"honey":[308],"pot":[308,311],"shortcake":[309],"bento":[310],"food":[311,847,1062],"stew":[311],"cooking":[312],"egg":[312,1064],"fork":[313,322],"knife":[313,322,742,825],"teacup":[314],"handle":[314],"tea":[314],"sake":[315],"bottle":[315,321,323],"cup":[315],"wine":[316],"glass":[316,317,713,714,1046,1065],"cocktail":[317],"tropical":[318,477],"drink":[318],"beer":[319,320],"mug":[319],"clinking":[320,1045],"mugs":[320],"beers":[320],"baby":[321,481,482,563,569,976],"plate":[322],"popping":[323],"cork":[323],"champagne":[323],"popcorn":[324],"ribbon":[325,346,602],"wrapped":[326],"present":[326],"gift":[326,602],"birthday":[327],"jack":[328],"lantern":[328,430],"christmas":[329,330,1035],"father":[330],"santa":[330],"fireworks":[331],"firework":[332],"sparkler":[332],"balloon":[333,617,618],"party":[334],"popper":[334],"tada":[334],"confetti":[335],"tanabata":[336],"flags":[337,340,385,433,434,957,1100,1101,1102,1103,1104,1105,1106,1107,1108,1109,1110,1111,1112,1113,1114,1115,1116,1117,1118,1119,1120,1121,1122,1123,1124,1125,1126,1127,1128,1129,1130,1131,1132,1133,1134,1135,1136,1137,1138,1139,1140,1141,1142,1143,1144,1145,1146,1147,1148,1149,1150,1151,1152,1153,1154,1155,1156,1157,1158,1159,1160,1161,1162,1163,1164,1165,1166,1167,1168,1169,1170,1171,1172,1173,1174,1175,1176,1177,1178,1179,1180,1181,1182,1183,1184,1185,1186,1187,1188,1189,1190,1191,1192,1193,1194,1195,1196,1197,1198,1199,1200,1201,1202,1203,1204,1205,1206,1207,1208,1209,1210,1211,1212,1213,1214,1215,1216,1217,1218,1219,1220,1221,1222,1223,1224,1225,1226,1227,1228,1229,1230,1231,1232,1233,1234,1235,1236,1237,1238,1239,1240,1241,1242,1243,1244,1245,1246,1247,1248,1249,1250,1251,1252,1253,1254,1255,1256,1257,1258,1259,1260,1261,1262,1263,1264,1265,1266,1267,1268,1269,1270,1271,1272,1273,1274,1275,1276,1277,1278,1279,1280,1281,1282,1283,1284,1285,1286,1287,1288,1289,1290,1291,1292,1293,1294,1295,1296,1297,1298,1299,1300,1301,1302,1303,1304,1305,1306,1307,1308,1309,1310,1311,1312,1313,1314,1315,1316,1317,1318,1319,1320,1321,1322,1323,1324,1325,1326,1327,1328,1329,1330,1331,1332,1333,1334,1335,1336,1337,1338,1340,1341,1342,1343,1344,1345,1346,1347,1348,1349,1350,1351,1352,1353,1354,1355,1356,1357],"pine":[338],"decoration":[338,604],"bamboo":[338],"japanese":[339,419,431,566,567,748],"dolls":[339],"carp":[340],"streamer":[340],"chime":[341],"viewing":[342],"ceremony":[342],"scene":[342],"school":[343,427],"satchel":[343],"graduation":[344],"cap":[344],"mortar":[344],"board":[344,364],"military":[345],"medal":[345,389,1049,1050,1051],"reminder":[346],"studio":[347],"microphone":[347,356],"level":[348],"slider":[348],"control":[349,982],"knobs":[349],"film":[350,698],"frames":[350],"admission":[351],"tickets":[351],"carousel":[352],"horse":[352,391,459,497],"ferris":[353],"roller":[354],"coaster":[354],"fishing":[355],"pole":[355,581],"movie":[357],"camera":[357,692,693,694],"cinema":[358],"headphone":[359],"headphones":[359],"artist":[360],"palette":[360],"art":[360],"top":[361,729],"hat":[361,527,1023],"tophat":[361],"circus":[362],"ticket":[363],"clapper":[364],"performing":[365],"arts":[365,1053],"video":[366,694],"game":[366,370],"direct":[367],"hit":[367],"dart":[367],"slot":[368],"machine":[368,423,669],"billiards":[369],"8ball":[369],"die":[370],"bowling":[371],"flower":[372,619,1043],"cards":[372],"musical":[373,374,377,380],"note":[373,820],"multiple":[374],"notes":[374],"saxophone":[375],"guitar":[376],"trumpet":[378],"violin":[379],"score":[380],"running":[381,387],"shirt":[381,530],"sash":[381],"tennis":[382,403],"racquet":[382,437],"ski":[383],"boot":[383,543],"basketball":[384],"hoop":[384],"chequered":[385],"checkered":[385],"snowboarder":[386],"runner":[387],"surfer":[388],"sports":[389],"trophy":[390],"racing":[391,397,398],"american":[392],"football":[392,393],"rugby":[393],"swimmer":[394],"weight":[395],"lifter":[395],"golfer":[396],"motorcycle":[397],"car":[398,919,927,935,936,939,941],"cricket":[399],"bat":[399,1076],"volleyball":[400],"field":[401],"hockey":[401,402],"stick":[401,402],"puck":[402],"table":[403],"paddle":[403],"capped":[404],"camping":[405],"beach":[406],"building":[407,410,411,416,418],"construction":[407,564,955],"house":[408,410,416,417],"derelict":[410],"classical":[411],"desert":[412,413],"island":[413],"national":[414],"park":[414],"stadium":[415],"garden":[417],"office":[418,419,420],"post":[419,420,957],"european":[420,432],"hospital":[421],"bank":[422],"automated":[423],"teller":[423],"atm":[423],"hotel":[424,425],"love":[425,585],"convenience":[426],"store":[426,428],"department":[428],"factory":[429],"izakaya":[430],"castle":[431,432],"waving":[433,434,520],"rosette":[435],"label":[436],"badminton":[437],"shuttlecock":[437],"bow":[438,907],"amphora":[439],"rat":[445],"mouse":[446,490,813],"mouse2":[446],"ox":[447],"buffalo":[448],"cow":[449,491],"cow2":[449],"tiger":[450,492],"tiger2":[450],"leopard":[451],"rabbit":[452,493],"rabbit2":[452],"cat":[453,494,892,893,894,895,896,897,898,899,900],"cat2":[453],"crocodile":[455],"whale":[456,496],"whale2":[456],"snail":[457],"snake":[458],"racehorse":[459],"ram":[460],"goat":[461],"sheep":[462],"monkey":[463,498,908,909,910],"rooster":[464],"chicken":[465],"dog2":[466],"pig":[467,500,506],"pig2":[467],"boar":[468],"elephant":[469],"octopus":[470],"spiral":[471,820,821],"shell":[471],"bug":[472],"ant":[473],"honeybee":[474],"bee":[474],"lady":[475],"beetle":[475],"blowfish":[478],"turtle":[479],"hatching":[480],"chick":[480,481,482],"front":[482,921],"facing":[482,641,1019,1020],"hatched":[482],"bird":[483],"penguin":[484],"koala":[485],"poodle":[486],"dromedary":[487],"camel":[487,488],"bactrian":[488],"dolphin":[489],"flipper":[489],"spouting":[496],"frog":[501],"hamster":[502],"wolf":[503],"bear":[504],"panda":[505],"nose":[506,512,921],"paw":[507],"prints":[507],"feet":[507],"chipmunk":[508],"eyes":[509,837,840,842,846,849,861,862,865,892,895,897,904],"eye":[510,864],"mouth":[513,839,840,841,842,874,882,884,890,894,1008,1009],"lips":[513],"tongue":[514,863,864,865],"backhand":[515,516,517,518],"fisted":[519],"facepunch":[519],"punch":[519],"thumbs":[522,523],"+1":[522],"thumbsup":[522],"":[523],"thumbsdown":[523],"clapping":[524],"hands":[524,525,552,553,554,912,915],"clap":[524],"open":[525,639,659,681,682,701,702,703,704,719,839,840,841,842,874,882,884,894],"crown":[526],"womans":[527,535,542,543],"eyeglasses":[528],"necktie":[529],"t":[530],"tshirt":[530],"jeans":[531],"dress":[532],"kimono":[533],"bikini":[534],"clothes":[535],"purse":[536],"handbag":[537],"pouch":[538],"mans":[539],"shoe":[539,540,541],"athletic":[540],"heeled":[541],"heel":[541],"sandal":[542],"boots":[543],"footprints":[544],"bust":[545],"silhouette":[545,546,826,834],"busts":[546],"boy":[547,551],"girl":[548],"man":[549,551,552,559,560,561,795,801,1034],"woman":[550,551,552,556,562,906,1031],"family":[551],"holding":[552,553,554],"couple":[552,590],"two":[553,554,594,769,781,1092],"men":[553],"women":[554],"police":[555,935,936,956],"officer":[555],"cop":[555],"bunny":[556],"ears":[556],"dancers":[556],"bride":[557],"veil":[557],"blond":[558],"hair":[558],"gua":[559],"pi":[559],"mao":[559],"turban":[560],"older":[561,562],"worker":[564],"princess":[565],"ogre":[566],"goblin":[567],"ghost":[568],"angel":[569],"extraterrestrial":[570],"alien":[570,571],"monster":[571],"space":[571],"invader":[571],"imp":[572,844],"desk":[574],"guardsman":[575],"dancer":[576],"lipstick":[577],"nail":[578],"polish":[578],"care":[578],"massage":[579],"haircut":[580],"barber":[581],"syringe":[582],"pill":[583],"kiss":[584,588,860],"ring":[586,809],"gem":[587],"stone":[587],"couplekiss":[588],"bouquet":[589],"wedding":[591],"beating":[592],"heartbeat":[592],"broken":[593],"sparkling":[595],"growing":[596],"heartpulse":[596],"cupid":[597],"blue":[598,661,753,755,757,941],"yellow":[600],"purple":[601],"revolving":[603,956],"shape":[605],"dot":[605,747],"inside":[605],"electric":[606,712,738],"light":[606,924,953,954,956],"bulb":[606],"anger":[607,828],"bomb":[608],"sleeping":[609,888,987],"zzz":[609],"collision":[610],"boom":[610],"splashing":[611],"sweat":[611,841,855,884],"droplet":[612],"pile":[614],"poo":[614],"hankey":[614],"poop":[614],"shit":[614],"flexed":[615],"biceps":[615],"muscle":[615],"dizzy":[616,889],"speech":[617,827],"thought":[618],"hundred":[620],"points":[620],"money":[621,629,1009],"bag":[621],"moneybag":[621],"currency":[622],"exchange":[622],"dollar":[623,626],"credit":[624],"banknote":[625,626,627,628],"yen":[625,630],"euro":[627],"pound":[628],"wings":[629],"chart":[630,645,646,647],"trend":[630,645,646],"seat":[631],"personal":[632],"computer":[632,811],"briefcase":[633],"minidisc":[634],"floppy":[635],"disk":[635],"optical":[636],"disc":[636],"cd":[636,1140],"dvd":[637],"file":[638,639,817,818],"folder":[638,639],"page":[640,641],"curl":[640],"calendar":[642,643,821],"date":[642],"tear":[643],"off":[643,689],"clipboard":[648],"pushpin":[649,650],"round":[650],"paperclip":[651],"straight":[652],"ruler":[652,653],"triangular":[653,957],"bookmark":[654,722],"tabs":[654],"ledger":[655],"notebook":[656,657],"decorative":[657],"cover":[657],"book":[658,659,660,661,662],"orange":[662,754,756],"books":[663],"name":[664],"badge":[664],"scroll":[665],"memo":[666],"receiver":[667],"pager":[668],"fax":[669],"satellite":[670,1003],"antenna":[670,691],"public":[671],"address":[671],"loudspeaker":[671],"cheering":[672],"megaphone":[672],"mega":[672],"outbox":[673],"tray":[673,674],"inbox":[674],"package":[675],"e":[676],"mail":[676,681,682],"incoming":[677],"above":[678,725,726,727,728,729],"mailbox":[679,680,681,682],"lowered":[679,682],"postbox":[683],"postal":[684],"horn":[684],"newspaper":[685,824],"mobile":[686,687,689,690],"iphone":[686],"calling":[687],"vibration":[688],"mode":[688],"phones":[690],"bars":[691],"signal":[691],"strength":[691],"flash":[693],"television":[695],"tv":[695,1333],"radio":[696,724],"videocassette":[697],"vhs":[697],"projector":[698],"prayer":[699],"beads":[699],"twisted":[700],"arrows":[700,701,702,703,704],"clockwise":[701,702,703],"repeat":[701,702],"one":[702,709,730,768,780,911,1091],"overlay":[702],"anticlockwise":[704],"counterclockwise":[704],"low":[705],"brightness":[705,706],"speaker":[707,708,709,710],"cancellation":[707,721],"stroke":[707,721],"mute":[707],"sound":[709,710],"three":[710,770,782,813,1093],"waves":[710],"loud":[710],"battery":[711],"plug":[712],"magnifying":[713,714],"mag":[713,714],"lock":[715,716,718,719],"ink":[715],"pen":[715,803,804],"key":[716,717,823,1088],"unlock":[719],"bell":[720,721,989],"link":[723],"button":[724,750,751,813],"back":[725,1018],"end":[726],"soon":[728],"under":[730],"eighteen":[730],"underage":[730],"keycap":[731,1090,1091,1092,1093,1094,1095,1096,1097,1098,1099],"ten":[731,777,789],"input":[732,733,734,735,736],"letters":[732,733,736,1100,1101,1102,1103,1104,1105,1106,1107,1108,1109,1110,1111,1112,1113,1114,1115,1116,1117,1118,1119,1120,1121,1122,1123,1124,1125,1126,1127,1128,1129,1130,1131,1132,1133,1134,1135,1136,1137,1138,1139,1140,1141,1142,1143,1144,1145,1146,1147,1148,1149,1150,1151,1152,1153,1154,1155,1156,1157,1158,1159,1160,1161,1162,1163,1164,1165,1166,1167,1168,1169,1170,1171,1172,1173,1174,1175,1176,1177,1178,1179,1180,1181,1182,1183,1184,1185,1186,1187,1188,1189,1190,1191,1192,1193,1194,1195,1196,1197,1198,1199,1200,1201,1202,1203,1204,1205,1206,1207,1208,1209,1210,1211,1212,1213,1214,1215,1216,1217,1218,1219,1220,1221,1222,1223,1224,1225,1226,1227,1228,1229,1230,1231,1232,1233,1234,1235,1236,1237,1238,1239,1240,1241,1242,1243,1244,1245,1246,1247,1248,1249,1250,1251,1252,1253,1254,1255,1256,1257,1258,1259,1260,1261,1262,1263,1264,1265,1266,1267,1268,1269,1270,1271,1272,1273,1274,1275,1276,1277,1278,1279,1280,1281,1282,1283,1284,1285,1286,1287,1288,1289,1290,1291,1292,1293,1294,1295,1296,1297,1298,1299,1300,1301,1302,1303,1304,1305,1306,1307,1308,1309,1310,1311,1312,1313,1314,1315,1316,1317,1318,1319,1320,1321,1322,1323,1324,1325,1326,1327,1328,1329,1330,1331,1332,1333,1334,1335,1336,1337,1338,1340,1341,1342,1343,1344,1345,1346,1347,1348,1349,1350,1351,1352,1353,1354,1355,1356,1357],"abcd":[732,733],"numbers":[734],"abc":[736],"fire":[737,934],"torch":[738],"flashlight":[738],"wrench":[739,994],"nut":[741],"bolt":[741],"hocho":[742],"pistol":[743],"gun":[743],"microscope":[744],"telescope":[745],"crystal":[746],"six":[747,773,785,1096],"middle":[747,808,809,1022],"beginner":[748],"trident":[749],"emblem":[749],"om":[762,1277],"dove":[763],"kaaba":[764],"mosque":[765],"synagogue":[766],"menorah":[767],"nine":[767,776,788,1099],"branches":[767],"oclock":[768,769,770,771,772,773,774,775,776,777,778,779],"clock1":[768],"clock2":[769],"clock3":[770],"clock4":[771],"five":[772,784,1095],"clock5":[772],"clock6":[773],"seven":[774,786,1097],"clock7":[774],"clock8":[775],"clock9":[776],"clock10":[777],"eleven":[778,790],"clock11":[778],"twelve":[779,791],"clock12":[779],"thirty":[780,781,782,783,784,785,786,787,788,789,790,791],"clock130":[780],"clock230":[781],"clock330":[782],"clock430":[783],"clock530":[784],"clock630":[785],"clock730":[786],"clock830":[787],"clock930":[788],"clock1030":[789],"clock1130":[790],"clock1230":[791],"candle":[792],"mantelpiece":[793],"business":[795],"levitating":[795],"sleuth":[796],"or":[796],"spy":[796],"dark":[797],"sunglasses":[797,850],"spider":[798,799],"web":[799],"joystick":[800],"dancing":[801],"linked":[802],"paperclips":[802],"ballpoint":[803],"paintbrush":[805],"crayon":[806],"fingers":[807,809,1022],"splayed":[807],"reversed":[808],"finger":[808],"extended":[808],"between":[809],"spock":[809],"desktop":[811],"printer":[812],"trackball":[814],"frame":[815],"picture":[815],"dividers":[816],"cabinet":[818],"wastebasket":[819],"pad":[820,821],"compression":[822],"old":[823],"rolled":[824],"dagger":[825],"speaking":[826],"head":[826,1013],"bubble":[827,828],"world":[830],"map":[830],"mount":[831],"fuji":[831],"tokyo":[832],"tower":[832],"statue":[833],"liberty":[833],"japan":[834],"moyai":[835],"grinning":[836,837,892],"grin":[837],"tears":[838,893],"joy":[838,893],"smiley":[839,894],"smile":[840,841,892,896],"cold":[841,855,884],"tightly":[842,865],"laughing":[842,1026],"satisfied":[842],"halo":[843],"innocent":[843],"horns":[844,1016],"winking":[845,864],"wink":[845],"blush":[846],"savouring":[847],"delicious":[847],"yum":[847],"relieved":[848,873],"shaped":[849,895],"smirking":[851],"smirk":[851,896],"neutral":[852],"expressionless":[853],"unamused":[854],"pensive":[856],"confused":[857],"confounded":[858],"kissing":[859,860,861,862,897],"throwing":[860],"stuck":[863,864,865],"out":[863,864,865],"disappointed":[866,873],"worried":[867],"angry":[868],"pouting":[869,898,914],"rage":[869],"crying":[870,881,899],"cry":[870],"persevering":[871],"persevere":[871],"look":[872],"triumph":[872],"but":[873],"anguished":[875],"fearful":[876],"weary":[877,900],"sleepy":[878],"tired":[879],"grimacing":[880],"loudly":[881],"sob":[881],"hushed":[883],"screaming":[885],"fear":[885],"scream":[885,900],"astonished":[886],"flushed":[887],"medical":[891],"mask":[891],"wry":[896],"slightly":[901,902],"upside":[903],"rolling":[904,1026],"good":[905],"gesture":[905,906],"bowing":[907],"deeply":[907],"see":[908],"evil":[908,909,910],"hear":[909],"speak":[910],"happy":[911],"raising":[911,912],"both":[912],"celebration":[912],"folded":[915],"pray":[915],"rocket":[916],"helicopter":[917],"steam":[918],"locomotive":[918],"railway":[919,946,947,998],"speed":[920,921],"train":[920,921,922,927],"bullettrain":[920,921],"side":[920],"bullet":[921],"train2":[922],"metro":[923],"rail":[924],"station":[925],"tram":[926,927],"bus":[928,929,931],"oncoming":[929,936,938,940],"trolleybus":[930],"busstop":[931],"minibus":[932],"ambulance":[933],"engine":[934],"taxi":[937,938],"automobile":[939,940],"recreational":[941],"vehicle":[941],"delivery":[942],"truck":[942],"articulated":[943],"lorry":[943],"tractor":[944],"monorail":[945],"suspension":[947],"cableway":[948],"aerial":[949],"tramway":[949],"ship":[950,1004],"rowboat":[951],"speedboat":[952],"horizontal":[953],"traffic":[953,954],"cars":[956],"rotating":[956],"door":[958],"smoking":[960,961],"put":[962],"litter":[962,963],"its":[962],"place":[962,991,1049,1050,1051],"do":[963,1163],"not":[963],"potable":[964,965],"non":[965],"bicycle":[966],"bike":[966],"bicycles":[967],"bicyclist":[968,969],"pedestrian":[970],"walking":[970],"pedestrians":[971],"children":[972],"crossing":[972],"mens":[973],"womens":[974],"restroom":[975],"toilet":[977],"closet":[978],"wc":[978],"shower":[979],"bath":[980],"bathtub":[981],"passport":[982],"customs":[983],"baggage":[984],"claim":[984],"luggage":[985],"couch":[986],"lamp":[986],"accommodation":[987],"shopping":[988,993],"bags":[988],"bellhop":[989],"bed":[990],"worship":[991],"octagonal":[992],"trolley":[993],"shield":[995],"oil":[996],"drum":[996,1044],"motorway":[997],"track":[998],"motor":[999,1006],"departure":[1001],"arriving":[1002],"passenger":[1004],"scooter":[1005,1006],"canoe":[1007],"zipper":[1008],"nerd":[1011],"thinking":[1012],"bandage":[1013],"robot":[1014],"hugging":[1015],"the":[1016,1026],"call":[1017],"me":[1017,1245],"handshake":[1021],"cowboy":[1023],"clown":[1024],"nauseated":[1025],"floor":[1026],"drooling":[1027],"lying":[1028],"sneezing":[1030],"pregnant":[1031],"selfie":[1032],"prince":[1033],"tuxedo":[1034],"mother":[1035],"shrug":[1036],"doing":[1037],"cartwheel":[1037],"juggling":[1038],"fencer":[1039],"wrestlers":[1040],"polo":[1041],"handball":[1042],"wilted":[1043],"drumsticks":[1044],"glasses":[1045],"tumbler":[1046],"spoon":[1047],"goal":[1048],"net":[1048],"second":[1050],"third":[1051],"boxing":[1052],"glove":[1052],"martial":[1053],"uniform":[1053],"croissant":[1054],"avocado":[1055],"cucumber":[1056],"bacon":[1057],"carrot":[1059],"baguette":[1060],"salad":[1061],"shallow":[1062],"pan":[1062],"stuffed":[1063],"flatbread":[1063],"milk":[1065],"peanuts":[1066],"kiwifruit":[1067],"pancakes":[1068],"crab":[1069],"lion":[1070],"scorpion":[1071],"turkey":[1072],"unicorn":[1073],"eagle":[1074],"duck":[1075],"shark":[1077],"owl":[1078],"fox":[1079],"butterfly":[1080],"deer":[1081],"gorilla":[1082],"lizard":[1083],"rhinoceros":[1084],"squid":[1086],"cheese":[1087],"wedge":[1087],"hash":[1088],"zero":[1090],"regional":[1100,1101,1102,1103,1104,1105,1106,1107,1108,1109,1110,1111,1112,1113,1114,1115,1116,1117,1118,1119,1120,1121,1122,1123,1124,1125,1126,1127,1128,1129,1130,1131,1132,1133,1134,1135,1136,1137,1138,1139,1140,1141,1142,1143,1144,1145,1146,1147,1148,1149,1150,1151,1152,1153,1154,1155,1156,1157,1158,1159,1160,1161,1162,1163,1164,1165,1166,1167,1168,1169,1170,1171,1172,1173,1174,1175,1176,1177,1178,1179,1180,1181,1182,1183,1184,1185,1186,1187,1188,1189,1190,1191,1192,1193,1194,1195,1196,1197,1198,1199,1200,1201,1202,1203,1204,1205,1206,1207,1208,1209,1210,1211,1212,1213,1214,1215,1216,1217,1218,1219,1220,1221,1222,1223,1224,1225,1226,1227,1228,1229,1230,1231,1232,1233,1234,1235,1236,1237,1238,1239,1240,1241,1242,1243,1244,1245,1246,1247,1248,1249,1250,1251,1252,1253,1254,1255,1256,1257,1258,1259,1260,1261,1262,1263,1264,1265,1266,1267,1268,1269,1270,1271,1272,1273,1274,1275,1276,1277,1278,1279,1280,1281,1282,1283,1284,1285,1286,1287,1288,1289,1290,1291,1292,1293,1294,1295,1296,1297,1298,1299,1300,1301,1302,1303,1304,1305,1306,1307,1308,1309,1310,1311,1312,1313,1314,1315,1316,1317,1318,1319,1320,1321,1322,1323,1324,1325,1326,1327,1328,1329,1330,1331,1332,1333,1334,1335,1336,1337,1338,1340,1341,1342,1343,1344,1345,1346,1347,1348,1349,1350,1351,1352,1353,1354,1355,1356,1357],"indicator":[1100,1101,1102,1103,1104,1105,1106,1107,1108,1109,1110,1111,1112,1113,1114,1115,1116,1117,1118,1119,1120,1121,1122,1123,1124,1125,1126,1127,1128,1129,1130,1131,1132,1133,1134,1135,1136,1137,1138,1139,1140,1141,1142,1143,1144,1145,1146,1147,1148,1149,1150,1151,1152,1153,1154,1155,1156,1157,1158,1159,1160,1161,1162,1163,1164,1165,1166,1167,1168,1169,1170,1171,1172,1173,1174,1175,1176,1177,1178,1179,1180,1181,1182,1183,1184,1185,1186,1187,1188,1189,1190,1191,1192,1193,1194,1195,1196,1197,1198,1199,1200,1201,1202,1203,1204,1205,1206,1207,1208,1209,1210,1211,1212,1213,1214,1215,1216,1217,1218,1219,1220,1221,1222,1223,1224,1225,1226,1227,1228,1229,1230,1231,1232,1233,1234,1235,1236,1237,1238,1239,1240,1241,1242,1243,1244,1245,1246,1247,1248,1249,1250,1251,1252,1253,1254,1255,1256,1257,1258,1259,1260,1261,1262,1263,1264,1265,1266,1267,1268,1269,1270,1271,1272,1273,1274,1275,1276,1277,1278,1279,1280,1281,1282,1283,1284,1285,1286,1287,1288,1289,1290,1291,1292,1293,1294,1295,1296,1297,1298,1299,1300,1301,1302,1303,1304,1305,1306,1307,1308,1309,1310,1311,1312,1313,1314,1315,1316,1317,1318,1319,1320,1321,1322,1323,1324,1325,1326,1327,1328,1329,1330,1331,1332,1333,1334,1335,1336,1337,1338,1340,1341,1342,1343,1344,1345,1346,1347,1348,1349,1350,1351,1352,1353,1354,1355,1356,1357],"ac":[1100],"ad":[1101],"ae":[1102],"af":[1103],"ag":[1104],"ai":[1105],"al":[1106],"am":[1107],"ao":[1108],"aq":[1109],"ar":[1110],"as":[1111],"au":[1113],"aw":[1114],"ax":[1115],"az":[1116],"ba":[1117],"bb":[1118],"bd":[1119],"be":[1120],"bf":[1121],"bg":[1122],"bh":[1123],"bi":[1124],"bj":[1125],"bl":[1126],"bm":[1127],"bn":[1128],"bo":[1129],"bq":[1130],"br":[1131],"bs":[1132],"bt":[1133],"bv":[1134],"bw":[1135],"by":[1136],"bz":[1137],"ca":[1138],"cc":[1139],"cf":[1141],"cg":[1142],"ch":[1143],"ci":[1144],"ck":[1145],"cm":[1147],"cn":[1148],"co":[1149],"cp":[1150],"cr":[1151],"cu":[1152],"cv":[1153],"cw":[1154],"cx":[1155],"cy":[1156],"cz":[1157],"dg":[1159],"dj":[1160],"dk":[1161],"dm":[1162],"dz":[1164],"ea":[1165],"ec":[1166],"ee":[1167],"eg":[1168],"eh":[1169],"er":[1170],"es":[1171],"et":[1172],"eu":[1173],"fi":[1174],"fj":[1175],"fk":[1176],"fm":[1177],"fo":[1178],"fr":[1179],"ga":[1180],"gb":[1181],"uk":[1181],"gd":[1182],"ge":[1183],"gf":[1184],"gg":[1185],"gh":[1186],"gi":[1187],"gl":[1188],"gm":[1189],"gn":[1190],"gp":[1191],"gq":[1192],"gr":[1193],"gs":[1194],"gt":[1195],"gu":[1196],"gw":[1197],"gy":[1198],"hk":[1199],"hm":[1200],"hn":[1201],"hr":[1202],"ht":[1203],"hu":[1204],"ic":[1205],"ie":[1207],"il":[1208],"im":[1209],"io":[1211],"iq":[1212],"ir":[1213],"is":[1214],"it":[1215],"je":[1216],"jm":[1217],"jo":[1218],"jp":[1219],"ke":[1220],"kg":[1221],"kh":[1222],"ki":[1223],"km":[1224],"kn":[1225],"kp":[1226],"kr":[1227],"kw":[1228],"ky":[1229],"kz":[1230],"la":[1231],"lb":[1232],"lc":[1233],"li":[1234],"lk":[1235],"lr":[1236],"ls":[1237],"lt":[1238],"lu":[1239],"lv":[1240],"ly":[1241],"ma":[1242],"mc":[1243],"md":[1244],"mf":[1246],"mg":[1247],"mh":[1248],"mk":[1249],"ml":[1250],"mm":[1251],"mn":[1252],"mo":[1253],"mp":[1254],"mq":[1255],"mr":[1256],"ms":[1257],"mt":[1258],"mu":[1259],"mv":[1260],"mw":[1261],"mx":[1262],"my":[1263],"mz":[1264],"na":[1265],"nc":[1266],"ne":[1267],"nf":[1268],"ni":[1270],"nl":[1271],"np":[1273],"nr":[1274],"nu":[1275],"nz":[1276],"pa":[1278],"pe":[1279],"pf":[1280],"pg":[1281],"ph":[1282],"pk":[1283],"pl":[1284],"pm":[1285],"pn":[1286],"pr":[1287],"ps":[1288],"pt":[1289],"pw":[1290],"py":[1291],"qa":[1292],"re":[1293],"ro":[1294],"rs":[1295],"ru":[1296],"rw":[1297],"sb":[1299],"sc":[1300],"sd":[1301],"se":[1302],"sg":[1303],"sh":[1304],"si":[1305],"sj":[1306],"sk":[1307],"sl":[1308],"sm":[1309],"sn":[1310],"so":[1311],"sr":[1312],"ss":[1313],"st":[1314],"sv":[1315],"sx":[1316],"sy":[1317],"sz":[1318],"ta":[1319],"tc":[1320],"td":[1321],"tf":[1322],"tg":[1323],"th":[1324],"tj":[1325],"tk":[1326],"tl":[1327],"tn":[1329],"to":[1330],"tr":[1331],"tt":[1332],"tw":[1334],"tz":[1335],"ua":[1336],"ug":[1337],"um":[1338],"us":[1340],"uy":[1341],"uz":[1342],"va":[1343],"vc":[1344],"ve":[1345],"vg":[1346],"vi":[1347],"vn":[1348],"vu":[1349],"wf":[1350],"ws":[1351],"xk":[1352],"ye":[1353],"yt":[1354],"za":[1355],"zm":[1356],"zw":[1357]},"modifiers":["neutral","1f3fb","1f3fc","1f3fd","1f3fe","1f3ff"],"skinTones":{"1f3fb":"skin-tone-2","1f3fc":"skin-tone-3","1f3fd":"skin-tone-4","1f3fe":"skin-tone-5","1f3ff":"skin-tone-6"}}

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(112);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./style.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".emoji-picker .icn-magnifier:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg id='Capa_1' xmlns='http://www.w3.org/2000/svg' width='310.4' height='310.4'%3E%3Cstyle%3E.st0%7Bfill:%239e9e9e%7D%3C/style%3E%3Cpath class='st0' d='M273.6 215c49.1-49.1 49.1-129 0-178.1-49.1-49.1-129-49.1-178.1 0-41.7 41.7-48 103.6-18.9 152 0 0 2.1 3.5-.7 6.3l-64.3 64.3c-12.8 12.8-15.8 30.7-4.5 42l2 2c11.3 11.3 29.2 8.3 42-4.5l64.1-64.1c3-3 6.4-.9 6.4-.9 48.4 28.9 110.3 22.6 152-19zm-154.9-23.3c-36.3-36.3-36.3-95.3 0-131.6s95.3-36.3 131.6 0 36.3 95.3 0 131.6-95.3 36.3-131.6 0z'/%3E%3Cpath class='st0' d='M126.8 118.4c-1.7 0-3.4-.3-5.1-1-6.6-2.8-9.7-10.4-6.9-17 17.6-41.6 65.7-61.1 107.3-43.5 6.6 2.8 9.7 10.4 6.9 17-2.8 6.6-10.4 9.7-17 6.9-28.4-12-61.2 1.3-73.2 29.7-2.2 4.9-7 7.9-12 7.9z'/%3E%3C/svg%3E\"); }\n\n.emoji-picker ul.skin-tones {\n  position: absolute;\n  right: 0; }\n  .emoji-picker ul.skin-tones.spread li {\n    opacity: 1; }\n  .emoji-picker ul.skin-tones li {\n    position: absolute;\n    top: 16px;\n    right: 20px;\n    z-index: 3;\n    padding: 1px;\n    border-radius: 3px;\n    opacity: 0;\n    transition: transform .4s, opacity .3s; }\n    .emoji-picker ul.skin-tones li.selected {\n      opacity: 1;\n      transform: scale(1.5); }\n    .emoji-picker ul.skin-tones li.neutral a {\n      background-color: #ffe082; }\n    .emoji-picker ul.skin-tones li.m1f3fb a {\n      background-color: #ffe0b2; }\n    .emoji-picker ul.skin-tones li.m1f3fc a {\n      background-color: #ffccbc; }\n    .emoji-picker ul.skin-tones li.m1f3fe a {\n      background-color: #795548; }\n    .emoji-picker ul.skin-tones li.m1f3ff a {\n      background-color: #5d4037; }\n    .emoji-picker ul.skin-tones li.m1f3fd a {\n      background-color: #ca7e55; }\n    .emoji-picker ul.skin-tones li a {\n      display: block;\n      height: 10px;\n      width: 10px;\n      border-radius: 2px; }\n      .emoji-picker ul.skin-tones li a img {\n        z-index: 2;\n        height: 10px;\n        width: 10px; }\n", ""]);

// exports


/***/ }),
/* 113 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _emojiData = __webpack_require__(1);

__webpack_require__(115);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CategoriesNav(_ref) {
    var _onClick = _ref.onClick;


    return _react2.default.createElement(
        'nav',
        null,
        _emojiData.categories.map(function (category, index) {
            return _react2.default.createElement(
                'a',
                { className: category.name, key: index, onClick: function onClick(e) {
                        return _onClick(e, index);
                    } },
                _react2.default.createElement('i', null),
                _react2.default.createElement(
                    'span',
                    { className: 'hidden' },
                    category.name
                )
            );
        })
    );
}

CategoriesNav.propTypes = {
    onClick: _propTypes2.default.func.isRequired
};

exports.default = CategoriesNav;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(116);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./style.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".emoji-picker .icn-magnifier:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg id='Capa_1' xmlns='http://www.w3.org/2000/svg' width='310.4' height='310.4'%3E%3Cstyle%3E.st0%7Bfill:%239e9e9e%7D%3C/style%3E%3Cpath class='st0' d='M273.6 215c49.1-49.1 49.1-129 0-178.1-49.1-49.1-129-49.1-178.1 0-41.7 41.7-48 103.6-18.9 152 0 0 2.1 3.5-.7 6.3l-64.3 64.3c-12.8 12.8-15.8 30.7-4.5 42l2 2c11.3 11.3 29.2 8.3 42-4.5l64.1-64.1c3-3 6.4-.9 6.4-.9 48.4 28.9 110.3 22.6 152-19zm-154.9-23.3c-36.3-36.3-36.3-95.3 0-131.6s95.3-36.3 131.6 0 36.3 95.3 0 131.6-95.3 36.3-131.6 0z'/%3E%3Cpath class='st0' d='M126.8 118.4c-1.7 0-3.4-.3-5.1-1-6.6-2.8-9.7-10.4-6.9-17 17.6-41.6 65.7-61.1 107.3-43.5 6.6 2.8 9.7 10.4 6.9 17-2.8 6.6-10.4 9.7-17 6.9-28.4-12-61.2 1.3-73.2 29.7-2.2 4.9-7 7.9-12 7.9z'/%3E%3C/svg%3E\"); }\n\n.emoji-picker nav ~ .bar-wrapper {\n  margin-top: 45px;\n  border-top: 1px solid #eeeeee; }\n\n.emoji-picker nav {\n  flex-direction: row;\n  min-height: 45px;\n  background-color: #ffffff;\n  display: flex;\n  justify-content: space-between;\n  position: absolute;\n  z-index: 1;\n  box-sizing: border-box;\n  left: 10px;\n  right: 10px; }\n  .emoji-picker nav a {\n    position: relative;\n    transition: filter .2s; }\n    .emoji-picker nav a:hover:after {\n      opacity: 1;\n      background-color: #a5d6a7; }\n    .emoji-picker nav a:hover i {\n      opacity: 1; }\n    .emoji-picker nav a i {\n      content: '';\n      display: block;\n      height: 45px;\n      width: 20px;\n      background-size: 18px auto;\n      background-position: 50% 50%;\n      background-repeat: no-repeat;\n      opacity: .4;\n      transition: opacity .3s;\n      transition-delay: .2s; }\n    .emoji-picker nav a.people i {\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 33 33'%3E%3Cpath d='M16.5 33C7.402 33 0 25.598 0 16.5S7.402 0 16.5 0 33 7.402 33 16.5 25.598 33 16.5 33zm0-32C7.953 1 1 7.953 1 16.5S7.953 32 16.5 32 32 25.047 32 16.5 25.047 1 16.5 1z'/%3E%3Cpath d='M16.5 33a16.38 16.38 0 0 1-9.549-3.06.5.5 0 1 1 .116-.876c4.146-1.535 4.815-2.781 4.815-5.169 0-.631-.142-.838-.398-1.214-.339-.494-.803-1.171-1.129-2.939-.048-.254-.089-.274-.316-.384-.606-.292-1.163-.712-1.309-2.628 0-.928.32-1.441.585-1.708-.058-.33-.153-.899-.242-1.519-.453-2.777-.473-6.178 3.433-7.759 3.404-1.38 6.121-.626 6.974.273.604.019 2.162.177 3.246 1.438 1.668 1.94 1.137 6.363.955 7.562.266.261.589.767.589 1.675-.146 1.954-.703 2.375-1.31 2.666-.228.11-.269.129-.316.384-.326 1.768-.789 2.445-1.128 2.939-.257.375-.398.583-.398 1.214 0 2.388.669 3.634 4.815 5.169a.498.498 0 0 1 .116.876A16.38 16.38 0 0 1 16.5 33zm-8.183-3.349C10.779 31.191 13.589 32 16.5 32s5.721-.809 8.183-2.349c-3.474-1.426-4.565-2.864-4.565-5.755 0-.941.278-1.348.573-1.779.304-.444.682-.996.971-2.556.139-.754.576-.964.865-1.103.311-.149.631-.303.744-1.803-.001-.764-.344-.972-.358-.98a.533.533 0 0 1-.264-.537c.248-1.329.656-5.474-.681-7.031-.913-1.062-2.352-1.091-2.626-1.08-.046-.004-.091-.005-.134-.016-.13-.033-.35-.146-.417-.262-.272-.466-2.641-1.403-5.91-.08-3.231 1.308-3.238 4.112-2.819 6.682.138.957.289 1.784.29 1.788a.5.5 0 0 1-.283.544c.003 0-.339.209-.339 1.008.112 1.461.433 1.616.743 1.765.289.139.727.349.866 1.103.288 1.56.666 2.112.97 2.556.296.431.574.838.574 1.779 0 2.894-1.091 4.332-4.566 5.757z'/%3E%3C/svg%3E\"); }\n    .emoji-picker nav a.foods i {\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath d='M337.502 61.244c-46.267-19.341-98.094-21.573-145.933-6.282-5.497 1.758-8.528 7.638-6.772 13.134 1.758 5.497 7.64 8.528 13.134 6.772 43.115-13.782 89.819-11.772 131.51 5.657 1.317.55 2.682.811 4.026.811 4.087 0 7.969-2.415 9.644-6.422 2.228-5.324-.284-11.445-5.609-13.67zM368.323 77.252a11.31 11.31 0 0 0-.375-.239c-4.925-3.009-11.356-1.458-14.364 3.467-2.984 4.884-1.483 11.249 3.346 14.29a10.398 10.398 0 0 0 5.587 1.626c3.377 0 6.69-1.633 8.704-4.654 3.201-4.801 1.904-11.289-2.898-14.49zM447.293 161.884c-4.081-4.08-10.698-4.08-14.778 0l-14.629 14.629c-4.08 4.081-4.08 10.698 0 14.778 2.04 2.041 4.715 3.06 7.388 3.06s5.349-1.02 7.389-3.06l14.629-14.629c4.081-4.081 4.081-10.698.001-14.778zM83.999 214.617c-4.081-4.08-10.698-4.08-14.778 0l-14.629 14.629c-4.08 4.081-4.08 10.698 0 14.778 2.04 2.041 4.715 3.06 7.388 3.06s5.349-1.02 7.39-3.06l14.629-14.629c4.081-4.082 4.081-10.698 0-14.778zM115.508 100.235c-4.081-4.08-10.698-4.08-14.778 0l-14.629 14.629c-4.08 4.081-4.08 10.698 0 14.778 2.04 2.041 4.715 3.06 7.388 3.06s5.348-1.02 7.39-3.06l14.629-14.629c4.081-4.081 4.081-10.698 0-14.778zM386.754 116.24h-20.688c-5.771 0-10.449 4.678-10.449 10.449s4.678 10.449 10.449 10.449h20.688c5.771 0 10.449-4.678 10.449-10.449s-4.678-10.449-10.449-10.449zM151.326 161.908l-14.618-14.618c-4.081-4.08-10.698-4.081-14.778 0s-4.08 10.698 0 14.778l14.618 14.618a10.413 10.413 0 0 0 7.388 3.06c2.674 0 5.349-1.02 7.39-3.06 4.081-4.081 4.081-10.698 0-14.778zM411.753 229.241l-14.618-14.617c-4.08-4.081-10.696-4.08-14.777 0s-4.08 10.697 0 14.777l14.618 14.617c2.041 2.041 4.715 3.06 7.388 3.06s5.348-1.021 7.388-3.06c4.083-4.08 4.082-10.696.001-14.777zM318.326 126.607l-14.617-14.617c-4.081-4.08-10.698-4.081-14.778 0s-4.08 10.698 0 14.778l14.617 14.617a10.414 10.414 0 0 0 7.388 3.061 10.42 10.42 0 0 0 7.39-3.061c4.08-4.081 4.08-10.698 0-14.778zM195.194 97.387c-3.904-4.25-10.515-4.528-14.763-.622l-15.22 13.989c-4.249 3.905-4.527 10.515-.622 14.763a10.42 10.42 0 0 0 7.696 3.378c2.528 0 5.063-.911 7.068-2.756l15.22-13.989c4.248-3.905 4.526-10.515.621-14.763zM256.153 145.241H255.865c-5.762 0-10.437 4.665-10.449 10.429-.011 5.771 4.658 10.457 10.429 10.469H256.134c5.762 0 10.438-4.664 10.449-10.429.01-5.771-4.659-10.458-10.43-10.469z'/%3E%3Cpath d='M437.019 74.981C388.668 26.628 324.38 0 256 0S123.332 26.628 74.981 74.981C26.629 123.333 0 187.62 0 256c0 68.38 26.628 132.668 74.981 181.019C123.333 485.371 187.62 512 256 512c68.38 0 132.668-26.628 181.019-74.981C485.371 388.667 512 324.38 512 256s-26.628-132.668-74.981-181.019zM256 491.102c-94.256 0-175.718-55.763-213.173-136.024 6.781-.56 13.126-3.458 18.112-8.35 5.756-5.647 9.057-13.495 9.057-21.531v-9.364c0-7.449 6.027-13.624 13.435-13.767 3.561-.079 6.976 1.322 9.617 3.913 2.77 2.718 4.359 6.484 4.359 10.332v23.709c0 18.754 15.222 34.302 33.932 34.66.221.004.442.006.664.006 8.973 0 17.47-3.499 23.989-9.895 6.751-6.623 10.623-15.826 10.623-25.25v-18.215c20.172 27.524 52.723 45.432 89.384 45.432 52.209 0 96.09-36.312 107.73-85.007a10.027 10.027 0 0 1 2.18 6.23v25.773c0 19.673 15.968 35.984 35.596 36.361.233.004.464.006.696.006 9.409 0 18.321-3.671 25.161-10.38 7.086-6.951 11.149-16.61 11.149-26.5v-24.856c0-2.83 1.17-5.6 3.21-7.602 1.927-1.889 4.429-2.882 6.986-2.854 5.403.104 9.8 4.612 9.8 10.05v2.721c0 14.409 10.071 26.69 23.526 30.04C453.848 418.996 363.189 491.102 256 491.102zm223.405-200.399v-2.721c0-16.741-13.591-30.624-30.297-30.944-8.235-.159-16.057 2.978-22.022 8.829-6.021 5.906-9.473 14.113-9.473 22.52v24.856c0 4.314-1.782 8.536-4.886 11.582-2.97 2.912-6.846 4.462-10.82 4.397-8.326-.16-15.099-7.098-15.099-15.468v-25.773c0-13.154-8.392-24.538-20.091-28.971.027-1.001.043-2.004.043-3.011 0-46.06-29.007-87.788-72.182-103.836-5.411-2.01-11.425.745-13.434 6.154-2.01 5.409.745 11.424 6.154 13.434 35.027 13.021 58.562 46.877 58.562 84.248 0 49.549-40.312 89.861-89.861 89.861-49.549 0-89.861-40.312-89.861-89.861 0-37.372 23.535-71.228 58.565-84.246 5.409-2.01 8.164-8.026 6.154-13.434s-8.022-8.165-13.434-6.154C174.248 168.21 145.239 209.938 145.239 256a110.22 110.22 0 0 0 7.085 38.971 30.145 30.145 0 0 0-6.607 18.808v25.763c0 3.848-1.589 7.614-4.359 10.332-2.642 2.591-6.036 3.973-9.617 3.913-7.407-.142-13.434-6.317-13.434-13.766v-23.709c0-9.424-3.872-18.627-10.623-25.251-6.681-6.554-15.435-10.081-24.652-9.889-18.71.358-33.932 15.907-33.932 34.66v9.364c0 2.461-1.019 4.871-2.794 6.613-1.668 1.635-3.808 2.506-6.034 2.47-3.374-.065-6.387-2.139-7.733-5.21-7.543-23.011-11.64-47.569-11.64-73.07C20.898 126.365 126.365 20.898 256 20.898S491.102 126.365 491.102 256c0 15.182-1.464 30.026-4.227 44.414-4.281-1.138-7.47-5.083-7.47-9.711z'/%3E%3C/svg%3E\"); }\n    .emoji-picker nav a.nature i {\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 470 470'%3E%3Cpath d='M401.17 68.83C356.784 24.444 297.771 0 235 0S113.216 24.444 68.83 68.83 0 172.229 0 235s24.444 121.784 68.83 166.17S172.229 470 235 470s121.784-24.444 166.17-68.83S470 297.771 470 235s-24.444-121.784-68.83-166.17zM235 455c-121.309 0-220-98.691-220-220S113.691 15 235 15s220 98.691 220 220-98.691 220-220 220z'/%3E%3Cpath d='M382.5 173.979c3.532 0 6.735 1.824 8.568 4.879a7.499 7.499 0 0 0 12.864 0c1.833-3.055 5.036-4.879 8.568-4.879 4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5c-5.461 0-10.724 1.829-15 5.039-4.276-3.21-9.539-5.039-15-5.039-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5zM322.5 135.459c3.532 0 6.735 1.824 8.568 4.879a7.499 7.499 0 0 0 12.864 0c1.833-3.055 5.036-4.879 8.568-4.879 4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5c-5.461 0-10.724 1.829-15 5.039-4.276-3.21-9.539-5.039-15-5.039-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5zM117.5 173.979c3.532 0 6.735 1.824 8.568 4.879a7.499 7.499 0 0 0 12.864 0c1.833-3.055 5.036-4.879 8.568-4.879 4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5c-5.461 0-10.724 1.829-15 5.039-4.276-3.21-9.539-5.039-15-5.039-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5zM436.826 253.173a7.5 7.5 0 0 0-5.443-2.6c-12.664-.4-24.343-7.548-32.041-19.608a7.5 7.5 0 0 0-12.643-.001c-7.974 12.489-20.074 19.652-33.2 19.652-13.089 0-25.177-7.164-33.162-19.656a7.502 7.502 0 0 0-12.635-.004c-8 12.494-20.098 19.66-33.192 19.66-13.098 0-25.189-7.164-33.175-19.656a7.5 7.5 0 0 0-12.64.004c-7.974 12.489-20.069 19.652-33.187 19.652-13.098 0-25.19-7.164-33.176-19.656a7.502 7.502 0 0 0-12.635-.004c-8 12.494-20.098 19.66-33.191 19.66-13.099 0-25.19-7.164-33.175-19.655a7.5 7.5 0 0 0-12.64.004c-7.699 12.061-19.389 19.207-32.07 19.608a7.494 7.494 0 0 0-5.443 2.6 7.497 7.497 0 0 0-1.769 5.767c5.786 49.506 29.545 95.215 66.901 128.706C135.964 421.407 184.509 440 235 440c45.241 0 88.17-14.518 124.145-41.982a7.498 7.498 0 0 0 1.41-10.512 7.496 7.496 0 0 0-10.512-1.41C316.705 411.547 276.924 425 235 425c-93.882 0-173.276-68.424-187.68-160.366 11.265-2.217 21.561-8.215 29.707-17.284 10.49 11.584 24.673 18.267 39.476 18.267 14.808 0 29.002-6.691 39.505-18.291 10.493 11.6 24.685 18.291 39.498 18.291 14.828 0 29.022-6.689 39.511-18.284 10.493 11.595 24.682 18.284 39.491 18.284 14.808 0 29.002-6.691 39.505-18.291 10.493 11.6 24.679 18.291 39.485 18.291 14.826 0 29.018-6.681 39.505-18.264 8.14 9.065 18.422 15.061 29.671 17.278-6.044 38.177-24.008 74.246-51.068 102.269a7.5 7.5 0 1 0 10.791 10.419c31.08-32.185 51.038-74.226 56.198-118.38a7.495 7.495 0 0 0-1.769-5.766z'/%3E%3Cpath d='M289.513 310.616c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h10c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-10zM358.49 280.616h-10c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h10c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5zM111.503 280.616c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h10c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-10zM235 191.25c30.327 0 55-24.673 55-55s-24.673-55-55-55-55 24.673-55 55 24.673 55 55 55zm0-95c22.056 0 40 17.944 40 40s-17.944 40-40 40-40-17.944-40-40 17.944-40 40-40z'/%3E%3C/svg%3E\"); }\n    .emoji-picker nav a.activity i {\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'%3E%3Cpath d='M32 0C14.355 0 0 14.355 0 32s14.355 32 32 32 32-14.355 32-32S49.645 0 32 0zm29.624 36.731l-3.885-6.439 2.681-7.88a29.867 29.867 0 0 1 1.204 14.319zm-7.558 15.567a.994.994 0 0 0-.408-.02L43.98 53.83a.993.993 0 0 0-.123-.345l-5.502-9.17 8.896-13.7h8.428a.992.992 0 0 0 .105.312l5.236 8.678a29.956 29.956 0 0 1-6.954 12.693zm-10.085 3.557l7.688-1.232a29.958 29.958 0 0 1-11.706 6.296l4.018-5.064zM12.65 9.1a29.858 29.858 0 0 1 18.628-7.082.982.982 0 0 0 .24.376l5.525 5.214-2.185 8.156-14.237 5.465c-.052-.042-.093-.094-.154-.126l-8.87-4.701L12.65 9.1zm25.736-2.976l-4.283-4.042a29.763 29.763 0 0 1 10.989 2.931l-6.706 1.111zM21.93 38.737l-.816-15.554L35.655 17.6l9.803 12.106-8.483 13.063-15.045-4.032zm37.375-19.141c-.031.054-.072.098-.093.159l-3.015 8.86h-9.048L36.882 15.937l2.113-7.887 8.27-1.371a.979.979 0 0 0 .453-.218 30.2 30.2 0 0 1 11.587 13.135zm-48.994-8.289l-.802 5.561-5.349 3.975a30.035 30.035 0 0 1 6.151-9.536zm-7.255 12.82c.044-.023.09-.037.131-.068l7.737-5.751 8.158 4.323.888 16.936c.002.025.013.048.016.073l-7.71 7.629c-.066.065-.105.145-.149.222L4.734 44.32c-.028-.012-.057-.009-.085-.018A29.822 29.822 0 0 1 2 32c0-2.725.372-5.362 1.056-7.873zm3.022 22.945l5.415 2.322 4.141 7.729a30.222 30.222 0 0 1-9.556-10.051zm12.759 11.879c-.019-.064-.025-.131-.058-.192l-5.317-9.924c.076-.043.155-.08.22-.145l8.027-7.942 14.507 3.888 5.927 9.879c.05.083.11.154.178.217l-5.449 6.867c-1.587.26-3.213.401-4.872.401-4.72 0-9.186-1.099-13.163-3.049z'/%3E%3C/svg%3E\"); }\n    .emoji-picker nav a.objects i {\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 58.153 58.153'%3E%3Cpath d='M40.076 29.153h-7.142a3.995 3.995 0 0 0-2.858-2.858V16.153a1 1 0 1 0-2 0v10.142c-1.72.447-3 1.999-3 3.858 0 2.206 1.794 4 4 4 1.858 0 3.411-1.28 3.858-3h7.142a1 1 0 1 0 0-2zm-11 3c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z'/%3E%3Cpath d='M50.188 9.764l4.096 4.096a1 1 0 0 0 1.414 0c3.167-3.166 3.167-8.319 0-11.485s-8.319-3.166-11.485 0a.997.997 0 0 0 0 1.414l4.561 4.561-1.699 1.699c-4.78-4.284-11.089-6.896-17.998-6.896s-13.218 2.612-17.998 6.896l-1.7-1.699 4.561-4.561a.997.997 0 0 0 0-1.414c-3.166-3.166-8.318-3.166-11.485 0s-3.167 8.319 0 11.485a1 1 0 0 0 1.414 0l4.096-4.096 1.676 1.676c-4.679 4.857-7.565 11.453-7.565 18.713 0 9.898 5.357 18.564 13.321 23.265l-3.028 3.028a.999.999 0 1 0 1.414 1.414l3.45-3.45c3.578 1.754 7.597 2.743 11.843 2.743s8.265-.989 11.843-2.743l3.45 3.45a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-3.028-3.028c7.964-4.701 13.321-13.367 13.321-23.265 0-7.26-2.886-13.856-7.565-18.713l1.677-1.676zm4.095-5.975c2.146 2.146 2.362 5.502.649 7.893L46.391 3.14a6.13 6.13 0 0 1 7.892.649zM3.22 11.681c-1.713-2.39-1.497-5.746.649-7.892s5.502-2.361 7.892-.649L3.22 11.681zm25.856 43.472c-13.785 0-25-11.215-25-25s11.215-25 25-25 25 11.215 25 25-11.214 25-25 25z'/%3E%3Cpath d='M29.076 10.032a1 1 0 0 0 1-1v-1a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1zM29.076 50.032a1 1 0 0 0-1 1v1a1 1 0 1 0 2 0v-1a1 1 0 0 0-1-1zM50.076 31.032h1a1 1 0 1 0 0-2h-1a1 1 0 1 0 0 2zM8.076 29.032h-1a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zM43.926 13.768l-.707.707a.999.999 0 1 0 1.414 1.414l.707-.707a.999.999 0 1 0-1.414-1.414zM13.52 44.174l-.707.707a.999.999 0 1 0 1.414 1.414l.707-.707a.999.999 0 1 0-1.414-1.414zM44.633 44.174a.999.999 0 1 0-1.414 1.414l.707.707a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-.707-.707zM14.227 13.768a.999.999 0 1 0-1.414 1.414l.707.707a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-.707-.707z'/%3E%3C/svg%3E\"); }\n    .emoji-picker nav a.places i {\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 470 470'%3E%3Cpath d='M401.17 68.83C356.784 24.444 297.771 0 235 0S113.216 24.444 68.83 68.83C24.444 113.215 0 172.229 0 235s24.444 121.785 68.83 166.17C113.216 445.556 172.229 470 235 470s121.784-24.444 166.17-68.83C445.556 356.785 470 297.771 470 235s-24.444-121.785-68.83-166.17zM235 455c-121.309 0-220-98.691-220-220S113.691 15 235 15s220 98.691 220 220-98.691 220-220 220z'/%3E%3Ccircle cx='235' cy='97.5' r='7.5'/%3E%3Cpath d='M437.56 242.365a7.501 7.501 0 0 0-5.467-2.365h-26.046v-22.5c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5V240H372.5v-52.5a7.5 7.5 0 0 0-3.525-6.36L292.5 133.343V97.5A7.5 7.5 0 0 0 285 90h-13.253C268.262 72.905 253.109 60 235 60s-33.262 12.905-36.747 30H185a7.5 7.5 0 0 0-7.5 7.5V130h-25v-22.5c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5V130H105a7.5 7.5 0 0 0-7.5 7.5v102.499l-59.593-.01a7.504 7.504 0 0 0-7.487 7.969c3.523 56.171 29.666 105.984 69.187 140.798.281.291.587.556.911.799 23.389 20.362 51.39 35.496 82.128 43.638.307.102.622.184.946.246A204.258 204.258 0 0 0 235 440c17.409 0 34.679-2.229 51.386-6.558a7.297 7.297 0 0 0 1.002-.262 203.842 203.842 0 0 0 50.574-20.966c30.222-17.629 55.631-42.86 73.479-72.965a7.5 7.5 0 0 0-12.902-7.65 189.49 189.49 0 0 1-26.039 34.299V255h51.438a188.457 188.457 0 0 1-12.616 50.728 7.499 7.499 0 0 0 4.156 9.758 7.498 7.498 0 0 0 9.758-4.157 203.511 203.511 0 0 0 14.342-63.359 7.499 7.499 0 0 0-2.018-5.605zM192.5 175h85v215h-85V175zm0-70H205a7.5 7.5 0 0 0 7.5-7.5c0-12.407 10.094-22.5 22.5-22.5s22.5 10.093 22.5 22.5a7.5 7.5 0 0 0 7.5 7.5h12.5v55h-85v-55zM46.059 254.99l51.441.009V307.5c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5V145h65v245H175c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h2.5v11.078c-24.056-7.668-46.091-20.018-65-35.997V337.5c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v28.458c-28.127-29.492-46.937-68.033-51.441-110.968zM192.5 420.179V405h85v15.106A187.644 187.644 0 0 1 235 425a189.427 189.427 0 0 1-42.5-4.821zm100-4.235V405h2.5c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-2.5V151.032l65 40.625v188.307a191.989 191.989 0 0 1-65 35.98z'/%3E%3Cpath d='M325 320a7.5 7.5 0 0 0-7.5 7.5v10c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-10a7.5 7.5 0 0 0-7.5-7.5zM325 280a7.5 7.5 0 0 0-7.5 7.5v10c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-10a7.5 7.5 0 0 0-7.5-7.5zM325 240a7.5 7.5 0 0 0-7.5 7.5v10c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-10a7.5 7.5 0 0 0-7.5-7.5zM325 200a7.5 7.5 0 0 0-7.5 7.5v10c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-10a7.5 7.5 0 0 0-7.5-7.5zM145 345a7.5 7.5 0 0 0 7.5-7.5v-10c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v10a7.5 7.5 0 0 0 7.5 7.5zM145 305a7.5 7.5 0 0 0 7.5-7.5v-10c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v10a7.5 7.5 0 0 0 7.5 7.5zM145 265a7.5 7.5 0 0 0 7.5-7.5v-10c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v10a7.5 7.5 0 0 0 7.5 7.5zM145 185a7.5 7.5 0 0 0 7.5-7.5v-10c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v10a7.5 7.5 0 0 0 7.5 7.5zM145 225a7.5 7.5 0 0 0 7.5-7.5v-10c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v10a7.5 7.5 0 0 0 7.5 7.5zM235 350a7.5 7.5 0 0 0-7.5 7.5v10c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-10a7.5 7.5 0 0 0-7.5-7.5zM235 310a7.5 7.5 0 0 0-7.5 7.5v10c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-10a7.5 7.5 0 0 0-7.5-7.5zM235 270a7.5 7.5 0 0 0-7.5 7.5v10c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-10a7.5 7.5 0 0 0-7.5-7.5zM235 230a7.5 7.5 0 0 0-7.5 7.5v10c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-10a7.5 7.5 0 0 0-7.5-7.5zM235 190a7.5 7.5 0 0 0-7.5 7.5v10c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-10a7.5 7.5 0 0 0-7.5-7.5zM215 145h40c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-40c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5z'/%3E%3C/svg%3E\"); }\n    .emoji-picker nav a.flags i {\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 502 502'%3E%3Cpath d='M428.484 73.516C381.076 26.108 318.044 0 251 0S120.924 26.108 73.516 73.516 0 183.956 0 251s26.108 130.076 73.516 177.484S183.956 502 251 502s130.076-26.108 177.484-73.516C475.892 381.076 502 318.044 502 251s-26.108-130.076-73.516-177.484zM283.829 39h58.868c58.354 25.338 104.274 74.079 125.849 134.317h-41.725a21.139 21.139 0 0 0-19.587 13.087 21.139 21.139 0 0 0 4.595 23.104l3.3 3.3c4.638 4.637 4.638 12.184 0 16.821a11.42 11.42 0 0 1-8.13 3.368 11.422 11.422 0 0 1-8.13-3.368l-7.969-7.969c-13.135-13.135-30.599-20.369-49.175-20.369h-6.397v-8.036c0-19.265-7.502-37.376-21.124-50.999l-9.952-9.952c-10.216-10.216-23.799-15.843-38.247-15.843h-19.931c-7.721 0-14.98 3.007-20.439 8.466l-5.17 5.169c-5.459 5.459-8.466 12.718-8.466 20.439a4.736 4.736 0 0 1-4.73 4.73h-8.66v-12.154c0-8.648 3.368-16.78 9.483-22.895l5.849-5.849c5.244-5.243 8.131-12.214 8.131-19.629V92.71c0-.394.32-.713.713-.713H320.5c12.407 0 22.5-10.093 22.5-22.5S332.907 47 320.5 47h-36.671c-2.206 0-4-1.794-4-4s1.794-4 4-4zm74.893 252.437l-5.452 5.484a155.066 155.066 0 0 0-22.913 29.41l-9.918 16.5-12.403 20.492a48.673 48.673 0 0 0-7.036 25.21v.615a.857.857 0 0 1-.856.856h-.004a8.78 8.78 0 0 1-6.247-2.586 8.776 8.776 0 0 1-2.589-6.25c0-12.58-4.899-24.407-13.794-33.303l-4.591-4.591c-6.947-6.947-10.773-16.183-10.773-26.007v-29.475c0-14.806-12.045-26.851-26.852-26.851H231.8c-8.349 0-15.142-6.792-15.142-15.142v-15.343c0-9.034 7.35-16.384 16.384-16.384h79.886l24.099 24.1c6.003 6.003 9.309 13.984 9.309 22.473v11.464c0 8.56 5.082 15.955 12.386 19.328zM20 251c0-9.444.583-18.752 1.69-27.902h30.619c10.153 0 19.698 3.954 26.876 11.133l8.781 8.78c7.527 7.527 17.534 11.672 28.179 11.672 5.65 0 10.962 2.2 14.957 6.195l.193.193c7.233 7.233 11.217 16.851 11.217 27.081v17.886c0 13.63-5.308 26.444-14.945 36.082l-19.15 19.15c-13.442 13.443-21.939 30.512-24.58 49.002C44.303 368.799 20 312.684 20 251zm231 231c-56.288 0-107.93-20.247-148.049-53.827v-5.423c0-17.881 6.963-34.693 19.607-47.337l19.15-19.15c13.415-13.416 20.803-31.252 20.803-50.224v-17.886c0-15.573-6.064-30.213-17.075-41.224l-.193-.192c-7.772-7.772-18.106-12.053-29.099-12.053a19.72 19.72 0 0 1-14.036-5.814l-8.781-8.781c-10.957-10.956-25.524-16.99-41.019-16.99h-27.3C47.126 98.635 140.047 20 251 20c7.743 0 15.396.39 22.946 1.138-8.316 3.774-14.117 12.151-14.117 21.862 0 13.234 10.766 24 24 24H320.5c1.378 0 2.5 1.122 2.5 2.5s-1.122 2.5-2.5 2.5h-97.713c-11.421 0-20.713 9.292-20.713 20.713v2.028a7.706 7.706 0 0 1-2.273 5.486l-5.85 5.85c-9.893 9.893-15.341 23.047-15.341 37.037v13.574c0 10.245 8.334 18.58 18.579 18.58h10.081c13.636 0 24.73-11.094 24.73-24.73 0-2.379.926-4.615 2.608-6.297l5.169-5.169c.203-.203.414-.393.632-.574.167.195.334.389.518.574l19.932 19.932c-3.833 3.911-3.813 10.186.068 14.068 1.953 1.953 4.512 2.929 7.071 2.929s5.119-.976 7.071-2.929l7-7c3.905-3.905 3.905-10.237 0-14.143l-15.45-15.45c8.875.156 17.197 3.677 23.489 9.97l9.953 9.952c9.844 9.844 15.266 22.934 15.266 36.856v.817H233.04c-20.062 0-36.384 16.322-36.384 36.384V245.8c0 19.377 15.765 35.142 35.142 35.142h3.493a6.86 6.86 0 0 1 6.852 6.851v29.475c0 15.167 5.906 29.425 16.63 40.15l4.591 4.591c5.118 5.118 7.937 11.923 7.937 19.161 0 7.705 3.001 14.948 8.451 20.396 5.446 5.443 12.685 8.44 20.384 8.44h.015C311.648 410 321 400.644 321 389.149v-.614a28.68 28.68 0 0 1 4.146-14.854l12.409-20.502a.226.226 0 0 1 .016-.026l9.928-16.517a135.064 135.064 0 0 1 19.955-25.613l11.147-11.213c4.428-4.455 5.731-11.08 3.319-16.879s-8.029-9.546-14.31-9.546a1.274 1.274 0 0 1-1.273-1.273v-11.464c0-13.832-5.386-26.835-15.167-36.616l-2.215-2.215c10.49 1.524 20.173 6.357 27.804 13.988l7.969 7.969c6.141 6.141 14.207 9.211 22.272 9.211s16.132-3.07 22.272-9.211c6.024-6.024 9.341-14.033 9.341-22.553 0-8.519-3.317-16.528-9.341-22.553l-3.3-3.3c-.198-.198-.567-.567-.26-1.308.307-.741.829-.741 1.109-.741h47.888C479.468 211.761 482 231.09 482 251c0 127.374-103.626 231-231 231z'/%3E%3Cpath d='M184 85c5.523 0 10-4.477 10-10V54.494c0-5.523-4.477-10-10-10s-10 4.477-10 10V75c0 5.523 4.477 10 10 10zM450.39 314.63c-5.176-1.93-10.935.702-12.863 5.877C408.652 397.961 333.692 450 251 450c-5.523 0-10 4.477-10 10s4.477 10 10 10c45.543 0 89.207-13.849 126.272-40.048 36.24-25.617 63.556-61.046 78.995-102.458 1.929-5.175-.702-10.934-5.877-12.864zM202.433 444.034a198.232 198.232 0 0 1-28.554-9.526c-5.092-2.144-10.954.249-13.096 5.339-2.142 5.09.249 10.954 5.339 13.096a218.202 218.202 0 0 0 31.445 10.491c.817.205 1.635.303 2.44.303 4.478 0 8.554-3.03 9.692-7.57 1.344-5.358-1.909-10.79-7.266-12.133z'/%3E%3C/svg%3E\"); }\n    .emoji-picker nav a.symbols i {\n      background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 490.4 490.4'%3E%3Cpath d='M229 381.2c4.4 4.4 10.1 6.8 16.3 6.8 6.2 0 12-2.4 16.3-6.8l96.3-96.3c15.7-15.7 24.4-36.6 24.4-58.7 0-22.2-8.6-43.1-24.3-58.8-15.7-15.7-36.6-24.3-58.7-24.3-20 0-38.9 7-54 19.9-15.1-13-34.1-20-54.1-20-22.2 0-43 8.6-58.7 24.3s-24.3 36.6-24.3 58.8 8.7 43 24.4 58.7l96.4 96.4zm-79.3-196.7c11.1-11.1 25.7-17.1 41.4-17.1s30.4 6.1 41.5 17.2l4 4c4.8 4.8 12.5 4.8 17.3 0l3.9-3.9c11.1-11.1 25.8-17.2 41.5-17.2 15.6 0 30.3 6.1 41.4 17.2 11.1 11.1 17.2 25.8 17.1 41.4 0 15.7-6.1 30.4-17.2 41.5l-95.3 95.3-95.5-95.5c-11.1-11.1-17.2-25.8-17.2-41.4 0-15.7 6.1-30.4 17.1-41.5z'/%3E%3Cpath d='M245.2 490.4c135.2 0 245.2-110 245.2-245.2S380.4 0 245.2 0 0 110 0 245.2s110 245.2 245.2 245.2zm0-465.9c121.7 0 220.7 99 220.7 220.7s-99 220.7-220.7 220.7-220.7-99-220.7-220.7 99-220.7 220.7-220.7z'/%3E%3C/svg%3E\"); }\n\n.emoji-picker nav a:after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  left: 0;\n  height: 2px;\n  border-radius: 5px;\n  background-color: #90caf9;\n  opacity: 0;\n  transition-delay: 1s;\n  transition: opacity .4s, background .2s; }\n\n.emoji-picker.people nav .people i {\n  opacity: 1; }\n\n.emoji-picker.people nav .people:after {\n  opacity: 1; }\n\n.emoji-picker.foods nav .foods i {\n  opacity: 1; }\n\n.emoji-picker.foods nav .foods:after {\n  opacity: 1; }\n\n.emoji-picker.nature nav .nature i {\n  opacity: 1; }\n\n.emoji-picker.nature nav .nature:after {\n  opacity: 1; }\n\n.emoji-picker.activity nav .activity i {\n  opacity: 1; }\n\n.emoji-picker.activity nav .activity:after {\n  opacity: 1; }\n\n.emoji-picker.objects nav .objects i {\n  opacity: 1; }\n\n.emoji-picker.objects nav .objects:after {\n  opacity: 1; }\n\n.emoji-picker.places nav .places i {\n  opacity: 1; }\n\n.emoji-picker.places nav .places:after {\n  opacity: 1; }\n\n.emoji-picker.flags nav .flags i {\n  opacity: 1; }\n\n.emoji-picker.flags nav .flags:after {\n  opacity: 1; }\n\n.emoji-picker.symbols nav .symbols i {\n  opacity: 1; }\n\n.emoji-picker.symbols nav .symbols:after {\n  opacity: 1; }\n", ""]);

// exports


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(20);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(23);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(24);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _throttleDebounce = __webpack_require__(58);

var _DiversityPicker = __webpack_require__(118);

var _DiversityPicker2 = _interopRequireDefault(_DiversityPicker);

var _EmojiList = __webpack_require__(126);

var _EmojiList2 = _interopRequireDefault(_EmojiList);

__webpack_require__(135);

var _helpers = __webpack_require__(137);

var _constants = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isFFMac = (0, _helpers.isFirefoxOnMac)();

var WrapperSection = function (_Component) {
    (0, _inherits3.default)(WrapperSection, _Component);

    function WrapperSection(props) {
        (0, _classCallCheck3.default)(this, WrapperSection);

        var _this = (0, _possibleConstructorReturn3.default)(this, (WrapperSection.__proto__ || (0, _getPrototypeOf2.default)(WrapperSection)).call(this, props));

        _this.onScroll = (0, _throttleDebounce.throttle)(16, _this.onScroll.bind(_this));
        _this.hideScrollIndicator = (0, _throttleDebounce.debounce)(_constants.HIDE_SCROLL_DEBOUNCE, _this.hideScrollIndicator.bind(_this));

        _this._emojiName = null;
        return _this;
    }

    (0, _createClass3.default)(WrapperSection, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.headerHeight = this._list.querySelector('.category-name').clientHeight;
            this.scrollbarWidth = (0, _helpers.getScrollbarWidth)();
            this.hideNativeScrollbar();
            var positions = (0, _helpers.getOffsets)(this._list);
            this.offsets = positions.offsets;
            this.scrollHeight = positions.scrollHeight;
            this.listHeight = positions.listHeight;
            this.listWidth = positions.listWidth;
            this._categories = this._list.children;
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var positions = (0, _helpers.getOffsets)(this._list);
            this.offsets = positions.offsets;
            this.scrollHeight = positions.scrollHeight;
        }
    }, {
        key: 'onScroll',
        value: function onScroll() {

            var scrollTop = this._list.scrollTop,
                active = this.props.activeCategory,
                _active = this._categories[active];

            if (!isFFMac && !(this.scrollHeight <= this.listHeight)) {
                (0, _helpers.adjustScrollbar)(this.scrollHeight, scrollTop, this.listHeight, this._scroller);
                this.hideScrollIndicator();
                this._scroller.classList.add('shown');
            }

            this.props.suppressModifiers();
            this.props.closeDiversitiesMenu();

            this.proximity = (0, _helpers.getProximity)(this.offsets, scrollTop, this.listHeight, this.headerHeight);

            var _proximity = this.proximity,
                proximityIndex = _proximity.proximityIndex,
                activeCategory = _proximity.activeCategory,
                inViewPort = _proximity.inViewPort;


            if (this.props.filter) {
                this.props.setSeenInSearch(inViewPort);
                return this.transformed = (0, _helpers.clearTransform)(this.transformed);
            }

            this.props.setSeenCategory(activeCategory, inViewPort);

            // this block deals is for most cases - we're not near a title change
            if (typeof proximityIndex !== 'number') {
                if (activeCategory !== active) {
                    this.props.setActiveCategory({ index: activeCategory });
                }
                return this.transformed = (0, _helpers.clearTransform)(this.transformed);
            }
            var distance = -(scrollTop - this.offsets[proximityIndex]),
                _activeName = _active.firstElementChild,
                // active category name
            currentIsFirst = proximityIndex === 0,
                // is this the first category?
            currentIsActive = proximityIndex === active,
                // is the current category the active one
            scrollDirection = (0, _helpers.hitAnotherCategory)({ distance: distance, currentIsActive: currentIsActive, currentIsFirst: currentIsFirst });

            if (this.props.delayedCategory === proximityIndex || scrollDirection === 'next') {
                this.props.setActiveCategory({ index: proximityIndex });
            } else if (scrollDirection === 'prev') {
                this.props.setActiveCategory({ index: active - 1 });
            }

            if (!currentIsActive) {
                this.transformed = (0, _helpers.clearTransform)(this.transformed, active);

                // push the active title up or down
                _activeName.setAttribute('style', (0, _helpers.headerTransform)(distance, this.headerHeight));
                this.transformed.push({ index: active, element: _activeName });
            }
        }
    }, {
        key: 'hideScrollIndicator',
        value: function hideScrollIndicator() {
            this._scroller.classList.remove('shown');
        }
    }, {
        key: 'hideNativeScrollbar',
        value: function hideNativeScrollbar() {
            if (!isFFMac && this.scrollbarWidth > 0) {
                return this._list.style.width = this._list.offsetWidth + this.scrollbarWidth + 'px';
            }
        }
    }, {
        key: 'scrollToCategoryByIndex',
        value: function scrollToCategoryByIndex(index) {
            this._list.scrollTop = this.offsets[index];
        }
    }, {
        key: 'scrollTop',
        value: function scrollTop() {
            this._list.scrollTop = 0;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                filter = _props.filter,
                diversityPicker = _props.diversityPicker,
                closeDiversitiesMenu = _props.closeDiversitiesMenu,
                visibleCategories = _props.visibleCategories,
                modifiersSpread = _props.modifiersSpread,
                preload = _props.preload;
            var _context = this.context,
                assetPath = _context.assetPath,
                onEmojiClick = _context.onEmojiClick,
                emojiResolution = _context.emojiResolution,
                disableDiversityPicker = _context.disableDiversityPicker;


            var wrapperClassName = 'wrapper' + (filter && (0, _keys2.default)(filter).length === 0 ? ' no-results icn-magnifier' : '');

            return _react2.default.createElement(
                'section',
                { className: wrapperClassName },
                _react2.default.createElement(_DiversityPicker2.default, { index: diversityPicker,
                    assetPath: assetPath,
                    emojiResolution: emojiResolution,
                    onEmojiClick: onEmojiClick,
                    close: closeDiversitiesMenu,
                    disable: disableDiversityPicker }),
                _react2.default.createElement(
                    'div',
                    { className: 'scroller', ref: function ref(scroller) {
                            return _this2._scroller = scroller;
                        } },
                    _react2.default.createElement('div', null)
                ),
                _react2.default.createElement('span', { className: 'emoji-name', ref: function ref(emojiName) {
                        return _this2._emojiName = emojiName;
                    } }),
                _react2.default.createElement(_EmojiList2.default, { filter: filter,
                    onScroll: this.onScroll,
                    seenCategories: visibleCategories,
                    modifiersSpread: modifiersSpread,
                    preload: preload,
                    _emojiName: this._emojiName,
                    ref: function ref(list) {
                        return _this2._list = list ? list._list : null;
                    } })
            );
        }
    }]);
    return WrapperSection;
}(_react.Component);

exports.default = WrapperSection;


WrapperSection.propTypes = {
    filter: _propTypes2.default.object,
    diversityPicker: _propTypes2.default.number,
    closeDiversitiesMenu: _propTypes2.default.func,
    suppressModifiers: _propTypes2.default.func,
    setSeenCategory: _propTypes2.default.func,
    setSeenInSearch: _propTypes2.default.func,
    setActiveCategory: _propTypes2.default.func,
    visibleCategories: _propTypes2.default.object,
    modifiersSpread: _propTypes2.default.bool,
    activeCategory: _propTypes2.default.number,
    delayedCategory: _propTypes2.default.number,
    preload: _propTypes2.default.bool
};

WrapperSection.contextTypes = {
    onEmojiClick: _propTypes2.default.func,
    parent: _propTypes2.default.any,
    assetPath: _propTypes2.default.string,
    activeModifier: _propTypes2.default.string,
    emojiResolution: _propTypes2.default.number,
    disableDiversityPicker: _propTypes2.default.bool
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _emojiData = __webpack_require__(1);

var _emoji_accessor = __webpack_require__(43);

var _emoji_accessor2 = _interopRequireDefault(_emoji_accessor);

var _helpers = __webpack_require__(59);

__webpack_require__(124);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DiversityPicker(_ref) {
    var index = _ref.index,
        assetPath = _ref.assetPath,
        emojiResolution = _ref.emojiResolution,
        onEmojiClick = _ref.onEmojiClick,
        close = _ref.close,
        disable = _ref.disable;


    if (disable) {
        return null;
    }

    var className = 'diversity-picker' + (index ? ' shown' : ''),
        emoji = (0, _emoji_accessor2.default)(_emojiData.emojis[index]);

    var diversities = null;

    function _onClick(diversity, e) {
        onEmojiClick(diversity, emoji, e);
        setTimeout(close, 500);
    }

    if (emoji && emoji.diversities) {
        diversities = [emoji.unified].concat(emoji.diversities);
    }

    return _react2.default.createElement(
        'div',
        { className: className },
        diversities && diversities.map(function (diversity) {
            var style = (0, _helpers.bgImage)({ unified: diversity, assetPath: assetPath, emojiResolution: emojiResolution });
            return _react2.default.createElement('a', { key: diversity,
                style: style,
                className: 'emoji',
                onClick: function onClick(e) {
                    return _onClick(diversity, e);
                } });
        })
    );
}

DiversityPicker.propTypes = {
    index: _propTypes2.default.number,
    assetPath: _propTypes2.default.string,
    emojiResolution: _propTypes2.default.number,
    onEmojiClick: _propTypes2.default.func.isRequired,
    close: _propTypes2.default.func.isRequired,
    disable: _propTypes2.default.bool
};

exports.default = DiversityPicker;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = bgImage;

var _constants = __webpack_require__(17);

function bgImage(_ref) {
    var unified = _ref.unified,
        assetPath = _ref.assetPath,
        emojiResolution = _ref.emojiResolution;


    if (typeof assetPath === 'undefined') {
        assetPath = _constants.DEFAULT_CDN_PATH;
    }

    assetPath += emojiResolution ? '/' + emojiResolution : '/' + _constants.DEFAULT_IMAGE_RESOLUTION;

    return {
        'backgroundImage': 'url(' + assetPath + '/' + unified + '.png)'
    };
}

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _emojiData = __webpack_require__(1);

var keywordsSingleChar = {};

for (var keyword in _emojiData.keywords) {
    for (var i = 0; i < keyword.length; i++) {
        keywordsSingleChar[keyword[i]] = keywordsSingleChar[keyword[i]] || [];
        if (keywordsSingleChar[keyword[i]].indexOf(keyword) === -1) {
            keywordsSingleChar[keyword[i]].push(keyword);
        }
    }
}

exports.default = keywordsSingleChar;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(122);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/lib/loader.js!./base.scss", function() {
			var newContent = require("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/lib/loader.js!./base.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".emoji-picker .icn-magnifier:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg id='Capa_1' xmlns='http://www.w3.org/2000/svg' width='310.4' height='310.4'%3E%3Cstyle%3E.st0%7Bfill:%239e9e9e%7D%3C/style%3E%3Cpath class='st0' d='M273.6 215c49.1-49.1 49.1-129 0-178.1-49.1-49.1-129-49.1-178.1 0-41.7 41.7-48 103.6-18.9 152 0 0 2.1 3.5-.7 6.3l-64.3 64.3c-12.8 12.8-15.8 30.7-4.5 42l2 2c11.3 11.3 29.2 8.3 42-4.5l64.1-64.1c3-3 6.4-.9 6.4-.9 48.4 28.9 110.3 22.6 152-19zm-154.9-23.3c-36.3-36.3-36.3-95.3 0-131.6s95.3-36.3 131.6 0 36.3 95.3 0 131.6-95.3 36.3-131.6 0z'/%3E%3Cpath class='st0' d='M126.8 118.4c-1.7 0-3.4-.3-5.1-1-6.6-2.8-9.7-10.4-6.9-17 17.6-41.6 65.7-61.1 107.3-43.5 6.6 2.8 9.7 10.4 6.9 17-2.8 6.6-10.4 9.7-17 6.9-28.4-12-61.2 1.3-73.2 29.7-2.2 4.9-7 7.9-12 7.9z'/%3E%3C/svg%3E\"); }\n", ""]);

// exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = unifiedWithModifier;
function unifiedWithModifier(emoji, activeModifier) {
    if (activeModifier && emoji.hasOwnProperty('diversities')) {
        var currentDiversity = emoji.unified + '-' + activeModifier;
        if (emoji.diversities.indexOf(currentDiversity) > -1) {
            return currentDiversity;
        }
    }

    return emoji.unified;
}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(125);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./style.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".emoji-picker .icn-magnifier:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg id='Capa_1' xmlns='http://www.w3.org/2000/svg' width='310.4' height='310.4'%3E%3Cstyle%3E.st0%7Bfill:%239e9e9e%7D%3C/style%3E%3Cpath class='st0' d='M273.6 215c49.1-49.1 49.1-129 0-178.1-49.1-49.1-129-49.1-178.1 0-41.7 41.7-48 103.6-18.9 152 0 0 2.1 3.5-.7 6.3l-64.3 64.3c-12.8 12.8-15.8 30.7-4.5 42l2 2c11.3 11.3 29.2 8.3 42-4.5l64.1-64.1c3-3 6.4-.9 6.4-.9 48.4 28.9 110.3 22.6 152-19zm-154.9-23.3c-36.3-36.3-36.3-95.3 0-131.6s95.3-36.3 131.6 0 36.3 95.3 0 131.6-95.3 36.3-131.6 0z'/%3E%3Cpath class='st0' d='M126.8 118.4c-1.7 0-3.4-.3-5.1-1-6.6-2.8-9.7-10.4-6.9-17 17.6-41.6 65.7-61.1 107.3-43.5 6.6 2.8 9.7 10.4 6.9 17-2.8 6.6-10.4 9.7-17 6.9-28.4-12-61.2 1.3-73.2 29.7-2.2 4.9-7 7.9-12 7.9z'/%3E%3C/svg%3E\"); }\n\n.emoji-picker .diversity-picker {\n  background-color: #fafafa;\n  display: flex;\n  justify-content: space-around;\n  flex-direction: row-reverse;\n  position: absolute;\n  z-index: 3;\n  left: 0;\n  top: 0;\n  right: 0;\n  height: 30px;\n  transform: translateY(-30px);\n  opacity: .6;\n  transition: .2s opacity, .2s transform; }\n  .emoji-picker .diversity-picker.shown {\n    transform: translateY(0);\n    opacity: 1;\n    border-bottom: 1px solid #eeeeee; }\n  .emoji-picker .diversity-picker .emoji {\n    display: inline-block; }\n", ""]);

// exports


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(20);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(23);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(24);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _emojiData = __webpack_require__(1);

var _EmojiCategory = __webpack_require__(127);

var _EmojiCategory2 = _interopRequireDefault(_EmojiCategory);

__webpack_require__(133);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmojiList = function (_Component) {
    (0, _inherits3.default)(EmojiList, _Component);

    function EmojiList() {
        (0, _classCallCheck3.default)(this, EmojiList);
        return (0, _possibleConstructorReturn3.default)(this, (EmojiList.__proto__ || (0, _getPrototypeOf2.default)(EmojiList)).apply(this, arguments));
    }

    (0, _createClass3.default)(EmojiList, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState, _ref) {
            var activeModifier = _ref.activeModifier;

            if (nextProps.modifiersSpread) {
                return false;
            }

            if (nextProps.filter || !nextProps.filter && this.props.filter) {
                return true;
            }

            if (this.props._emojiName !== nextProps._emojiName) {
                return true;
            }

            if (activeModifier !== this.context.activeModifier) {
                return true;
            }

            return (0, _keys2.default)(nextProps.seenCategories).length !== (0, _keys2.default)(this.props.seenCategories).length;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                filter = _props.filter,
                onScroll = _props.onScroll,
                seenCategories = _props.seenCategories,
                preload = _props.preload,
                customCategoryNames = _props.customCategoryNames,
                _emojiName = _props._emojiName;

            var filterClass = filter ? ' filter' : '';
            return _react2.default.createElement(
                'div',
                { className: 'emoji-list' + filterClass,
                    ref: function ref(list) {
                        return _this2._list = list;
                    },
                    onScroll: onScroll },
                _emojiData.categories.map(function (category, index) {
                    var isCategorySeen = preload || seenCategories[index];

                    return _react2.default.createElement(_EmojiCategory2.default, { category: category,
                        index: index,
                        key: index,
                        filter: filter,
                        customCategoryNames: customCategoryNames,
                        _emojiName: _emojiName,
                        categorySeen: isCategorySeen });
                })
            );
        }
    }]);
    return EmojiList;
}(_react.Component);

EmojiList.propTypes = {
    filter: _propTypes2.default.object,
    onScroll: _propTypes2.default.func.isRequired,
    seenCategories: _propTypes2.default.object.isRequired,
    preload: _propTypes2.default.bool,
    _emojiName: _propTypes2.default.object,
    customCategoryNames: _propTypes2.default.object
};

EmojiList.contextTypes = {
    activeModifier: _propTypes2.default.string
};

exports.default = EmojiList;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _emojiData = __webpack_require__(1);

var _emoji_accessor = __webpack_require__(43);

var _emoji_accessor2 = _interopRequireDefault(_emoji_accessor);

var _Emoji = __webpack_require__(128);

var _Emoji2 = _interopRequireDefault(_Emoji);

__webpack_require__(131);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EmojiCategory(_ref, _ref2) {
    var index = _ref.index,
        category = _ref.category,
        filter = _ref.filter,
        categorySeen = _ref.categorySeen,
        _emojiName = _ref._emojiName;
    var customCategoryNames = _ref2.customCategoryNames;

    var hiddenClass = filter && !filter.hasOwnProperty(category.name) ? ' hidden' : '';

    var categoryName = customCategoryNames && customCategoryNames[category.name] ? customCategoryNames[category.name] : '#' + category.name;

    return _react2.default.createElement(
        'div',
        { className: 'emoji-category ' + category.name + hiddenClass, key: index },
        _react2.default.createElement(
            'div',
            { className: 'category-name' },
            categoryName
        ),
        categorySeen && category.members.map(function (member, index) {

            var emoji = _emojiData.emojis[member],
                hidden = filter && !(filter.hasOwnProperty(category.name) && filter[category.name].hasOwnProperty(member));

            if (!emoji) {
                return null;
            }

            return _react2.default.createElement(_Emoji2.default, { member: member,
                emoji: (0, _emoji_accessor2.default)(emoji),
                key: index,
                hidden: hidden,
                _emojiName: _emojiName,
                categorySeen: categorySeen });
        })
    );
}

EmojiCategory.propTypes = {
    index: _propTypes2.default.number.isRequired,
    category: _propTypes2.default.object.isRequired,
    filter: _propTypes2.default.object,
    categorySeen: _propTypes2.default.bool,
    _emojiName: _propTypes2.default.object
};

EmojiCategory.contextTypes = {
    customCategoryNames: _propTypes2.default.object
};

exports.default = EmojiCategory;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(20);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(23);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(24);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _helpers = __webpack_require__(59);

var _constants = __webpack_require__(17);

__webpack_require__(129);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Emoji = function (_Component) {
    (0, _inherits3.default)(Emoji, _Component);

    function Emoji(props) {
        (0, _classCallCheck3.default)(this, Emoji);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Emoji.__proto__ || (0, _getPrototypeOf2.default)(Emoji)).call(this, props));

        _this.emoji = props.emoji;
        _this.hasDiversities = _this.emoji.hasOwnProperty('diversities');

        _this.onClick = _this.onClick.bind(_this);
        _this.emojiChosen = _this.emojiChosen.bind(_this);
        _this.onMouseEnter = _this.onMouseEnter.bind(_this);
        _this.onMouseLeave = _this.onMouseLeave.bind(_this);
        _this.onMouseDown = _this.onMouseDown.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(Emoji, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState, nextContext) {

            var visibilityChanged = nextProps.hidden !== this.props.hidden,
                categoryVisibilityChanged = nextProps.categorySeen !== this.props.categorySeen,
                hasDiversities = this.hasDiversities,
                activeModifierChanged = hasDiversities && nextContext.activeModifier !== this.context.activeModifier;

            return visibilityChanged || categoryVisibilityChanged || activeModifierChanged;
        }
    }, {
        key: 'onClick',
        value: function onClick(e) {
            e.preventDefault();
        }
    }, {
        key: 'emojiChosen',
        value: function emojiChosen(e) {
            var emoji = this.props.emoji;

            var onEmojiClick = this.context.onEmojiClick;

            onEmojiClick && onEmojiClick(emoji.unified, emoji, e);

            if (!e.defaultPrevented) {
                e.preventDefault();
            }
        }
    }, {
        key: 'onMouseEnter',
        value: function onMouseEnter() {
            var _this2 = this;

            if (this.props._emojiName) {
                this.props._emojiName.textContent = this.emoji.name;
            }

            if (!this.hasDiversities || this.props.disableDiversityPicker) {
                return;
            }

            this.onMouseEnterTimeout = setTimeout(function () {
                _this2.context.openDiversitiesMenu(_this2.props.member);
            }, _constants.OPEN_DIVERSITIES_TIMEOUT);
        }
    }, {
        key: 'onMouseLeave',
        value: function onMouseLeave(e) {

            clearTimeout(this.onMouseEnterTimeout);

            if (e.relatedTarget && e.relatedTarget.classList && e.relatedTarget.classList.contains('emoji')) {
                return;
            }

            if (this.props._emojiName) {
                this.props._emojiName.textContent = '';
            }
        }
    }, {
        key: 'onMouseDown',
        value: function onMouseDown() {
            var _this3 = this;

            clearTimeout(this.onMouseEnterTimeout);

            if (!this.hasDiversities || this.props.disableDiversityPicker) {
                return;
            }

            this.timeCounter = Date.now();

            this.diversitiesTimeout = setTimeout(function () {
                delete _this3.diversitiesTimeout;
                _this3.context.openDiversitiesMenu(_this3.props.member);
            }, _constants.OPEN_DIVERSITIES_TIMEOUT);
        }
    }, {
        key: 'onMouseUp',
        value: function onMouseUp(e) {

            var counter = this.timeCounter;
            clearTimeout(this.diversitiesTimeout);
            delete this.timeCounter;

            if (!(counter && Date.now() - counter >= _constants.OPEN_DIVERSITIES_TIMEOUT)) {
                return this.emojiChosen(e);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                emoji = _props.emoji,
                hidden = _props.hidden,
                categorySeen = _props.categorySeen;
            var _context = this.context,
                activeModifier = _context.activeModifier,
                assetPath = _context.assetPath,
                emojiResolution = _context.emojiResolution;

            var unified = emoji.unified;
            var shownClass = categorySeen && !hidden ? ' shown' : '';

            unified = (0, _helpers.unifiedWithModifier)(emoji, activeModifier);

            var className = 'emoji' + (this.hasDiversities ? ' has-diversities' : '') + shownClass;

            var style = (0, _helpers.bgImage)({ unified: unified, assetPath: assetPath, emojiResolution: emojiResolution });
            style.order = emoji.order;

            return _react2.default.createElement('a', { className: className,
                onClick: this.onClick,
                onMouseEnter: this.onMouseEnter,
                onMouseLeave: this.onMouseLeave,
                onMouseDown: this.onMouseDown,
                onMouseUp: this.onMouseUp,
                tabIndex: emoji.order,
                style: style });
        }
    }]);
    return Emoji;
}(_react.Component);

Emoji.propTypes = {
    emoji: _propTypes2.default.object.isRequired,
    hidden: _propTypes2.default.bool,
    categorySeen: _propTypes2.default.bool,
    member: _propTypes2.default.number.isRequired,
    disableDiversityPicker: _propTypes2.default.bool,
    _emojiName: _propTypes2.default.object
};

Emoji.contextTypes = {
    onEmojiClick: _propTypes2.default.func,
    parent: _propTypes2.default.any,
    assetPath: _propTypes2.default.string,
    activeModifier: _propTypes2.default.string,
    emojiResolution: _propTypes2.default.number,
    openDiversitiesMenu: _propTypes2.default.func,
    disableDiversityPicker: _propTypes2.default.bool
};

exports.default = Emoji;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(130);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./style.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".emoji-picker .icn-magnifier:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg id='Capa_1' xmlns='http://www.w3.org/2000/svg' width='310.4' height='310.4'%3E%3Cstyle%3E.st0%7Bfill:%239e9e9e%7D%3C/style%3E%3Cpath class='st0' d='M273.6 215c49.1-49.1 49.1-129 0-178.1-49.1-49.1-129-49.1-178.1 0-41.7 41.7-48 103.6-18.9 152 0 0 2.1 3.5-.7 6.3l-64.3 64.3c-12.8 12.8-15.8 30.7-4.5 42l2 2c11.3 11.3 29.2 8.3 42-4.5l64.1-64.1c3-3 6.4-.9 6.4-.9 48.4 28.9 110.3 22.6 152-19zm-154.9-23.3c-36.3-36.3-36.3-95.3 0-131.6s95.3-36.3 131.6 0 36.3 95.3 0 131.6-95.3 36.3-131.6 0z'/%3E%3Cpath class='st0' d='M126.8 118.4c-1.7 0-3.4-.3-5.1-1-6.6-2.8-9.7-10.4-6.9-17 17.6-41.6 65.7-61.1 107.3-43.5 6.6 2.8 9.7 10.4 6.9 17-2.8 6.6-10.4 9.7-17 6.9-28.4-12-61.2 1.3-73.2 29.7-2.2 4.9-7 7.9-12 7.9z'/%3E%3C/svg%3E\"); }\n\n.emoji-picker .emoji {\n  border-radius: 5px;\n  height: 20px;\n  width: 20px;\n  padding: 5px;\n  background-size: 20px;\n  background-repeat: no-repeat;\n  background-position: 50% 50%;\n  overflow: hidden;\n  transition: background-color .2s;\n  display: none; }\n  .emoji-picker .emoji.shown {\n    display: inline-block; }\n  .emoji-picker .emoji:hover {\n    background-color: #bbdefb; }\n    .emoji-picker .emoji:hover.has-diversities:before {\n      opacity: 1; }\n  .emoji-picker .emoji.has-diversities:before {\n    content: '';\n    background-color: #f5f5f5;\n    display: block;\n    height: 8px;\n    width: 8px;\n    float: right;\n    opacity: 0;\n    transform: translateY(-6px) translateX(6px);\n    transition: opacity .2s; }\n", ""]);

// exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(132);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./style.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".emoji-picker .icn-magnifier:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg id='Capa_1' xmlns='http://www.w3.org/2000/svg' width='310.4' height='310.4'%3E%3Cstyle%3E.st0%7Bfill:%239e9e9e%7D%3C/style%3E%3Cpath class='st0' d='M273.6 215c49.1-49.1 49.1-129 0-178.1-49.1-49.1-129-49.1-178.1 0-41.7 41.7-48 103.6-18.9 152 0 0 2.1 3.5-.7 6.3l-64.3 64.3c-12.8 12.8-15.8 30.7-4.5 42l2 2c11.3 11.3 29.2 8.3 42-4.5l64.1-64.1c3-3 6.4-.9 6.4-.9 48.4 28.9 110.3 22.6 152-19zm-154.9-23.3c-36.3-36.3-36.3-95.3 0-131.6s95.3-36.3 131.6 0 36.3 95.3 0 131.6-95.3 36.3-131.6 0z'/%3E%3Cpath class='st0' d='M126.8 118.4c-1.7 0-3.4-.3-5.1-1-6.6-2.8-9.7-10.4-6.9-17 17.6-41.6 65.7-61.1 107.3-43.5 6.6 2.8 9.7 10.4 6.9 17-2.8 6.6-10.4 9.7-17 6.9-28.4-12-61.2 1.3-73.2 29.7-2.2 4.9-7 7.9-12 7.9z'/%3E%3C/svg%3E\"); }\n\n.emoji-picker .emoji-category {\n  position: relative;\n  padding: 30px 5px 0 5px;\n  margin: 0;\n  text-align: left;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: flex-start; }\n  .emoji-picker .emoji-category .category-name {\n    background-color: rgba(255, 255, 255, 0.9);\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 0;\n    display: block;\n    padding: 0 10px;\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: .1em;\n    text-transform: uppercase;\n    color: #bdbdbd;\n    height: 30px;\n    line-height: 30px;\n    box-sizing: border-box;\n    transition: color .2s; }\n\n.emoji-picker.people .people.emoji-category {\n  position: initial; }\n  .emoji-picker.people .people.emoji-category .category-name {\n    color: #9e9e9e; }\n\n.emoji-picker.foods .foods.emoji-category {\n  position: initial; }\n  .emoji-picker.foods .foods.emoji-category .category-name {\n    color: #9e9e9e; }\n\n.emoji-picker.nature .nature.emoji-category {\n  position: initial; }\n  .emoji-picker.nature .nature.emoji-category .category-name {\n    color: #9e9e9e; }\n\n.emoji-picker.activity .activity.emoji-category {\n  position: initial; }\n  .emoji-picker.activity .activity.emoji-category .category-name {\n    color: #9e9e9e; }\n\n.emoji-picker.objects .objects.emoji-category {\n  position: initial; }\n  .emoji-picker.objects .objects.emoji-category .category-name {\n    color: #9e9e9e; }\n\n.emoji-picker.places .places.emoji-category {\n  position: initial; }\n  .emoji-picker.places .places.emoji-category .category-name {\n    color: #9e9e9e; }\n\n.emoji-picker.flags .flags.emoji-category {\n  position: initial; }\n  .emoji-picker.flags .flags.emoji-category .category-name {\n    color: #9e9e9e; }\n\n.emoji-picker.regional .regional.emoji-category {\n  position: initial; }\n  .emoji-picker.regional .regional.emoji-category .category-name {\n    color: #9e9e9e; }\n\n.emoji-picker.symbols .symbols.emoji-category {\n  position: initial; }\n  .emoji-picker.symbols .symbols.emoji-category .category-name {\n    color: #9e9e9e; }\n", ""]);

// exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(134);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./style.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".emoji-picker .icn-magnifier:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg id='Capa_1' xmlns='http://www.w3.org/2000/svg' width='310.4' height='310.4'%3E%3Cstyle%3E.st0%7Bfill:%239e9e9e%7D%3C/style%3E%3Cpath class='st0' d='M273.6 215c49.1-49.1 49.1-129 0-178.1-49.1-49.1-129-49.1-178.1 0-41.7 41.7-48 103.6-18.9 152 0 0 2.1 3.5-.7 6.3l-64.3 64.3c-12.8 12.8-15.8 30.7-4.5 42l2 2c11.3 11.3 29.2 8.3 42-4.5l64.1-64.1c3-3 6.4-.9 6.4-.9 48.4 28.9 110.3 22.6 152-19zm-154.9-23.3c-36.3-36.3-36.3-95.3 0-131.6s95.3-36.3 131.6 0 36.3 95.3 0 131.6-95.3 36.3-131.6 0z'/%3E%3Cpath class='st0' d='M126.8 118.4c-1.7 0-3.4-.3-5.1-1-6.6-2.8-9.7-10.4-6.9-17 17.6-41.6 65.7-61.1 107.3-43.5 6.6 2.8 9.7 10.4 6.9 17-2.8 6.6-10.4 9.7-17 6.9-28.4-12-61.2 1.3-73.2 29.7-2.2 4.9-7 7.9-12 7.9z'/%3E%3C/svg%3E\"); }\n\n.emoji-picker .emoji-list {\n  width: 100%;\n  height: 240px;\n  padding: 0;\n  overflow-x: hidden;\n  box-sizing: border-box;\n  -ms-overflow-style: none; }\n  .emoji-picker .emoji-list::-webkit-scrollbar {\n    height: 0;\n    width: 0; }\n  .emoji-picker .emoji-list::scrollbar {\n    height: 0;\n    width: 0; }\n  .emoji-picker .emoji-list.filter:before {\n    content: '';\n    background: #ffffff;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    height: 30px;\n    z-index: 1;\n    opacity: 0.9; }\n  .emoji-picker .emoji-list.filter .category-name {\n    background: none;\n    z-index: 1; }\n  .emoji-picker .emoji-list:not(.filter) .emoji-category {\n    min-height: 100%; }\n", ""]);

// exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(136);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./style.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".emoji-picker .icn-magnifier:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg id='Capa_1' xmlns='http://www.w3.org/2000/svg' width='310.4' height='310.4'%3E%3Cstyle%3E.st0%7Bfill:%239e9e9e%7D%3C/style%3E%3Cpath class='st0' d='M273.6 215c49.1-49.1 49.1-129 0-178.1-49.1-49.1-129-49.1-178.1 0-41.7 41.7-48 103.6-18.9 152 0 0 2.1 3.5-.7 6.3l-64.3 64.3c-12.8 12.8-15.8 30.7-4.5 42l2 2c11.3 11.3 29.2 8.3 42-4.5l64.1-64.1c3-3 6.4-.9 6.4-.9 48.4 28.9 110.3 22.6 152-19zm-154.9-23.3c-36.3-36.3-36.3-95.3 0-131.6s95.3-36.3 131.6 0 36.3 95.3 0 131.6-95.3 36.3-131.6 0z'/%3E%3Cpath class='st0' d='M126.8 118.4c-1.7 0-3.4-.3-5.1-1-6.6-2.8-9.7-10.4-6.9-17 17.6-41.6 65.7-61.1 107.3-43.5 6.6 2.8 9.7 10.4 6.9 17-2.8 6.6-10.4 9.7-17 6.9-28.4-12-61.2 1.3-73.2 29.7-2.2 4.9-7 7.9-12 7.9z'/%3E%3C/svg%3E\"); }\n\n.emoji-picker .wrapper {\n  position: relative;\n  overflow: hidden; }\n  .emoji-picker .wrapper.no-results:before {\n    content: '';\n    background-repeat: no-repeat;\n    background-image: url(\"data:image/svg+xml,%3Csvg id='Capa_1' xmlns='http://www.w3.org/2000/svg' width='310.4' height='310.4'%3E%3Cstyle%3E.st0%7Bfill:%239e9e9e%7D%3C/style%3E%3Cpath class='st0' d='M273.6 215c49.1-49.1 49.1-129 0-178.1-49.1-49.1-129-49.1-178.1 0-41.7 41.7-48 103.6-18.9 152 0 0 2.1 3.5-.7 6.3l-64.3 64.3c-12.8 12.8-15.8 30.7-4.5 42l2 2c11.3 11.3 29.2 8.3 42-4.5l64.1-64.1c3-3 6.4-.9 6.4-.9 48.4 28.9 110.3 22.6 152-19zm-154.9-23.3c-36.3-36.3-36.3-95.3 0-131.6s95.3-36.3 131.6 0 36.3 95.3 0 131.6-95.3 36.3-131.6 0z'/%3E%3Cpath class='st0' d='M126.8 118.4c-1.7 0-3.4-.3-5.1-1-6.6-2.8-9.7-10.4-6.9-17 17.6-41.6 65.7-61.1 107.3-43.5 6.6 2.8 9.7 10.4 6.9 17-2.8 6.6-10.4 9.7-17 6.9-28.4-12-61.2 1.3-73.2 29.7-2.2 4.9-7 7.9-12 7.9z'/%3E%3C/svg%3E\");\n    background-position: 50% 50%;\n    background-size: 100px 100px;\n    display: block;\n    width: 100px;\n    height: 100px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    opacity: .07;\n    transform: translateX(-50%) translateY(-50%); }\n  .emoji-picker .wrapper.no-results .emoji-name {\n    display: none; }\n  .emoji-picker .wrapper:after {\n    content: '';\n    background-color: #ffffff;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 5px; }\n  .emoji-picker .wrapper .scroller {\n    display: block;\n    position: absolute;\n    width: 5px;\n    padding-top: 5px;\n    z-index: 2;\n    right: 3px;\n    box-sizing: border-box;\n    opacity: 0;\n    transition: opacity .2s; }\n    .emoji-picker .wrapper .scroller.shown {\n      opacity: 1; }\n    .emoji-picker .wrapper .scroller div {\n      background-color: #bdbdbd;\n      width: 100%;\n      min-height: 12px; }\n  .emoji-picker .wrapper .emoji-name {\n    position: absolute;\n    right: 10px;\n    top: 8px;\n    font-size: 10px;\n    font-weight: 100;\n    z-index: 2;\n    color: #9e9e9e;\n    max-width: 130px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis; }\n", ""]);

// exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isFirefoxOnMac = exports.headerTransform = exports.hitAnotherCategory = exports.getScrollbarWidth = exports.getProximity = exports.getOffsets = exports.clearTransform = exports.adjustScrollbar = undefined;

var _adjust_scrollbar = __webpack_require__(138);

var _adjust_scrollbar2 = _interopRequireDefault(_adjust_scrollbar);

var _clear_transform = __webpack_require__(139);

var _clear_transform2 = _interopRequireDefault(_clear_transform);

var _get_offsets = __webpack_require__(140);

var _get_offsets2 = _interopRequireDefault(_get_offsets);

var _get_proximity = __webpack_require__(141);

var _get_proximity2 = _interopRequireDefault(_get_proximity);

var _get_scrollbar_width = __webpack_require__(142);

var _get_scrollbar_width2 = _interopRequireDefault(_get_scrollbar_width);

var _hit_another_category = __webpack_require__(143);

var _hit_another_category2 = _interopRequireDefault(_hit_another_category);

var _header_transform = __webpack_require__(148);

var _header_transform2 = _interopRequireDefault(_header_transform);

var _is_firefox_on_mac = __webpack_require__(149);

var _is_firefox_on_mac2 = _interopRequireDefault(_is_firefox_on_mac);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.adjustScrollbar = _adjust_scrollbar2.default;
exports.clearTransform = _clear_transform2.default;
exports.getOffsets = _get_offsets2.default;
exports.getProximity = _get_proximity2.default;
exports.getScrollbarWidth = _get_scrollbar_width2.default;
exports.hitAnotherCategory = _hit_another_category2.default;
exports.headerTransform = _header_transform2.default;
exports.isFirefoxOnMac = _is_firefox_on_mac2.default;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = adjustScrollbar;

var _constants = __webpack_require__(17);

function adjustScrollbar(scrollHeight, scrollTop, listHeight, _scroller) {

    var scrollbarHeight = Math.floor(listHeight / (scrollHeight / listHeight) * 0.8);

    var wholeRange = scrollHeight - listHeight,
        visibleRange = listHeight - (scrollbarHeight < _constants.MIN_SCROLLBAR_HEIGHT_PADDED ? _constants.MIN_SCROLLBAR_HEIGHT_PADDED : scrollbarHeight) - 5,
        newPos = scrollTop * visibleRange / wholeRange;

    _scroller.setAttribute('style', 'transform: translateY(' + newPos + 'px)');
    _scroller.children[0].setAttribute('style', 'height: ' + scrollbarHeight + 'px');
}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = clearTransform;
function clearTransform(transformed, keep) {

    if (!Array.isArray(transformed) || transformed.length === 0) {
        return [];
    }

    var newList = [];

    transformed.forEach(function (categoryName) {
        if (categoryName.index === keep) {
            newList.push(categoryName);
            return;
        }

        categoryName.element.removeAttribute('style');
    });

    return newList;
}

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getOffsets;
function getOffsets(_list) {
    var scrollHeight = _list.scrollHeight,
        listHeight = _list.offsetHeight,
        offsets = [];
    Array.prototype.forEach.call(_list.children, function (node) {
        offsets.push(node.offsetTop);
    });

    return { scrollHeight: scrollHeight, listHeight: listHeight, offsets: offsets };
}

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getProximity;
function checkIfActiveCategory(_ref) {
    var offset = _ref.offset,
        offsets = _ref.offsets,
        scrollTop = _ref.scrollTop,
        next = _ref.next;

    return offset <= scrollTop && (offsets[next] >= scrollTop || offsets[next] === undefined);
}

function isInViewport(_ref2) {
    var scrollTop = _ref2.scrollTop,
        listHeight = _ref2.listHeight,
        offsets = _ref2.offsets,
        index = _ref2.index;

    return offsets[index] <= listHeight + scrollTop && offsets[index] >= scrollTop;
}

function isElementInProximity(_ref3) {
    var scrollTop = _ref3.scrollTop,
        offset = _ref3.offset,
        headerHeight = _ref3.headerHeight;

    var elementIsUp = scrollTop + headerHeight >= offset,
        elementIsDown = scrollTop - headerHeight <= offset;

    return elementIsDown && elementIsUp; // logically not true, better naming needed
}

function getProximity(offsets) {
    var scrollTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var listHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var headerHeight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 30;

    // gets the closest categoryw

    offsets = offsets || [0];

    var proximityIndex = null,
        activeCategory = void 0;

    var inViewPort = {};

    for (var index = 0; index < offsets.length; index++) {
        var offset = offsets[index],
            next = index + 1,
            inProximity = isElementInProximity({ scrollTop: scrollTop, offset: offset, headerHeight: headerHeight }),
            isActiveCategory = checkIfActiveCategory({ offset: offset, offsets: offsets, scrollTop: scrollTop, next: next }),
            isVisible = isInViewport({ scrollTop: scrollTop, listHeight: listHeight, offsets: offsets, index: index });

        if (isVisible) {
            inViewPort[index] = true;
        }

        if (isActiveCategory) {
            activeCategory = index;
        }

        if (inProximity) {
            proximityIndex = index;
        }
    }

    return {
        proximityIndex: proximityIndex,
        activeCategory: activeCategory,
        inViewPort: inViewPort
    };
}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getScrollbarWidth;
function getScrollbarWidth() {
    var outer = document.createElement('div'),
        inner = document.createElement('div');
    outer.setAttribute('style', 'width: 50px;height:50px;overflow-y:scroll;border:none;');
    inner.setAttribute('style', 'height:100px;width:100%;border:none;');

    outer.appendChild(inner);
    document.body.appendChild(outer);

    var w1 = outer.offsetWidth,
        w2 = inner.clientWidth;

    document.body.removeChild(outer);

    var size = w1 - w2;

    return size;
}

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _is = __webpack_require__(144);

var _is2 = _interopRequireDefault(_is);

exports.default = hitAnotherCategory;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hitAnotherCategory(_ref) {
    var distance = _ref.distance,
        currentIsActive = _ref.currentIsActive,
        currentIsFirst = _ref.currentIsFirst;


    if ((0, _is2.default)(distance, 0) || distance < 0 && !currentIsActive) {
        return 'next';
    } else if (!currentIsFirst && distance >= 0 && currentIsActive) {
        return 'prev';
    }
}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(145), __esModule: true };

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(146);
module.exports = __webpack_require__(0).Object.is;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(6);
$export($export.S, 'Object', { is: __webpack_require__(147) });


/***/ }),
/* 147 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = headerTransform;
function headerTransform() {
    var distance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var headerHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;

    distance = parseInt(distance, 10) || 0;
    return "transform: translateY(" + (distance - headerHeight) + "px);";
}

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isFirefoxOnMac;
function isFirefoxOnMac() {

    if (typeof navigator === 'undefined') {
        return;
    }

    var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1,
        isMac = navigator.platform.indexOf('Mac') > -1;

    return isFirefox && isMac;
}

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(20);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(23);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(24);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _throttleDebounce = __webpack_require__(58);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _helpers = __webpack_require__(151);

var _constants = __webpack_require__(17);

__webpack_require__(156);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchBar = function (_Component) {
    (0, _inherits3.default)(SearchBar, _Component);

    function SearchBar(props) {
        (0, _classCallCheck3.default)(this, SearchBar);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SearchBar.__proto__ || (0, _getPrototypeOf2.default)(SearchBar)).call(this, props));

        _this.onChange = (0, _throttleDebounce.debounce)(_constants.FILTER_UPDATE_DEBOUNCE, props.onChange);
        _this.filterStack = [];

        _this.filterKeywords = (0, _throttleDebounce.debounce)(50, _this.filterKeywords.bind(_this));
        return _this;
    }

    (0, _createClass3.default)(SearchBar, [{
        key: 'addToStack',
        value: function addToStack(currentFilter) {

            var stack = this.filterStack,
                stackLength = stack.length;

            if (stackLength && stack[stackLength - 1].text === currentFilter.text) {
                return;
            }

            this.filterStack.push(currentFilter);
        }
    }, {
        key: 'filterKeywords',
        value: function filterKeywords() {

            var text = this._input.value.trim().toLowerCase();

            if (!text) {
                this.filterStack = [];
                return this.onChange(null);
            }

            this.filterStack = this.filterStack || [];

            var textLength = text.length;

            if (this.filterStack.length > textLength) {
                this.filterStack = this.filterStack.slice(0, textLength);
            }

            var stackIndex = (0, _helpers.textIndexInStack)(text, this.filterStack);

            var matches = void 0;

            if (stackIndex > -1) {
                this.filterStack.length = stackIndex + 1;
                var skip = false;

                // if the text is shorter than the last item in the stack
                // but the full text is not in the stack
                if (text.length < this.filterStack[stackIndex].text.length) {
                    skip = true;
                    this.filterStack.forEach(function (stackItem) {
                        if (stackItem.text === text) {
                            skip = false;
                        }
                    });
                }

                if (!skip) {
                    matches = (0, _helpers.stackFilter)(stackIndex, text, this.filterStack);
                    if ((0, _keys2.default)(matches).length) {
                        this.addToStack({ text: text, matches: matches });
                        return this.onChange(matches);
                    }
                }
            }

            matches = (0, _helpers.findMatches)(text);

            this.filterStack = [];

            if (!matches.length) {
                return this.onChange({});
            }

            matches = (0, _helpers.reduceEmojis)(matches);

            this.filterStack.push({ text: text, matches: matches });
            this.onChange(matches);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'search-bar' },
                _react2.default.createElement('input', { type: 'text', placeholder: 'Emoji Search', onChange: this.filterKeywords, ref: function ref(_input) {
                        return _this2._input = _input;
                    } }),
                _react2.default.createElement('i', { className: 'icn-magnifier' })
            );
        }
    }]);
    return SearchBar;
}(_react.Component);

SearchBar.propTypes = {
    onChange: _propTypes2.default.func.isRequired
};

exports.default = SearchBar;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.textIndexInStack = exports.findMatches = exports.stackFilter = exports.reduceEmojis = undefined;

var _reduce_emojis = __webpack_require__(152);

var _reduce_emojis2 = _interopRequireDefault(_reduce_emojis);

var _stack_filter = __webpack_require__(153);

var _stack_filter2 = _interopRequireDefault(_stack_filter);

var _text_index_in_stack = __webpack_require__(154);

var _text_index_in_stack2 = _interopRequireDefault(_text_index_in_stack);

var _find_matches = __webpack_require__(155);

var _find_matches2 = _interopRequireDefault(_find_matches);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.reduceEmojis = _reduce_emojis2.default;
exports.stackFilter = _stack_filter2.default;
exports.findMatches = _find_matches2.default;
exports.textIndexInStack = _text_index_in_stack2.default;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = reduceEmojis;

var _emojiData = __webpack_require__(1);

var _emoji_accessor = __webpack_require__(43);

var _emoji_accessor2 = _interopRequireDefault(_emoji_accessor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reduceEmojis(matches) {
    return matches.reduce(function (accumulator, keyword) {
        _emojiData.keywords[keyword].forEach(function (emoji) {
            var current = (0, _emoji_accessor2.default)(_emojiData.emojis[emoji]);

            if (!current) {
                return;
            }

            var catName = current.category;

            accumulator[catName] = accumulator[catName] || {};
            accumulator[catName][emoji] = keyword;
        });
        return accumulator;
    }, {});
}

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

exports.default = stackFilter;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function stackFilter(index, text, stack) {
    var matches = {},
        stackedItem = stack[index],
        prevMatches = stackedItem.matches;

    if (stackedItem.text === text) {
        return prevMatches;
    }

    for (var category in prevMatches) {
        matches[category] = {};
        for (var emoji in prevMatches[category]) {
            if (prevMatches[category][emoji].indexOf(text) > -1) {
                matches[category][emoji] = prevMatches[category][emoji];
            }
        }
        if (!(0, _keys2.default)(matches[category]).length) {
            delete matches[category];
        }
    }

    return matches;
}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = textIndexInStack;
function textIndexInStack(text, stack) {
    var textLength = text.length,
        stackLength = stack.length,
        stackLast = stackLength - 1;

    var bestMatch = -1;

    if (!stackLength) {
        return bestMatch;
    }

    if (stackLength >= textLength && stack[textLength - 1].text === text) {
        return textLength - 1;
    }

    if (text.indexOf(stack[stackLast].text) !== -1) {
        return stackLast;
    }

    for (var i = stackLast; i >= 0; i--) {
        var stackItem = stack[i];

        if (stackItem.text === text) {
            return i;
        }

        if (stackItem.text.indexOf(text.substr(0, stackItem.text.length)) > -1) {
            return bestMatch = i;
        }
    }

    return bestMatch;
}

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = findMatches;

var _constants = __webpack_require__(17);

function findMatches(text) {
    if (_constants.KEYWORDS_SINGLE.hasOwnProperty(text)) {
        return _constants.KEYWORDS_SINGLE[text];
    }

    return _constants.ALL_KEYWORDS.filter(function (keyword) {
        return keyword.indexOf(text) > -1;
    });
}

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(157);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./style.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".emoji-picker .icn-magnifier:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg id='Capa_1' xmlns='http://www.w3.org/2000/svg' width='310.4' height='310.4'%3E%3Cstyle%3E.st0%7Bfill:%239e9e9e%7D%3C/style%3E%3Cpath class='st0' d='M273.6 215c49.1-49.1 49.1-129 0-178.1-49.1-49.1-129-49.1-178.1 0-41.7 41.7-48 103.6-18.9 152 0 0 2.1 3.5-.7 6.3l-64.3 64.3c-12.8 12.8-15.8 30.7-4.5 42l2 2c11.3 11.3 29.2 8.3 42-4.5l64.1-64.1c3-3 6.4-.9 6.4-.9 48.4 28.9 110.3 22.6 152-19zm-154.9-23.3c-36.3-36.3-36.3-95.3 0-131.6s95.3-36.3 131.6 0 36.3 95.3 0 131.6-95.3 36.3-131.6 0z'/%3E%3Cpath class='st0' d='M126.8 118.4c-1.7 0-3.4-.3-5.1-1-6.6-2.8-9.7-10.4-6.9-17 17.6-41.6 65.7-61.1 107.3-43.5 6.6 2.8 9.7 10.4 6.9 17-2.8 6.6-10.4 9.7-17 6.9-28.4-12-61.2 1.3-73.2 29.7-2.2 4.9-7 7.9-12 7.9z'/%3E%3C/svg%3E\"); }\n\n.emoji-picker .search-bar {\n  height: 45px;\n  margin-top: 0;\n  padding: 10px;\n  position: relative;\n  z-index: 2;\n  left: 0;\n  box-sizing: border-box; }\n  .emoji-picker .search-bar input {\n    padding: 5px 5px 5px 35px;\n    margin: 0;\n    box-sizing: border-box;\n    color: #9e9e9e;\n    width: 100%;\n    outline: none;\n    border: 1px solid #eeeeee;\n    border-radius: 5px;\n    transition: border .2s; }\n    .emoji-picker .search-bar input::placeholder {\n      color: #e0e0e0; }\n    .emoji-picker .search-bar input:focus {\n      border: 1px solid #e0e0e0; }\n      .emoji-picker .search-bar input:focus + i:before {\n        opacity: 1; }\n  .emoji-picker .search-bar i:before {\n    content: '';\n    background-repeat: no-repeat;\n    background-image: url(\"data:image/svg+xml,%3Csvg id='Capa_1' xmlns='http://www.w3.org/2000/svg' width='310.4' height='310.4'%3E%3Cstyle%3E.st0%7Bfill:%239e9e9e%7D%3C/style%3E%3Cpath class='st0' d='M273.6 215c49.1-49.1 49.1-129 0-178.1-49.1-49.1-129-49.1-178.1 0-41.7 41.7-48 103.6-18.9 152 0 0 2.1 3.5-.7 6.3l-64.3 64.3c-12.8 12.8-15.8 30.7-4.5 42l2 2c11.3 11.3 29.2 8.3 42-4.5l64.1-64.1c3-3 6.4-.9 6.4-.9 48.4 28.9 110.3 22.6 152-19zm-154.9-23.3c-36.3-36.3-36.3-95.3 0-131.6s95.3-36.3 131.6 0 36.3 95.3 0 131.6-95.3 36.3-131.6 0z'/%3E%3Cpath class='st0' d='M126.8 118.4c-1.7 0-3.4-.3-5.1-1-6.6-2.8-9.7-10.4-6.9-17 17.6-41.6 65.7-61.1 107.3-43.5 6.6 2.8 9.7 10.4 6.9 17-2.8 6.6-10.4 9.7-17 6.9-28.4-12-61.2 1.3-73.2 29.7-2.2 4.9-7 7.9-12 7.9z'/%3E%3C/svg%3E\");\n    background-position: 50% 50%;\n    background-size: 15px 15px;\n    height: 15px;\n    width: 15px;\n    position: absolute;\n    left: 20px;\n    top: 15px;\n    display: block;\n    opacity: .3;\n    transition: opacity .2s; }\n", ""]);

// exports


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(159);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./style.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./style.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".emoji-picker .icn-magnifier:before {\n  background-image: url(\"data:image/svg+xml,%3Csvg id='Capa_1' xmlns='http://www.w3.org/2000/svg' width='310.4' height='310.4'%3E%3Cstyle%3E.st0%7Bfill:%239e9e9e%7D%3C/style%3E%3Cpath class='st0' d='M273.6 215c49.1-49.1 49.1-129 0-178.1-49.1-49.1-129-49.1-178.1 0-41.7 41.7-48 103.6-18.9 152 0 0 2.1 3.5-.7 6.3l-64.3 64.3c-12.8 12.8-15.8 30.7-4.5 42l2 2c11.3 11.3 29.2 8.3 42-4.5l64.1-64.1c3-3 6.4-.9 6.4-.9 48.4 28.9 110.3 22.6 152-19zm-154.9-23.3c-36.3-36.3-36.3-95.3 0-131.6s95.3-36.3 131.6 0 36.3 95.3 0 131.6-95.3 36.3-131.6 0z'/%3E%3Cpath class='st0' d='M126.8 118.4c-1.7 0-3.4-.3-5.1-1-6.6-2.8-9.7-10.4-6.9-17 17.6-41.6 65.7-61.1 107.3-43.5 6.6 2.8 9.7 10.4 6.9 17-2.8 6.6-10.4 9.7-17 6.9-28.4-12-61.2 1.3-73.2 29.7-2.2 4.9-7 7.9-12 7.9z'/%3E%3C/svg%3E\"); }\n\n.emoji-picker {\n  background-color: #ffffff;\n  width: 285px;\n  display: block;\n  position: relative;\n  padding: 0;\n  border: 1px solid #eeeeee;\n  border-radius: 3px;\n  overflow: hidden;\n  font-family: sans-serif; }\n  .emoji-picker .hidden {\n    display: none !important;\n    visibility: hidden !important;\n    padding: 0 !important;\n    margin: 0 !important; }\n  .emoji-picker a {\n    outline: none;\n    cursor: pointer; }\n  .emoji-picker ul {\n    list-style-type: none;\n    margin: 0;\n    padding: 0; }\n    .emoji-picker ul li {\n      display: inline-block; }\n  .emoji-picker .bar-wrapper {\n    position: relative; }\n", ""]);

// exports


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js